/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AccessFunctionality', 'model/AccessFunctionalityAddOn', 'model/AccessModule', 'model/AccessProfile', 'model/AccessType', 'model/AccountingData', 'model/AccountingDataPaginationSlice', 'model/AccountingDataPreviewReport', 'model/AgendaFlag', 'model/AgendaTheme', 'model/AgendaTimeReservation', 'model/AgendaTimeSerieEvent', 'model/AgendaTimeSerieRule', 'model/AgendaTimeSerieRuleReport', 'model/AnalysisCategory', 'model/AutomatedSourceGeneratedNews', 'model/BingCognitiveItem', 'model/BingCognitiveSearchData', 'model/BisnodeFinancialIndicatorValue', 'model/BusinessModel', 'model/BusinessModelArea', 'model/BusinessModelCanvasArea', 'model/BusinessModelCanvasItem', 'model/BusinessModelCanvasItemType', 'model/BusinessModelReport', 'model/BusinessReviewExcludedSection', 'model/BusinessReviewSchedule', 'model/BusinessReviewSectionType', 'model/BusinessReviewSession', 'model/BusinessReviewSessionPaginationSlice', 'model/BusinessReviewSessionStatus', 'model/BusinessReviewStatus', 'model/BusinessReviewStep', 'model/BusinessReviewStepElementSide', 'model/BusinessReviewTemplate', 'model/BusinessReviewTemplateReport', 'model/BusinessReviewUserSettings', 'model/BusinessSimulatorCashflowAccountReceivablesDistribution', 'model/BusinessSimulatorCashflowCapitalItem', 'model/BusinessSimulatorCashflowCapitalItemGroup', 'model/BusinessSimulatorCashflowCapitalItemValue', 'model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice', 'model/BusinessSimulatorCashflowSalesReceivablesDistribution', 'model/CashflowForecastDataReport', 'model/CashflowForecastIndicatorConnection', 'model/CashflowForecastIndicatorConnectionReport', 'model/CashflowForecastIndicatorDistributionEntry', 'model/CashflowForecastSettings', 'model/CashflowForecastSettingsReport', 'model/CategoryReport', 'model/Company', 'model/CompanyAccessFunctionalityAddOn', 'model/CompanyAccessModule', 'model/CompanyFunction', 'model/CompanyLegalEntity', 'model/CompanyLegalEntityType', 'model/CompanyResponsiblePerson', 'model/CompanyResponsiblePersonConnection', 'model/CompanySubscriptionReport', 'model/CompanySubscriptionServiceLevel', 'model/CompanyTemplateType', 'model/CompanyUserServiceLevelBase', 'model/CompanyVirtualTeam', 'model/CompanyVirtualTeamMember', 'model/ContentWatchSettings', 'model/ContentWatchSettingsPaginationSlice', 'model/CorporateStructureFilter', 'model/CorporateStructureLink', 'model/CorporateStructureLinkReport', 'model/CorporateStructureSortMode', 'model/Country', 'model/Customer', 'model/DashboardGroup', 'model/DashboardGroupLightReport', 'model/DashboardPage', 'model/DashboardPageBlock', 'model/DashboardPageBlockBubbleSettings', 'model/DashboardPageBlockCartesianAxis', 'model/DashboardPageBlockCartesianSerie', 'model/DashboardPageBlockCartesianSerieGrouping', 'model/DashboardPageBlockCartesianSerieMilestone', 'model/DashboardPageBlockCartesianSerieReport', 'model/DashboardPageBlockCartesianSerieType', 'model/DashboardPageBlockComment', 'model/DashboardPageBlockCommentPaginationSlice', 'model/DashboardPageBlockComparisonBarSerie', 'model/DashboardPageBlockComparisonBarSerieType', 'model/DashboardPageBlockComparisonColumnSerie', 'model/DashboardPageBlockComparisonColumnSerieType', 'model/DashboardPageBlockCustomTableColumn', 'model/DashboardPageBlockCustomTableColumnDefaultFilter', 'model/DashboardPageBlockCustomTableGraphSerieType', 'model/DashboardPageBlockCustomTableQuery', 'model/DashboardPageBlockExternalSettings', 'model/DashboardPageBlockGoogleSheetSettings', 'model/DashboardPageBlockImage', 'model/DashboardPageBlockLightReport', 'model/DashboardPageBlockMarketOverviewSettings', 'model/DashboardPageBlockMilestone', 'model/DashboardPageBlockNewsfeed', 'model/DashboardPageBlockNumberSerie', 'model/DashboardPageBlockPieSerie', 'model/DashboardPageBlockPollSettings', 'model/DashboardPageBlockPowerBIEmbed', 'model/DashboardPageBlockReport', 'model/DashboardPageBlockReportNestedPaginationSlice', 'model/DashboardPageBlockReportPaginationSlice', 'model/DashboardPageBlockSerieOrder', 'model/DashboardPageBlockSolidGaugeSerie', 'model/DashboardPageBlockStrategicAction', 'model/DashboardPageBlockStrategicActionViewType', 'model/DashboardPageBlockStrategy', 'model/DashboardPageBlockTableComparisonColumn', 'model/DashboardPageBlockTableComparisonRow', 'model/DashboardPageBlockTableDataColumn', 'model/DashboardPageBlockTableEmptyRow', 'model/DashboardPageBlockTableRollingComparison', 'model/DashboardPageBlockTableSerieRow', 'model/DashboardPageBlockTableSerieRowExpandedIndicator', 'model/DashboardPageBlockTableSerieRowReport', 'model/DashboardPageBlockTableSumColumn', 'model/DashboardPageBlockTemplate', 'model/DashboardPageBlockType', 'model/DashboardPageExportSettings', 'model/DashboardPageHomeSettings', 'model/DashboardPageLightReport', 'model/DashboardPageReport', 'model/DashboardPageTemplate', 'model/DashboardPageUserAccess', 'model/DashboardShareBatchBlock', 'model/DashboardShareBatchReport', 'model/Decision', 'model/DecisionPoll', 'model/DecisionPollReplyOptionTypeOption', 'model/DecisionPollReplyOptionTypeReport', 'model/DecisionPollReport', 'model/DecisionPollRespondent', 'model/DecisionPollType', 'model/DecisionReport', 'model/DecisionTopicComment', 'model/DecisionTopicCommentPaginationSlice', 'model/DecisionTopicPhase', 'model/DecisionTopicReport', 'model/DecisionTopicSuggestionSearchItem', 'model/DecisionTopicType', 'model/DecisionTrackingType', 'model/DialogDistributionChannel', 'model/DialogFlowLogicGateMatchRule', 'model/DialogFlowLogicGateValueSource', 'model/DialogFlowMultiOptionDataSource', 'model/DialogFlowSession', 'model/DialogFlowTemplate', 'model/DialogFlowTemplateMessage', 'model/DialogFlowTemplateMessageConversionRule', 'model/DialogFlowTemplateMessageOption', 'model/DialogFlowTemplateMessageReport', 'model/DialogFlowTemplateMessageType', 'model/DialogFlowTemplateReport', 'model/DialogScheduleBatch', 'model/DialogScheduleBatchReport', 'model/DialogScheduleFlow', 'model/DialogScheduleRhytm', 'model/DialogScheduleSettings', 'model/DialogScheduleSettingsReport', 'model/DialogScheduleUser', 'model/ERPAccountList', 'model/ERPAdminCostDivisionRule', 'model/ERPAdminCostDivisionRuleFixedRule', 'model/ERPAdminCostDivisionRuleFromAccount', 'model/ERPAdminCostDivisionRuleLevel', 'model/ERPAdminCostDivisionRuleReport', 'model/ERPAdminCostDivisionRuleSourceFilter', 'model/ERPAdminCostDivisionType', 'model/ERPCorporateAccount', 'model/ERPDimensionMapping', 'model/ERPDimensionSyncSetting', 'model/ERPDimensionSyncType', 'model/ERPFinancialAdvisorySettings', 'model/ERPFinancialCalculationError', 'model/ERPFivaldiIntegrationSettings', 'model/ERPNetvisorIntegrationLockPeriod', 'model/ERPNetvisorIntegrationSettings', 'model/ERPProcountorIntegrationSettings', 'model/ERPSyncCustomer', 'model/ERPSyncCustomerMonthData', 'model/ERPSyncCustomerReport', 'model/ERPSyncCustomerReportERPSyncItemPaginationSlice', 'model/ERPSyncProduct', 'model/ERPSyncProductMonthData', 'model/ERPSyncProductReport', 'model/ERPSyncProductReportERPSyncItemPaginationSlice', 'model/EntityChange', 'model/ExternalSourceLightSpreadsheet', 'model/ExternalSourceLightSpreadsheetSheet', 'model/FileTransferHelperEntity', 'model/FinancialBatchPreviewReport', 'model/FinancialIndicator', 'model/FinancialIndicatorDataFilter', 'model/FinancialIndicatorDataReport', 'model/FinancialIndicatorValueBase', 'model/FinancialsAndDecisionMakers', 'model/FinancialsFiscalReport', 'model/ForecastModel', 'model/ForecastModelAggregationLevel', 'model/ForecastModelAggregationLevelReport', 'model/ForecastModelAggregationReport', 'model/ForecastModelDataEntry', 'model/ForecastModelDataEntryCustomIndicator', 'model/ForecastModelDataEntryStatus', 'model/ForecastModelDataEntryType', 'model/ForecastModelRecordData', 'model/ForecastModelRecordDataActualSplitRange', 'model/ForecastModelRecordDataFile', 'model/ForecastModelRecordDataFileReport', 'model/ForecastModelRecordDataImportPeriodType', 'model/ForecastModelRecordDataReport', 'model/ForecastModelRecordDataTransferLog', 'model/ForecastModelReport', 'model/ForesightScenario', 'model/ForesightScenarioBaselineCalculation', 'model/ForesightScenarioElement', 'model/ForesightScenarioElementReport', 'model/ForesightScenarioElementType', 'model/ForesightScenarioFactor', 'model/ForesightScenarioLevel', 'model/ForesightScenarioLevelReport', 'model/ForesightScenarioNotificationRecipient', 'model/ForesightScenarioReport', 'model/FrontendErrorReport', 'model/GeneralSettings', 'model/GeoArea', 'model/GoalMetric', 'model/GoalMetricReport', 'model/GoalMetricReportPaginationSlice', 'model/GoalMetricValueSource', 'model/GoalMetricValueType', 'model/GoogleAnalyticsAccount', 'model/GoogleAnalyticsProfile', 'model/GoogleAnalyticsProperty', 'model/GoogleAnalyticsSettings', 'model/GoogleOAuthUser', 'model/GroupCount', 'model/HeaderColumn', 'model/ImportAccountingActualsFileRequest', 'model/InputValidationFeedback', 'model/Insight', 'model/InsightCompanyData', 'model/InsightDefaultExcludedDomain', 'model/InsightFilter', 'model/InsightImage', 'model/InsightLinkReport', 'model/InsightReactionLink', 'model/InsightReactionType', 'model/InsightReport', 'model/InsightTaggedUser', 'model/InsightType', 'model/IntegrationDataMappingDimension', 'model/IntegrationDataMappingMatchRule', 'model/IntegrationDataMappingRule', 'model/IntegrationDataMappingSource', 'model/IntegrationFinancialUploadBatch', 'model/IntegrationFinancialUploadBatchExcelFile', 'model/IntegrationFinancialUploadBatchFileReport', 'model/IntegrationPipedriveSettings', 'model/IntegrationPipedriveSettingsPipeline', 'model/IntegrationPipedriveSettingsPipelineReport', 'model/IntegrationPipedriveSettingsPipelineReportPaginationSlice', 'model/IntegrationPipedriveSettingsPipelineStage', 'model/IntegrationPipedriveSettingsPipelineStagePaginationSlice', 'model/IntegrationPipedriveSettingsReport', 'model/IntegrationSettingsNetvisorSyncDefaultHandleType', 'model/IntegrationSource', 'model/IntegrationSourceCompanyStatus', 'model/InvoicingDataLightReport', 'model/InvoicingDataLightReportPaginationSlice', 'model/InvoicingDataPreviewReport', 'model/InvoicingDataReceivableReport', 'model/InvoicingDataReceivableReportPaginationSlice', 'model/LSDStrategyProgressReport', 'model/LastFinancialPeriodType', 'model/LemonsoftIntegrationSettings', 'model/LivingStrategyDashboardReport', 'model/MapDataReport', 'model/MapRegionDataReport', 'model/Market', 'model/MarketFeedBingCognitive', 'model/MarketFreeNode', 'model/MarketRSSWatchSetting', 'model/MarketRSSWatchSettingFeedData', 'model/MarketRSSWatchSettingReport', 'model/MarketScopeType', 'model/MarketSearchTemplateQuery', 'model/MarketSearchTemplateReport', 'model/MasterSearchReport', 'model/MasterSearchReportItem', 'model/MasterSearchUserInput', 'model/Meeting', 'model/MeetingAdministrator', 'model/MeetingInvitationPeriodType', 'model/MeetingMinutesContentType', 'model/MeetingMinutesReport', 'model/MeetingMinutesSignature', 'model/MeetingParticipant', 'model/MeetingReport', 'model/MeetingSection', 'model/MeetingSectionContentType', 'model/MeetingSectionReport', 'model/MeetingSectionReportPaginationSlice', 'model/MeetingSectionTextTopic', 'model/MeetingSectionTopic', 'model/MeetingSectionTopicAttachment', 'model/MeetingSectionTopicComment', 'model/MeetingSectionTopicCommentPaginationSlice', 'model/MeetingSectionTopicLink', 'model/MeetingSectionTopicReport', 'model/MeetingStatus', 'model/MeetingTemplate', 'model/MeetingTemplateAdministrator', 'model/MeetingTemplateParticipant', 'model/MeetingTemplateReport', 'model/MeetingTemplateSection', 'model/MeetingTemplateSectionReport', 'model/MeetingTemplateSectionTextTopic', 'model/MeetingTemplateSectionTopic', 'model/MeetingTemplateSectionTopicLink', 'model/MeetingTemplateSectionTopicReport', 'model/MicrosoftTeamsBotLinkedConversation', 'model/MobileClientToken', 'model/NewsEntry', 'model/NewsEntryAutomatedSource', 'model/NewsEntryCategory', 'model/NewsEntryComment', 'model/NewsEntryCommentPaginationSlice', 'model/NewsEntryCommentReport', 'model/NewsEntryCommentReportPaginationSlice', 'model/NewsEntryContributor', 'model/NewsEntryContributorPaginationSlice', 'model/NewsEntryEntryStatus', 'model/NewsEntryFilter', 'model/NewsEntryFullReport', 'model/NewsEntryFullReportNewsEntryReportPaginationSlice', 'model/NewsEntryInsightLink', 'model/NewsEntryLightReport', 'model/NewsEntryLightReportNewsEntryReportPaginationSlice', 'model/NewsEntrySourceCategory', 'model/NewsEntrySourceReport', 'model/NewsEntrySourceReportPaginationSlice', 'model/NewsEntrySourceType', 'model/NewsEntryUserStatus', 'model/NotificationFilter', 'model/NotificationGroupCount', 'model/NotificationReport', 'model/NotificationReportPaginationSlice', 'model/NotificationSendingTimeType', 'model/NotificationType', 'model/OpencorporatesOrganization', 'model/OpencorporatesOrganizationPaginationSlice', 'model/Organization', 'model/OrganizationClassificationType', 'model/OrganizationIndexSearchResultExtended', 'model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport', 'model/OrganizationItemLight', 'model/OrganizationItemLightPaginationSlice', 'model/OrganizationPaginationSlice', 'model/PartnerClientCompany', 'model/PartnerClientCompanyEvent', 'model/PartnerClientCompanyEventType', 'model/PartnerClientCompanyReport', 'model/PartnerClientCompanyType', 'model/PartnerCompany', 'model/PartnerSupportLevel', 'model/PaymentDisturbance', 'model/PerformanceIndicator', 'model/PerformanceIndicatorAvailabilityReport', 'model/PerformanceIndicatorCalculationRange', 'model/PerformanceIndicatorCollectionType', 'model/PerformanceIndicatorComparisonCalculation', 'model/PerformanceIndicatorComparisonTarget', 'model/PerformanceIndicatorConversation', 'model/PerformanceIndicatorConversationReport', 'model/PerformanceIndicatorDataBase', 'model/PerformanceIndicatorDataCopySettings', 'model/PerformanceIndicatorDataExtrapolationSettings', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorDataReport', 'model/PerformanceIndicatorDateRange', 'model/PerformanceIndicatorDayData', 'model/PerformanceIndicatorDimension', 'model/PerformanceIndicatorDrillData', 'model/PerformanceIndicatorFormula', 'model/PerformanceIndicatorFormulaElementType', 'model/PerformanceIndicatorGroupReport', 'model/PerformanceIndicatorMonthData', 'model/PerformanceIndicatorPeriodType', 'model/PerformanceIndicatorPointCalculation', 'model/PerformanceIndicatorPollBatch', 'model/PerformanceIndicatorPollBatchPaginationSlice', 'model/PerformanceIndicatorPollBatchUserReport', 'model/PerformanceIndicatorPollBatchUserReportPaginationSlice', 'model/PerformanceIndicatorPollGeneralResponseReport', 'model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice', 'model/PerformanceIndicatorPollSettings', 'model/PerformanceIndicatorPollSettingsLightReport', 'model/PerformanceIndicatorPollStatus', 'model/PerformanceIndicatorPollValueAggregationType', 'model/PerformanceIndicatorPollValueType', 'model/PerformanceIndicatorQuarterData', 'model/PerformanceIndicatorRelativePeriod', 'model/PerformanceIndicatorReport', 'model/PerformanceIndicatorSystemType', 'model/PerformanceIndicatorValueDependencyRule', 'model/PerformanceIndicatorValueSource', 'model/PerformanceIndicatorWeekData', 'model/PerformanceIndicatorYearData', 'model/PerformanceManagementAlert', 'model/PerformanceManagementAlertActivityStatus', 'model/PerformanceManagementAlertDashboardBlock', 'model/PerformanceManagementAlertDashboardBlockComment', 'model/PerformanceManagementAlertDashboardBlockReport', 'model/PerformanceManagementAlertDeliveryChannel', 'model/PerformanceManagementAlertEmailTitleType', 'model/PerformanceManagementAlertIndicator', 'model/PerformanceManagementAlertRecipient', 'model/PerformanceManagementAlertReport', 'model/PerformanceManagementAlertReportNestedPaginationSlice', 'model/PerformanceManagementAlertReviewSection', 'model/PerformanceManagementAlertReviewSectionComment', 'model/PerformanceManagementAlertReviewSectionReport', 'model/PerformanceManagementAlertScore', 'model/PerformanceManagementAlertTriggerIndicator', 'model/PerformanceManagementAlertTriggerType', 'model/PerformancePerspective', 'model/PerformancePerspectiveGroup', 'model/PersonalTopic', 'model/PollReport', 'model/PollReportQuestion', 'model/PollReportQuestionMatrixAxis', 'model/PollReportQuestionMultipleNumericValue', 'model/PollReportQuestionScaleValue', 'model/PollResponse', 'model/PollSettingsScale', 'model/PowerBIEmbedToken', 'model/PowerBIItem', 'model/PowerBIToken', 'model/PowerBIWorkspace', 'model/Product', 'model/PublicExternalLink', 'model/QuickStartReport', 'model/QuickStartStep', 'model/QuickStartStepCategoryReport', 'model/RawDataColumn', 'model/RawDataMapping', 'model/RawDataMappingColumn', 'model/RawDataMappingColumnDataType', 'model/RawDataMappingReport', 'model/RawDataMappingRule', 'model/RawDataRowColumn', 'model/RawDataRowError', 'model/RawDataRowReport', 'model/RawDataRowReportPaginationSlice', 'model/RawDataSource', 'model/RawDataSourceReport', 'model/RawDataSourceStatus', 'model/RelativeDateType', 'model/Row', 'model/SIEUploadQueue', 'model/SWOTArea', 'model/SWOTInbox', 'model/SWOTSession', 'model/SWOTSessionParticipant', 'model/SWOTSessionReport', 'model/SWOTTopic', 'model/SWOTTopicComment', 'model/SWOTTopicCommentPaginationSlice', 'model/SWOTTopicReport', 'model/SWOTTopicVote', 'model/SWOTTopicVoteBatch', 'model/SWOTTopicVoteBatchReport', 'model/SWOTTopicVoteBatchReportPaginationSlice', 'model/SessionInformation', 'model/SeveraIntegrationSettingsReport', 'model/SheetConfiguration', 'model/SheetConfigurationForecastDownloadFromSheetRule', 'model/SheetConfigurationForecastUploadToSheetRule', 'model/SheetExcelConfiguration', 'model/SheetExcelGenerationIndicatorDepthRule', 'model/SheetExcelGenerationSettings', 'model/SheetExcelGenerationValueWriteRule', 'model/SheetForecast', 'model/SheetForecastAggregatedBudgetReport', 'model/SheetForecastFile', 'model/SheetForecastFileReport', 'model/SheetForecastFileStatus', 'model/SheetForecastFileType', 'model/SheetForecastFileUserAccess', 'model/SheetForecastInputMethod', 'model/SheetForecastNotificationRecipient', 'model/SheetForecastNotificationReport', 'model/SheetForecastRelatedSheet', 'model/SheetForecastReport', 'model/SheetGenerationSettings', 'model/SheetGenerationSettingsIndicator', 'model/SheetGoogleConfiguration', 'model/SheetGoogleTemplateCopiedRange', 'model/SheetGoogleTemplateCopiedRangeSettings', 'model/SheetGoogleTemplateCopiedRangeValueType', 'model/SpecialMenuItem', 'model/Stakeholder', 'model/StakeholderBenchmark', 'model/StakeholderBenchmarkCustomItem', 'model/StakeholderBenchmarkCustomItemPaginationSlice', 'model/StakeholderBenchmarkDimension', 'model/StakeholderBenchmarkDimensionReport', 'model/StakeholderBenchmarkDimensionReportPaginationSlice', 'model/StakeholderBenchmarkDimensionValue', 'model/StakeholderBenchmarkDimensionValuePaginationSlice', 'model/StakeholderBenchmarkReport', 'model/StakeholderBenchmarkTemplate', 'model/StakeholderComment', 'model/StakeholderCommentPaginationSlice', 'model/StakeholderMarketPositioningMapView', 'model/StakeholderMarketPositioningMapViewCustomItem', 'model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice', 'model/StakeholderMarketPositioningMapViewPosition', 'model/StakeholderMarketPositioningMapViewPositionPaginationSlice', 'model/StakeholderMarketPositioningMapViewReport', 'model/StakeholderMarketPositioningMapViewTemplate', 'model/StakeholderNewsEntryAutomatedSource', 'model/StakeholderNewsWatchFilterLevel', 'model/StakeholderReport', 'model/StakeholderReportPaginationSlice', 'model/StakeholderType', 'model/StakeholderTypeReport', 'model/StrategicGoal', 'model/StrategicGoalCriticalSuccessFactor', 'model/StrategicGoalCriticalSuccessFactorReport', 'model/StrategicGoalMilestone', 'model/StrategicGoalMilestoneAchievability', 'model/StrategicGoalMilestoneComment', 'model/StrategicGoalMilestoneCommentPaginationSlice', 'model/StrategicGoalMilestoneFinalStatus', 'model/StrategicGoalMilestoneReport', 'model/StrategicGoalMilestoneSecondaryOwner', 'model/StrategicGoalMilestoneSecondaryStatusUpdate', 'model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice', 'model/StrategicGoalMilestoneStatus', 'model/StrategicGoalMilestoneStatusUpdate', 'model/StrategicGoalMilestoneStatusUpdatePaginationSlice', 'model/StrategicGoalMilestoneTeamLink', 'model/StrategicGoalReport', 'model/StrategicProgram', 'model/StrategicProgramComment', 'model/StrategicProgramCommentPaginationSlice', 'model/StrategicProgramConnection', 'model/StrategicProgramFinalStatus', 'model/StrategicProgramReport', 'model/StrategicProgramRiskLevel', 'model/StrategicProgramSecondaryOwner', 'model/StrategicProgramStatus', 'model/StrategicProgramStatusUpdate', 'model/StrategicProgramStatusUpdateRecipient', 'model/StrategicProgramStatusUpdateRecipientPaginationSlice', 'model/StrategicProgramStatusUpdateReport', 'model/StrategicProgramStatusUpdateReportPaginationSlice', 'model/StrategicProgramUpdateFrequency', 'model/StrategyBusinessReviewExportSettings', 'model/StrategyDescription', 'model/StrategyDescriptionAdministrator', 'model/StrategyDescriptionExternalLink', 'model/StrategyDescriptionParticipator', 'model/StrategyDescriptionPerformanceIndicator', 'model/StrategyDescriptionPerformanceIndicatorPaginationSlice', 'model/StrategyDescriptionReport', 'model/StrategyDescriptionStatus', 'model/StrategyElementType', 'model/StrategyExecutionCustomEntity', 'model/StrategyExecutionCustomEntityData', 'model/StrategyExecutionCustomField', 'model/StrategyExecutionCustomFieldLink', 'model/StrategyExecutionCustomFieldOption', 'model/StrategyExecutionCustomFieldReport', 'model/StrategyExecutionCustomFieldType', 'model/StrategyExecutionExportSettings', 'model/StrategyExecutionSecondaryStatusUpdateType', 'model/StrategyExecutionType', 'model/StrategyExportItemSettings', 'model/StrategyFreeNode', 'model/StrategyFreeNodeReport', 'model/StrategyHealthReport', 'model/StrategyNamingType', 'model/StrategyPageBlock', 'model/StrategyPageBlockType', 'model/StrategyPageMemoBlock', 'model/StrategyProcess', 'model/StrategyProcessPhase', 'model/StrategyProcessPhaseContent', 'model/StrategyProcessPhaseReport', 'model/StrategyProcessReport', 'model/StrategyProcessSubtheme', 'model/StrategyProcessSubthemeLink', 'model/StrategyProcessSubthemeReport', 'model/StrategyProcessSubthemeType', 'model/StrategyProcessTheme', 'model/StrategyProcessThemeReport', 'model/StrategyProgressCalculationMethod', 'model/StrategyProgressCalculationSource', 'model/StrategyPublishingLevel', 'model/StrategyPublishingType', 'model/StrategySavedView', 'model/StrategySelection', 'model/StrategySelectionReport', 'model/StrategyTaxonomy', 'model/SystemLanguage', 'model/SystemUserRole', 'model/SystemUserType', 'model/TrackingLevel', 'model/TrackingLevel1Item', 'model/TrackingLevel2Item', 'model/TrackingLevel3Item', 'model/TrackingLevel4Item', 'model/TrackingLevelItemBase', 'model/TranslationResource', 'model/TrendCategory', 'model/TrendScope', 'model/TrendSettings', 'model/TrendTopic', 'model/TrendTopicComment', 'model/TrendTopicCommentPaginationSlice', 'model/TrendTopicReport', 'model/TrendTopicType', 'model/User', 'model/UserActivityItem', 'model/UserActivityReport', 'model/UserCompanyAccess', 'model/UserCompanyAccessReport', 'model/UserCompanyFunctionalityAccess', 'model/UserDataVisibilityFunction', 'model/UserDataVisibilityLegalEntity', 'model/UserDataVisibilityProduct', 'model/UserDataVisibilitySettings', 'model/UserFeedbackReport', 'model/UserFunctionalityAccessReport', 'model/UserInterfaceText', 'model/UserInterfaceTranslationLanguage', 'model/UserListDataReport', 'model/UserLocal', 'model/UserNotificationEventSource', 'model/UserNotificationUserSettings', 'model/UserPartnerAccessReport', 'model/UserRole', 'model/UserRoleBillingUserType', 'model/UserRoleProduct', 'model/UserSyncExcelSettings', 'model/UserTrackingLevelLink', 'model/VATPeriodType', 'model/Workshop', 'model/WorkshopBackgroundImage', 'model/WorkshopCanvasItem', 'model/WorkshopCanvasItemType', 'model/WorkshopCloneSettings', 'model/WorkshopExternalContentType', 'model/WorkshopItem', 'model/WorkshopItemCategory', 'model/WorkshopItemCategoryConnection', 'model/WorkshopItemHistory', 'model/WorkshopItemRating', 'model/WorkshopItemRatingHistory', 'model/WorkshopParticipant', 'model/WorkshopParticipantRole', 'model/WorkshopPhase', 'model/WorkshopPhaseComparisonAxis', 'model/WorkshopPhaseComparisonDimension', 'model/WorkshopPhaseContentCreationRule', 'model/WorkshopPhaseContentRow', 'model/WorkshopPhaseContentRowLayout', 'model/WorkshopPhaseContentRowReport', 'model/WorkshopPhaseGridBlock', 'model/WorkshopPhaseParticipantRole', 'model/WorkshopPhaseReport', 'model/WorkshopPrioritizationVotingType', 'model/WorkshopQuestionnaireFilter', 'model/WorkshopQuestionnaireOption', 'model/WorkshopQuestionnaireQuestion', 'model/WorkshopQuestionnaireQuestionReport', 'model/WorkshopQuestionnaireQuestionType', 'model/WorkshopQuestionnaireResponse', 'model/WorkshopRatingPhaseCategoryWeight', 'model/WorkshopRatingPhaseSource', 'model/WorkshopRatingPhaseSourceReport', 'model/WorkshopRatingPhaseWeightedLevel', 'model/WorkshopReport', 'model/WorkshopResultPhaseSource', 'model/WorkshopResultPresentationType', 'model/WorkshopStrategyImportSettings', 'model/WorkshopVersionHistoryChangeType', 'model/WorkshopVideoCall', 'model/WorkshopWidget', 'model/WorkshopWidgetIdeaGenerationTheme', 'model/WorkshopWidgetIdeaGenerationThemeAnswer', 'model/WorkshopWidgetParticipantStatus', 'model/WorkshopWidgetReport', 'model/WorkshopWidgetStatus', 'model/WorkshopWidgetType', 'model/WorkspaceMindmap', 'model/WorkspaceMindmapNode', 'model/WorkspaceMindmapNodePaginationSlice', 'model/WorkspaceMindmapNodeType', 'model/WorkspaceMindmapReport', 'api/AccessFunctionalityApi', 'api/AccessFunctionalityAddOnApi', 'api/AccessModuleApi', 'api/AccessProfileApi', 'api/AccessTypeApi', 'api/AccountingDataApi', 'api/AccountingDataPreviewReportApi', 'api/AgendaFlagApi', 'api/AgendaThemeApi', 'api/AgendaTimeReservationApi', 'api/AgendaTimeSerieEventApi', 'api/AgendaTimeSerieRuleApi', 'api/AnalysisCategoryApi', 'api/BisnodeFinancialIndicatorValueApi', 'api/BusinessModelApi', 'api/BusinessModelAreaApi', 'api/BusinessModelCanvasAreaApi', 'api/BusinessModelCanvasItemApi', 'api/BusinessModelCanvasItemTypeApi', 'api/BusinessReviewExcludedSectionApi', 'api/BusinessReviewScheduleApi', 'api/BusinessReviewSectionTypeApi', 'api/BusinessReviewSessionApi', 'api/BusinessReviewSessionStatusApi', 'api/BusinessReviewStatusApi', 'api/BusinessReviewStepApi', 'api/BusinessReviewStepElementSideApi', 'api/BusinessReviewTemplateApi', 'api/BusinessReviewUserSettingsApi', 'api/BusinessSimulatorCashflowAccountReceivablesDistributionApi', 'api/BusinessSimulatorCashflowCapitalItemApi', 'api/BusinessSimulatorCashflowCapitalItemGroupApi', 'api/BusinessSimulatorCashflowCapitalItemValueApi', 'api/BusinessSimulatorCashflowSalesReceivablesDistributionApi', 'api/CashflowForecastIndicatorConnectionApi', 'api/CashflowForecastIndicatorDistributionEntryApi', 'api/CashflowForecastSettingsApi', 'api/CategoryApi', 'api/CompanyApi', 'api/CompanyAccessFunctionalityAddOnApi', 'api/CompanyAccessModuleApi', 'api/CompanyFunctionApi', 'api/CompanyLegalEntityApi', 'api/CompanyLegalEntityTypeApi', 'api/CompanySubscriptionReportApi', 'api/CompanyTemplateTypeApi', 'api/CompanyVirtualTeamApi', 'api/CompanyVirtualTeamMemberApi', 'api/CompetitorApi', 'api/ContentWatchSettingsApi', 'api/CorporateStructureFilterApi', 'api/CorporateStructureLinkApi', 'api/CorporateStructureLinkReportApi', 'api/CorporateStructureSortModeApi', 'api/CountryApi', 'api/CustomerApi', 'api/DashboardGroupApi', 'api/DashboardPageApi', 'api/DashboardPageBlockApi', 'api/DashboardPageBlockBubbleSettingsApi', 'api/DashboardPageBlockCartesianAxisApi', 'api/DashboardPageBlockCartesianSerieApi', 'api/DashboardPageBlockCartesianSerieGroupingApi', 'api/DashboardPageBlockCartesianSerieMilestoneApi', 'api/DashboardPageBlockCartesianSerieTypeApi', 'api/DashboardPageBlockCommentApi', 'api/DashboardPageBlockComparisonBarSerieApi', 'api/DashboardPageBlockComparisonBarSerieTypeApi', 'api/DashboardPageBlockComparisonColumnSerieApi', 'api/DashboardPageBlockComparisonColumnSerieTypeApi', 'api/DashboardPageBlockCustomTableColumnApi', 'api/DashboardPageBlockCustomTableColumnDefaultFilterApi', 'api/DashboardPageBlockCustomTableGraphSerieTypeApi', 'api/DashboardPageBlockCustomTableQueryApi', 'api/DashboardPageBlockExternalSettingsApi', 'api/DashboardPageBlockGoogleSheetSettingsApi', 'api/DashboardPageBlockMarketOverviewSettingsApi', 'api/DashboardPageBlockMilestoneApi', 'api/DashboardPageBlockNewsfeedApi', 'api/DashboardPageBlockNumberSerieApi', 'api/DashboardPageBlockPieSerieApi', 'api/DashboardPageBlockPollSettingsApi', 'api/DashboardPageBlockPowerBIEmbedApi', 'api/DashboardPageBlockSerieOrderApi', 'api/DashboardPageBlockSolidGaugeSerieApi', 'api/DashboardPageBlockStrategicActionApi', 'api/DashboardPageBlockStrategicActionViewTypeApi', 'api/DashboardPageBlockStrategyApi', 'api/DashboardPageBlockTableComparisonColumnApi', 'api/DashboardPageBlockTableComparisonRowApi', 'api/DashboardPageBlockTableDataColumnApi', 'api/DashboardPageBlockTableEmptyRowApi', 'api/DashboardPageBlockTableRollingComparisonApi', 'api/DashboardPageBlockTableSerieRowApi', 'api/DashboardPageBlockTableSerieRowExpandedIndicatorApi', 'api/DashboardPageBlockTableSumColumnApi', 'api/DashboardPageBlockTemplateApi', 'api/DashboardPageBlockTypeApi', 'api/DashboardPageHomeSettingsApi', 'api/DashboardPageTemplateApi', 'api/DashboardPageUserAccessApi', 'api/DashboardShareBatchApi', 'api/DecisionApi', 'api/DecisionPollApi', 'api/DecisionPollReplyOptionTypeApi', 'api/DecisionPollRespondentApi', 'api/DecisionPollTypeApi', 'api/DecisionTopicApi', 'api/DecisionTopicCommentApi', 'api/DecisionTopicPhaseApi', 'api/DecisionTopicTypeApi', 'api/DecisionTrackingTypeApi', 'api/DialogDistributionChannelApi', 'api/DialogFlowLogicGateMatchRuleApi', 'api/DialogFlowLogicGateValueSourceApi', 'api/DialogFlowMultiOptionDataSourceApi', 'api/DialogFlowSessionApi', 'api/DialogFlowTemplateApi', 'api/DialogFlowTemplateMessageApi', 'api/DialogFlowTemplateMessageConversionRuleApi', 'api/DialogFlowTemplateMessageOptionApi', 'api/DialogFlowTemplateMessageTypeApi', 'api/DialogScheduleBatchApi', 'api/DialogScheduleFlowApi', 'api/DialogScheduleRhytmApi', 'api/DialogScheduleSettingsApi', 'api/DialogScheduleUserApi', 'api/ERPAccountListApi', 'api/ERPAdminCostDivisionRuleApi', 'api/ERPAdminCostDivisionRuleFixedRuleApi', 'api/ERPAdminCostDivisionRuleFromAccountApi', 'api/ERPAdminCostDivisionRuleLevelApi', 'api/ERPAdminCostDivisionRuleSourceFilterApi', 'api/ERPAdminCostDivisionTypeApi', 'api/ERPCorporateAccountApi', 'api/ERPDimensionMappingApi', 'api/ERPDimensionSyncSettingApi', 'api/ERPDimensionSyncTypeApi', 'api/ERPFinancialAdvisorySettingsApi', 'api/ERPFinancialCalculationErrorApi', 'api/ERPFivaldiIntegrationSettingsApi', 'api/ERPNetvisorIntegrationLockPeriodApi', 'api/ERPNetvisorIntegrationSettingsApi', 'api/ERPProcountorIntegrationSettingsApi', 'api/ERPSyncCustomerApi', 'api/ERPSyncProductApi', 'api/EntityChangeApi', 'api/FinancialIndicatorApi', 'api/ForecastModelApi', 'api/ForecastModelAggregationLevelApi', 'api/ForecastModelDataEntryApi', 'api/ForecastModelDataEntryCustomIndicatorApi', 'api/ForecastModelDataEntryStatusApi', 'api/ForecastModelDataEntryTypeApi', 'api/ForecastModelRecordDataApi', 'api/ForecastModelRecordDataActualSplitRangeApi', 'api/ForecastModelRecordDataFileApi', 'api/ForecastModelRecordDataImportPeriodTypeApi', 'api/ForesightScenarioApi', 'api/ForesightScenarioBaselineCalculationApi', 'api/ForesightScenarioElementApi', 'api/ForesightScenarioElementTypeApi', 'api/ForesightScenarioFactorApi', 'api/ForesightScenarioLevelApi', 'api/ForesightScenarioNotificationRecipientApi', 'api/FrontendErrorReportApi', 'api/GeneralSettingsApi', 'api/GeoAreaApi', 'api/GoalMetricApi', 'api/GoalMetricValueSourceApi', 'api/GoalMetricValueTypeApi', 'api/GoogleAnalyticsSettingsApi', 'api/GoogleOAuthUserApi', 'api/InsightApi', 'api/InsightDefaultExcludedDomainApi', 'api/InsightImageApi', 'api/InsightReactionLinkApi', 'api/InsightReactionTypeApi', 'api/InsightTypeApi', 'api/IntegrationDataMappingDimensionApi', 'api/IntegrationDataMappingMatchRuleApi', 'api/IntegrationDataMappingRuleApi', 'api/IntegrationDataMappingSourceApi', 'api/IntegrationFinancialUploadBatchApi', 'api/IntegrationPipedriveSettingsApi', 'api/IntegrationPipedriveSettingsPipelineApi', 'api/IntegrationPipedriveSettingsPipelineStageApi', 'api/IntegrationSettingsNetvisorSyncDefaultHandleTypeApi', 'api/IntegrationSourceApi', 'api/IntegrationSourceCompanyStatusApi', 'api/InvoicingDataApi', 'api/InvoicingDataPreviewReportApi', 'api/LastFinancialPeriodTypeApi', 'api/LemonsoftIntegrationSettingsApi', 'api/LivingStrategyDashboardReportApi', 'api/MapRegionApi', 'api/MarketApi', 'api/MarketFeedBingCognitiveApi', 'api/MarketFreeNodeApi', 'api/MarketPlayerTypeApi', 'api/MarketRSSWatchSettingApi', 'api/MarketRSSWatchSettingFeedDataApi', 'api/MarketRSSWatchSettingReportApi', 'api/MarketScopeTypeApi', 'api/MarketSearchTemplateReportApi', 'api/MasterSearchReportApi', 'api/MasterSearchUserInputApi', 'api/MeetingApi', 'api/MeetingAdministratorApi', 'api/MeetingInvitationPeriodTypeApi', 'api/MeetingMinutesApi', 'api/MeetingMinutesContentTypeApi', 'api/MeetingParticipantApi', 'api/MeetingSectionApi', 'api/MeetingSectionContentTypeApi', 'api/MeetingSectionTextTopicApi', 'api/MeetingSectionTopicApi', 'api/MeetingSectionTopicAttachmentApi', 'api/MeetingSectionTopicCommentApi', 'api/MeetingSectionTopicLinkApi', 'api/MeetingStatusApi', 'api/MeetingTemplateApi', 'api/MeetingTemplateAdministratorApi', 'api/MeetingTemplateParticipantApi', 'api/MeetingTemplateSectionApi', 'api/MeetingTemplateSectionTextTopicApi', 'api/MeetingTemplateSectionTopicApi', 'api/MeetingTemplateSectionTopicLinkApi', 'api/MicrosoftTeamsBotLinkedConversationApi', 'api/MobileClientTokenApi', 'api/NewsEntryApi', 'api/NewsEntryAutomatedSourceApi', 'api/NewsEntryCategoryApi', 'api/NewsEntryCommentApi', 'api/NewsEntryContributorApi', 'api/NewsEntryEntryStatusApi', 'api/NewsEntryInsightLinkApi', 'api/NewsEntrySourceApi', 'api/NewsEntrySourceCategoryApi', 'api/NewsEntrySourceReportApi', 'api/NewsEntrySourceTypeApi', 'api/NewsEntryUserStatusApi', 'api/NotificationReportApi', 'api/NotificationSendingTimeTypeApi', 'api/NotificationTypeApi', 'api/OpencorporatesOrganizationApi', 'api/OrganizationApi', 'api/OrganizationClassificationTypeApi', 'api/OtherPlayerApi', 'api/PartnerApi', 'api/PartnerClientCompanyApi', 'api/PartnerClientCompanyEventTypeApi', 'api/PartnerClientCompanyTypeApi', 'api/PartnerSupportLevelApi', 'api/PerformanceIndicatorApi', 'api/PerformanceIndicatorCalculationRangeApi', 'api/PerformanceIndicatorCollectionTypeApi', 'api/PerformanceIndicatorComparisonCalculationApi', 'api/PerformanceIndicatorComparisonTargetApi', 'api/PerformanceIndicatorConversationApi', 'api/PerformanceIndicatorDateRangeApi', 'api/PerformanceIndicatorDayDataApi', 'api/PerformanceIndicatorDimensionApi', 'api/PerformanceIndicatorFormulaApi', 'api/PerformanceIndicatorFormulaElementTypeApi', 'api/PerformanceIndicatorGroupApi', 'api/PerformanceIndicatorMonthDataApi', 'api/PerformanceIndicatorPeriodTypeApi', 'api/PerformanceIndicatorPointCalculationApi', 'api/PerformanceIndicatorPollBatchApi', 'api/PerformanceIndicatorPollBatchUserApi', 'api/PerformanceIndicatorPollGeneralResponseApi', 'api/PerformanceIndicatorPollSettingsApi', 'api/PerformanceIndicatorPollStatusApi', 'api/PerformanceIndicatorPollValueAggregationTypeApi', 'api/PerformanceIndicatorPollValueTypeApi', 'api/PerformanceIndicatorQuarterDataApi', 'api/PerformanceIndicatorRelativePeriodApi', 'api/PerformanceIndicatorSystemTypeApi', 'api/PerformanceIndicatorValueDependencyRuleApi', 'api/PerformanceIndicatorValueSourceApi', 'api/PerformanceIndicatorWeekDataApi', 'api/PerformanceIndicatorYearDataApi', 'api/PerformanceManagementAlertApi', 'api/PerformanceManagementAlertActivityStatusApi', 'api/PerformanceManagementAlertDashboardBlockApi', 'api/PerformanceManagementAlertDashboardBlockCommentApi', 'api/PerformanceManagementAlertDeliveryChannelApi', 'api/PerformanceManagementAlertEmailTitleTypeApi', 'api/PerformanceManagementAlertIndicatorApi', 'api/PerformanceManagementAlertRecipientApi', 'api/PerformanceManagementAlertReviewSectionApi', 'api/PerformanceManagementAlertReviewSectionCommentApi', 'api/PerformanceManagementAlertScoreApi', 'api/PerformanceManagementAlertTriggerIndicatorApi', 'api/PerformanceManagementAlertTriggerTypeApi', 'api/PerformancePerspectiveApi', 'api/PerformancePerspectiveGroupApi', 'api/PersonalTopicApi', 'api/PollReportApi', 'api/PollSettingsScaleApi', 'api/PowerBITokenApi', 'api/ProductApi', 'api/PublicExternalLinkApi', 'api/QuickStartApi', 'api/RawDataMappingApi', 'api/RawDataMappingColumnApi', 'api/RawDataMappingColumnDataTypeApi', 'api/RawDataMappingRuleApi', 'api/RawDataRowApi', 'api/RawDataSourceApi', 'api/RawDataSourceStatusApi', 'api/RelativeDateTypeApi', 'api/SIEUploadQueueApi', 'api/SWOTAreaApi', 'api/SWOTInboxApi', 'api/SWOTSessionApi', 'api/SWOTSessionParticipantApi', 'api/SWOTTopicApi', 'api/SWOTTopicCommentApi', 'api/SWOTTopicVoteApi', 'api/SWOTTopicVoteBatchApi', 'api/SessionInformationApi', 'api/SeveraIntegrationSettingsApi', 'api/SheetConfigurationApi', 'api/SheetConfigurationForecastDownloadFromSheetRuleApi', 'api/SheetConfigurationForecastUploadToSheetRuleApi', 'api/SheetExcelConfigurationApi', 'api/SheetExcelGenerationIndicatorDepthRuleApi', 'api/SheetExcelGenerationValueWriteRuleApi', 'api/SheetForecastApi', 'api/SheetForecastFileApi', 'api/SheetForecastFileStatusApi', 'api/SheetForecastFileTypeApi', 'api/SheetForecastFileUserAccessApi', 'api/SheetForecastInputMethodApi', 'api/SheetForecastNotificationApi', 'api/SheetForecastRelatedSheetApi', 'api/SheetGoogleConfigurationApi', 'api/SheetGoogleTemplateCopiedRangeValueTypeApi', 'api/StakeholderApi', 'api/StakeholderBenchmarkApi', 'api/StakeholderBenchmarkCustomItemApi', 'api/StakeholderBenchmarkDimensionApi', 'api/StakeholderBenchmarkDimensionValueApi', 'api/StakeholderBenchmarkTemplateApi', 'api/StakeholderCommentApi', 'api/StakeholderMarketPositioningMapViewApi', 'api/StakeholderMarketPositioningMapViewCustomItemApi', 'api/StakeholderMarketPositioningMapViewPositionApi', 'api/StakeholderMarketPositioningMapViewTemplateApi', 'api/StakeholderNewsEntryAutomatedSourceApi', 'api/StakeholderNewsWatchFilterLevelApi', 'api/StakeholderTypeApi', 'api/StrategicGoalApi', 'api/StrategicGoalCriticalSuccessFactorApi', 'api/StrategicGoalMilestoneApi', 'api/StrategicGoalMilestoneAchievabilityApi', 'api/StrategicGoalMilestoneCommentApi', 'api/StrategicGoalMilestoneFinalStatusApi', 'api/StrategicGoalMilestoneSecondaryOwnerApi', 'api/StrategicGoalMilestoneSecondaryStatusUpdateApi', 'api/StrategicGoalMilestoneStatusApi', 'api/StrategicGoalMilestoneStatusUpdateApi', 'api/StrategicGoalMilestoneTeamLinkApi', 'api/StrategicProgramApi', 'api/StrategicProgramCommentApi', 'api/StrategicProgramConnectionApi', 'api/StrategicProgramFinalStatusApi', 'api/StrategicProgramRiskLevelApi', 'api/StrategicProgramSecondaryOwnerApi', 'api/StrategicProgramStatusApi', 'api/StrategicProgramStatusUpdateApi', 'api/StrategicProgramStatusUpdateRecipientApi', 'api/StrategicProgramUpdateFrequencyApi', 'api/StrategyDescriptionApi', 'api/StrategyDescriptionAdministratorApi', 'api/StrategyDescriptionExternalLinkApi', 'api/StrategyDescriptionParticipatorApi', 'api/StrategyDescriptionPerformanceIndicatorApi', 'api/StrategyDescriptionStatusApi', 'api/StrategyElementTypeApi', 'api/StrategyExecutionCustomEntityApi', 'api/StrategyExecutionCustomEntityDataApi', 'api/StrategyExecutionCustomFieldApi', 'api/StrategyExecutionCustomFieldLinkApi', 'api/StrategyExecutionCustomFieldOptionApi', 'api/StrategyExecutionCustomFieldTypeApi', 'api/StrategyExecutionSecondaryStatusUpdateTypeApi', 'api/StrategyExecutionTypeApi', 'api/StrategyFreeNodeApi', 'api/StrategyHealthReportApi', 'api/StrategyNamingTypeApi', 'api/StrategyPageBlockApi', 'api/StrategyPageBlockTypeApi', 'api/StrategyPageMemoBlockApi', 'api/StrategyProcessApi', 'api/StrategyProcessPhaseApi', 'api/StrategyProcessPhaseContentApi', 'api/StrategyProcessSubthemeApi', 'api/StrategyProcessSubthemeLinkApi', 'api/StrategyProcessSubthemeTypeApi', 'api/StrategyProcessThemeApi', 'api/StrategyProgressCalculationMethodApi', 'api/StrategyProgressCalculationSourceApi', 'api/StrategyPublishingLevelApi', 'api/StrategyPublishingTypeApi', 'api/StrategySavedViewApi', 'api/StrategySelectionApi', 'api/StrategyTaxonomyApi', 'api/SupplierApi', 'api/SystemLanguageApi', 'api/SystemRegisterDataSourceApi', 'api/SystemUserRoleApi', 'api/SystemUserTypeApi', 'api/TrackingLevelApi', 'api/TrackingLevelItemApi', 'api/TrendCategoryApi', 'api/TrendScopeApi', 'api/TrendSettingsApi', 'api/TrendTopicApi', 'api/TrendTopicCommentApi', 'api/TrendTopicTypeApi', 'api/UserApi', 'api/UserActivityItemApi', 'api/UserActivityReportApi', 'api/UserCompanyAccessApi', 'api/UserCompanyFunctionalityAccessApi', 'api/UserDataVisibilityFunctionApi', 'api/UserDataVisibilityLegalEntityApi', 'api/UserDataVisibilityProductApi', 'api/UserDataVisibilitySettingsApi', 'api/UserEngagementActionApi', 'api/UserFeedbackReportApi', 'api/UserFunctionalityAccessReportApi', 'api/UserInterfaceTextApi', 'api/UserInterfaceTranslationLanguageApi', 'api/UserListDataReportApi', 'api/UserLocalApi', 'api/UserNotificationEventSourceApi', 'api/UserNotificationUserSettingsApi', 'api/UserPartnerAccessApi', 'api/UserRoleApi', 'api/UserRoleBillingUserTypeApi', 'api/UserRoleProductApi', 'api/UserSyncExcelSettingsApi', 'api/UserTrackingLevelLinkApi', 'api/VATPeriodTypeApi', 'api/WorkshopApi', 'api/WorkshopBackgroundImageApi', 'api/WorkshopCanvasItemApi', 'api/WorkshopCanvasItemTypeApi', 'api/WorkshopExternalContentTypeApi', 'api/WorkshopItemApi', 'api/WorkshopItemCategoryApi', 'api/WorkshopItemCategoryConnectionApi', 'api/WorkshopItemHistoryApi', 'api/WorkshopItemRatingApi', 'api/WorkshopItemRatingHistoryApi', 'api/WorkshopParticipantApi', 'api/WorkshopParticipantRoleApi', 'api/WorkshopPhaseApi', 'api/WorkshopPhaseComparisonAxisApi', 'api/WorkshopPhaseComparisonDimensionApi', 'api/WorkshopPhaseContentCreationRuleApi', 'api/WorkshopPhaseContentRowApi', 'api/WorkshopPhaseContentRowLayoutApi', 'api/WorkshopPhaseGridBlockApi', 'api/WorkshopPhaseParticipantRoleApi', 'api/WorkshopPrioritizationVotingTypeApi', 'api/WorkshopQuestionnaireFilterApi', 'api/WorkshopQuestionnaireOptionApi', 'api/WorkshopQuestionnaireQuestionApi', 'api/WorkshopQuestionnaireQuestionTypeApi', 'api/WorkshopQuestionnaireResponseApi', 'api/WorkshopRatingPhaseCategoryWeightApi', 'api/WorkshopRatingPhaseSourceApi', 'api/WorkshopRatingPhaseWeightedLevelApi', 'api/WorkshopResultPhaseSourceApi', 'api/WorkshopResultPresentationTypeApi', 'api/WorkshopVersionHistoryChangeTypeApi', 'api/WorkshopVideoCallApi', 'api/WorkshopWidgetApi', 'api/WorkshopWidgetIdeaGenerationThemeApi', 'api/WorkshopWidgetParticipantStatusApi', 'api/WorkshopWidgetStatusApi', 'api/WorkshopWidgetTypeApi', 'api/WorkspaceMindmapApi', 'api/WorkspaceMindmapNodeApi', 'api/WorkspaceMindmapNodeTypeApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/AccessFunctionality'), require('./model/AccessFunctionalityAddOn'), require('./model/AccessModule'), require('./model/AccessProfile'), require('./model/AccessType'), require('./model/AccountingData'), require('./model/AccountingDataPaginationSlice'), require('./model/AccountingDataPreviewReport'), require('./model/AgendaFlag'), require('./model/AgendaTheme'), require('./model/AgendaTimeReservation'), require('./model/AgendaTimeSerieEvent'), require('./model/AgendaTimeSerieRule'), require('./model/AgendaTimeSerieRuleReport'), require('./model/AnalysisCategory'), require('./model/AutomatedSourceGeneratedNews'), require('./model/BingCognitiveItem'), require('./model/BingCognitiveSearchData'), require('./model/BisnodeFinancialIndicatorValue'), require('./model/BusinessModel'), require('./model/BusinessModelArea'), require('./model/BusinessModelCanvasArea'), require('./model/BusinessModelCanvasItem'), require('./model/BusinessModelCanvasItemType'), require('./model/BusinessModelReport'), require('./model/BusinessReviewExcludedSection'), require('./model/BusinessReviewSchedule'), require('./model/BusinessReviewSectionType'), require('./model/BusinessReviewSession'), require('./model/BusinessReviewSessionPaginationSlice'), require('./model/BusinessReviewSessionStatus'), require('./model/BusinessReviewStatus'), require('./model/BusinessReviewStep'), require('./model/BusinessReviewStepElementSide'), require('./model/BusinessReviewTemplate'), require('./model/BusinessReviewTemplateReport'), require('./model/BusinessReviewUserSettings'), require('./model/BusinessSimulatorCashflowAccountReceivablesDistribution'), require('./model/BusinessSimulatorCashflowCapitalItem'), require('./model/BusinessSimulatorCashflowCapitalItemGroup'), require('./model/BusinessSimulatorCashflowCapitalItemValue'), require('./model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice'), require('./model/BusinessSimulatorCashflowSalesReceivablesDistribution'), require('./model/CashflowForecastDataReport'), require('./model/CashflowForecastIndicatorConnection'), require('./model/CashflowForecastIndicatorConnectionReport'), require('./model/CashflowForecastIndicatorDistributionEntry'), require('./model/CashflowForecastSettings'), require('./model/CashflowForecastSettingsReport'), require('./model/CategoryReport'), require('./model/Company'), require('./model/CompanyAccessFunctionalityAddOn'), require('./model/CompanyAccessModule'), require('./model/CompanyFunction'), require('./model/CompanyLegalEntity'), require('./model/CompanyLegalEntityType'), require('./model/CompanyResponsiblePerson'), require('./model/CompanyResponsiblePersonConnection'), require('./model/CompanySubscriptionReport'), require('./model/CompanySubscriptionServiceLevel'), require('./model/CompanyTemplateType'), require('./model/CompanyUserServiceLevelBase'), require('./model/CompanyVirtualTeam'), require('./model/CompanyVirtualTeamMember'), require('./model/ContentWatchSettings'), require('./model/ContentWatchSettingsPaginationSlice'), require('./model/CorporateStructureFilter'), require('./model/CorporateStructureLink'), require('./model/CorporateStructureLinkReport'), require('./model/CorporateStructureSortMode'), require('./model/Country'), require('./model/Customer'), require('./model/DashboardGroup'), require('./model/DashboardGroupLightReport'), require('./model/DashboardPage'), require('./model/DashboardPageBlock'), require('./model/DashboardPageBlockBubbleSettings'), require('./model/DashboardPageBlockCartesianAxis'), require('./model/DashboardPageBlockCartesianSerie'), require('./model/DashboardPageBlockCartesianSerieGrouping'), require('./model/DashboardPageBlockCartesianSerieMilestone'), require('./model/DashboardPageBlockCartesianSerieReport'), require('./model/DashboardPageBlockCartesianSerieType'), require('./model/DashboardPageBlockComment'), require('./model/DashboardPageBlockCommentPaginationSlice'), require('./model/DashboardPageBlockComparisonBarSerie'), require('./model/DashboardPageBlockComparisonBarSerieType'), require('./model/DashboardPageBlockComparisonColumnSerie'), require('./model/DashboardPageBlockComparisonColumnSerieType'), require('./model/DashboardPageBlockCustomTableColumn'), require('./model/DashboardPageBlockCustomTableColumnDefaultFilter'), require('./model/DashboardPageBlockCustomTableGraphSerieType'), require('./model/DashboardPageBlockCustomTableQuery'), require('./model/DashboardPageBlockExternalSettings'), require('./model/DashboardPageBlockGoogleSheetSettings'), require('./model/DashboardPageBlockImage'), require('./model/DashboardPageBlockLightReport'), require('./model/DashboardPageBlockMarketOverviewSettings'), require('./model/DashboardPageBlockMilestone'), require('./model/DashboardPageBlockNewsfeed'), require('./model/DashboardPageBlockNumberSerie'), require('./model/DashboardPageBlockPieSerie'), require('./model/DashboardPageBlockPollSettings'), require('./model/DashboardPageBlockPowerBIEmbed'), require('./model/DashboardPageBlockReport'), require('./model/DashboardPageBlockReportNestedPaginationSlice'), require('./model/DashboardPageBlockReportPaginationSlice'), require('./model/DashboardPageBlockSerieOrder'), require('./model/DashboardPageBlockSolidGaugeSerie'), require('./model/DashboardPageBlockStrategicAction'), require('./model/DashboardPageBlockStrategicActionViewType'), require('./model/DashboardPageBlockStrategy'), require('./model/DashboardPageBlockTableComparisonColumn'), require('./model/DashboardPageBlockTableComparisonRow'), require('./model/DashboardPageBlockTableDataColumn'), require('./model/DashboardPageBlockTableEmptyRow'), require('./model/DashboardPageBlockTableRollingComparison'), require('./model/DashboardPageBlockTableSerieRow'), require('./model/DashboardPageBlockTableSerieRowExpandedIndicator'), require('./model/DashboardPageBlockTableSerieRowReport'), require('./model/DashboardPageBlockTableSumColumn'), require('./model/DashboardPageBlockTemplate'), require('./model/DashboardPageBlockType'), require('./model/DashboardPageExportSettings'), require('./model/DashboardPageHomeSettings'), require('./model/DashboardPageLightReport'), require('./model/DashboardPageReport'), require('./model/DashboardPageTemplate'), require('./model/DashboardPageUserAccess'), require('./model/DashboardShareBatchBlock'), require('./model/DashboardShareBatchReport'), require('./model/Decision'), require('./model/DecisionPoll'), require('./model/DecisionPollReplyOptionTypeOption'), require('./model/DecisionPollReplyOptionTypeReport'), require('./model/DecisionPollReport'), require('./model/DecisionPollRespondent'), require('./model/DecisionPollType'), require('./model/DecisionReport'), require('./model/DecisionTopicComment'), require('./model/DecisionTopicCommentPaginationSlice'), require('./model/DecisionTopicPhase'), require('./model/DecisionTopicReport'), require('./model/DecisionTopicSuggestionSearchItem'), require('./model/DecisionTopicType'), require('./model/DecisionTrackingType'), require('./model/DialogDistributionChannel'), require('./model/DialogFlowLogicGateMatchRule'), require('./model/DialogFlowLogicGateValueSource'), require('./model/DialogFlowMultiOptionDataSource'), require('./model/DialogFlowSession'), require('./model/DialogFlowTemplate'), require('./model/DialogFlowTemplateMessage'), require('./model/DialogFlowTemplateMessageConversionRule'), require('./model/DialogFlowTemplateMessageOption'), require('./model/DialogFlowTemplateMessageReport'), require('./model/DialogFlowTemplateMessageType'), require('./model/DialogFlowTemplateReport'), require('./model/DialogScheduleBatch'), require('./model/DialogScheduleBatchReport'), require('./model/DialogScheduleFlow'), require('./model/DialogScheduleRhytm'), require('./model/DialogScheduleSettings'), require('./model/DialogScheduleSettingsReport'), require('./model/DialogScheduleUser'), require('./model/ERPAccountList'), require('./model/ERPAdminCostDivisionRule'), require('./model/ERPAdminCostDivisionRuleFixedRule'), require('./model/ERPAdminCostDivisionRuleFromAccount'), require('./model/ERPAdminCostDivisionRuleLevel'), require('./model/ERPAdminCostDivisionRuleReport'), require('./model/ERPAdminCostDivisionRuleSourceFilter'), require('./model/ERPAdminCostDivisionType'), require('./model/ERPCorporateAccount'), require('./model/ERPDimensionMapping'), require('./model/ERPDimensionSyncSetting'), require('./model/ERPDimensionSyncType'), require('./model/ERPFinancialAdvisorySettings'), require('./model/ERPFinancialCalculationError'), require('./model/ERPFivaldiIntegrationSettings'), require('./model/ERPNetvisorIntegrationLockPeriod'), require('./model/ERPNetvisorIntegrationSettings'), require('./model/ERPProcountorIntegrationSettings'), require('./model/ERPSyncCustomer'), require('./model/ERPSyncCustomerMonthData'), require('./model/ERPSyncCustomerReport'), require('./model/ERPSyncCustomerReportERPSyncItemPaginationSlice'), require('./model/ERPSyncProduct'), require('./model/ERPSyncProductMonthData'), require('./model/ERPSyncProductReport'), require('./model/ERPSyncProductReportERPSyncItemPaginationSlice'), require('./model/EntityChange'), require('./model/ExternalSourceLightSpreadsheet'), require('./model/ExternalSourceLightSpreadsheetSheet'), require('./model/FileTransferHelperEntity'), require('./model/FinancialBatchPreviewReport'), require('./model/FinancialIndicator'), require('./model/FinancialIndicatorDataFilter'), require('./model/FinancialIndicatorDataReport'), require('./model/FinancialIndicatorValueBase'), require('./model/FinancialsAndDecisionMakers'), require('./model/FinancialsFiscalReport'), require('./model/ForecastModel'), require('./model/ForecastModelAggregationLevel'), require('./model/ForecastModelAggregationLevelReport'), require('./model/ForecastModelAggregationReport'), require('./model/ForecastModelDataEntry'), require('./model/ForecastModelDataEntryCustomIndicator'), require('./model/ForecastModelDataEntryStatus'), require('./model/ForecastModelDataEntryType'), require('./model/ForecastModelRecordData'), require('./model/ForecastModelRecordDataActualSplitRange'), require('./model/ForecastModelRecordDataFile'), require('./model/ForecastModelRecordDataFileReport'), require('./model/ForecastModelRecordDataImportPeriodType'), require('./model/ForecastModelRecordDataReport'), require('./model/ForecastModelRecordDataTransferLog'), require('./model/ForecastModelReport'), require('./model/ForesightScenario'), require('./model/ForesightScenarioBaselineCalculation'), require('./model/ForesightScenarioElement'), require('./model/ForesightScenarioElementReport'), require('./model/ForesightScenarioElementType'), require('./model/ForesightScenarioFactor'), require('./model/ForesightScenarioLevel'), require('./model/ForesightScenarioLevelReport'), require('./model/ForesightScenarioNotificationRecipient'), require('./model/ForesightScenarioReport'), require('./model/FrontendErrorReport'), require('./model/GeneralSettings'), require('./model/GeoArea'), require('./model/GoalMetric'), require('./model/GoalMetricReport'), require('./model/GoalMetricReportPaginationSlice'), require('./model/GoalMetricValueSource'), require('./model/GoalMetricValueType'), require('./model/GoogleAnalyticsAccount'), require('./model/GoogleAnalyticsProfile'), require('./model/GoogleAnalyticsProperty'), require('./model/GoogleAnalyticsSettings'), require('./model/GoogleOAuthUser'), require('./model/GroupCount'), require('./model/HeaderColumn'), require('./model/ImportAccountingActualsFileRequest'), require('./model/InputValidationFeedback'), require('./model/Insight'), require('./model/InsightCompanyData'), require('./model/InsightDefaultExcludedDomain'), require('./model/InsightFilter'), require('./model/InsightImage'), require('./model/InsightLinkReport'), require('./model/InsightReactionLink'), require('./model/InsightReactionType'), require('./model/InsightReport'), require('./model/InsightTaggedUser'), require('./model/InsightType'), require('./model/IntegrationDataMappingDimension'), require('./model/IntegrationDataMappingMatchRule'), require('./model/IntegrationDataMappingRule'), require('./model/IntegrationDataMappingSource'), require('./model/IntegrationFinancialUploadBatch'), require('./model/IntegrationFinancialUploadBatchExcelFile'), require('./model/IntegrationFinancialUploadBatchFileReport'), require('./model/IntegrationPipedriveSettings'), require('./model/IntegrationPipedriveSettingsPipeline'), require('./model/IntegrationPipedriveSettingsPipelineReport'), require('./model/IntegrationPipedriveSettingsPipelineReportPaginationSlice'), require('./model/IntegrationPipedriveSettingsPipelineStage'), require('./model/IntegrationPipedriveSettingsPipelineStagePaginationSlice'), require('./model/IntegrationPipedriveSettingsReport'), require('./model/IntegrationSettingsNetvisorSyncDefaultHandleType'), require('./model/IntegrationSource'), require('./model/IntegrationSourceCompanyStatus'), require('./model/InvoicingDataLightReport'), require('./model/InvoicingDataLightReportPaginationSlice'), require('./model/InvoicingDataPreviewReport'), require('./model/InvoicingDataReceivableReport'), require('./model/InvoicingDataReceivableReportPaginationSlice'), require('./model/LSDStrategyProgressReport'), require('./model/LastFinancialPeriodType'), require('./model/LemonsoftIntegrationSettings'), require('./model/LivingStrategyDashboardReport'), require('./model/MapDataReport'), require('./model/MapRegionDataReport'), require('./model/Market'), require('./model/MarketFeedBingCognitive'), require('./model/MarketFreeNode'), require('./model/MarketRSSWatchSetting'), require('./model/MarketRSSWatchSettingFeedData'), require('./model/MarketRSSWatchSettingReport'), require('./model/MarketScopeType'), require('./model/MarketSearchTemplateQuery'), require('./model/MarketSearchTemplateReport'), require('./model/MasterSearchReport'), require('./model/MasterSearchReportItem'), require('./model/MasterSearchUserInput'), require('./model/Meeting'), require('./model/MeetingAdministrator'), require('./model/MeetingInvitationPeriodType'), require('./model/MeetingMinutesContentType'), require('./model/MeetingMinutesReport'), require('./model/MeetingMinutesSignature'), require('./model/MeetingParticipant'), require('./model/MeetingReport'), require('./model/MeetingSection'), require('./model/MeetingSectionContentType'), require('./model/MeetingSectionReport'), require('./model/MeetingSectionReportPaginationSlice'), require('./model/MeetingSectionTextTopic'), require('./model/MeetingSectionTopic'), require('./model/MeetingSectionTopicAttachment'), require('./model/MeetingSectionTopicComment'), require('./model/MeetingSectionTopicCommentPaginationSlice'), require('./model/MeetingSectionTopicLink'), require('./model/MeetingSectionTopicReport'), require('./model/MeetingStatus'), require('./model/MeetingTemplate'), require('./model/MeetingTemplateAdministrator'), require('./model/MeetingTemplateParticipant'), require('./model/MeetingTemplateReport'), require('./model/MeetingTemplateSection'), require('./model/MeetingTemplateSectionReport'), require('./model/MeetingTemplateSectionTextTopic'), require('./model/MeetingTemplateSectionTopic'), require('./model/MeetingTemplateSectionTopicLink'), require('./model/MeetingTemplateSectionTopicReport'), require('./model/MicrosoftTeamsBotLinkedConversation'), require('./model/MobileClientToken'), require('./model/NewsEntry'), require('./model/NewsEntryAutomatedSource'), require('./model/NewsEntryCategory'), require('./model/NewsEntryComment'), require('./model/NewsEntryCommentPaginationSlice'), require('./model/NewsEntryCommentReport'), require('./model/NewsEntryCommentReportPaginationSlice'), require('./model/NewsEntryContributor'), require('./model/NewsEntryContributorPaginationSlice'), require('./model/NewsEntryEntryStatus'), require('./model/NewsEntryFilter'), require('./model/NewsEntryFullReport'), require('./model/NewsEntryFullReportNewsEntryReportPaginationSlice'), require('./model/NewsEntryInsightLink'), require('./model/NewsEntryLightReport'), require('./model/NewsEntryLightReportNewsEntryReportPaginationSlice'), require('./model/NewsEntrySourceCategory'), require('./model/NewsEntrySourceReport'), require('./model/NewsEntrySourceReportPaginationSlice'), require('./model/NewsEntrySourceType'), require('./model/NewsEntryUserStatus'), require('./model/NotificationFilter'), require('./model/NotificationGroupCount'), require('./model/NotificationReport'), require('./model/NotificationReportPaginationSlice'), require('./model/NotificationSendingTimeType'), require('./model/NotificationType'), require('./model/OpencorporatesOrganization'), require('./model/OpencorporatesOrganizationPaginationSlice'), require('./model/Organization'), require('./model/OrganizationClassificationType'), require('./model/OrganizationIndexSearchResultExtended'), require('./model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport'), require('./model/OrganizationItemLight'), require('./model/OrganizationItemLightPaginationSlice'), require('./model/OrganizationPaginationSlice'), require('./model/PartnerClientCompany'), require('./model/PartnerClientCompanyEvent'), require('./model/PartnerClientCompanyEventType'), require('./model/PartnerClientCompanyReport'), require('./model/PartnerClientCompanyType'), require('./model/PartnerCompany'), require('./model/PartnerSupportLevel'), require('./model/PaymentDisturbance'), require('./model/PerformanceIndicator'), require('./model/PerformanceIndicatorAvailabilityReport'), require('./model/PerformanceIndicatorCalculationRange'), require('./model/PerformanceIndicatorCollectionType'), require('./model/PerformanceIndicatorComparisonCalculation'), require('./model/PerformanceIndicatorComparisonTarget'), require('./model/PerformanceIndicatorConversation'), require('./model/PerformanceIndicatorConversationReport'), require('./model/PerformanceIndicatorDataBase'), require('./model/PerformanceIndicatorDataCopySettings'), require('./model/PerformanceIndicatorDataExtrapolationSettings'), require('./model/PerformanceIndicatorDataFilter'), require('./model/PerformanceIndicatorDataReport'), require('./model/PerformanceIndicatorDateRange'), require('./model/PerformanceIndicatorDayData'), require('./model/PerformanceIndicatorDimension'), require('./model/PerformanceIndicatorDrillData'), require('./model/PerformanceIndicatorFormula'), require('./model/PerformanceIndicatorFormulaElementType'), require('./model/PerformanceIndicatorGroupReport'), require('./model/PerformanceIndicatorMonthData'), require('./model/PerformanceIndicatorPeriodType'), require('./model/PerformanceIndicatorPointCalculation'), require('./model/PerformanceIndicatorPollBatch'), require('./model/PerformanceIndicatorPollBatchPaginationSlice'), require('./model/PerformanceIndicatorPollBatchUserReport'), require('./model/PerformanceIndicatorPollBatchUserReportPaginationSlice'), require('./model/PerformanceIndicatorPollGeneralResponseReport'), require('./model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice'), require('./model/PerformanceIndicatorPollSettings'), require('./model/PerformanceIndicatorPollSettingsLightReport'), require('./model/PerformanceIndicatorPollStatus'), require('./model/PerformanceIndicatorPollValueAggregationType'), require('./model/PerformanceIndicatorPollValueType'), require('./model/PerformanceIndicatorQuarterData'), require('./model/PerformanceIndicatorRelativePeriod'), require('./model/PerformanceIndicatorReport'), require('./model/PerformanceIndicatorSystemType'), require('./model/PerformanceIndicatorValueDependencyRule'), require('./model/PerformanceIndicatorValueSource'), require('./model/PerformanceIndicatorWeekData'), require('./model/PerformanceIndicatorYearData'), require('./model/PerformanceManagementAlert'), require('./model/PerformanceManagementAlertActivityStatus'), require('./model/PerformanceManagementAlertDashboardBlock'), require('./model/PerformanceManagementAlertDashboardBlockComment'), require('./model/PerformanceManagementAlertDashboardBlockReport'), require('./model/PerformanceManagementAlertDeliveryChannel'), require('./model/PerformanceManagementAlertEmailTitleType'), require('./model/PerformanceManagementAlertIndicator'), require('./model/PerformanceManagementAlertRecipient'), require('./model/PerformanceManagementAlertReport'), require('./model/PerformanceManagementAlertReportNestedPaginationSlice'), require('./model/PerformanceManagementAlertReviewSection'), require('./model/PerformanceManagementAlertReviewSectionComment'), require('./model/PerformanceManagementAlertReviewSectionReport'), require('./model/PerformanceManagementAlertScore'), require('./model/PerformanceManagementAlertTriggerIndicator'), require('./model/PerformanceManagementAlertTriggerType'), require('./model/PerformancePerspective'), require('./model/PerformancePerspectiveGroup'), require('./model/PersonalTopic'), require('./model/PollReport'), require('./model/PollReportQuestion'), require('./model/PollReportQuestionMatrixAxis'), require('./model/PollReportQuestionMultipleNumericValue'), require('./model/PollReportQuestionScaleValue'), require('./model/PollResponse'), require('./model/PollSettingsScale'), require('./model/PowerBIEmbedToken'), require('./model/PowerBIItem'), require('./model/PowerBIToken'), require('./model/PowerBIWorkspace'), require('./model/Product'), require('./model/PublicExternalLink'), require('./model/QuickStartReport'), require('./model/QuickStartStep'), require('./model/QuickStartStepCategoryReport'), require('./model/RawDataColumn'), require('./model/RawDataMapping'), require('./model/RawDataMappingColumn'), require('./model/RawDataMappingColumnDataType'), require('./model/RawDataMappingReport'), require('./model/RawDataMappingRule'), require('./model/RawDataRowColumn'), require('./model/RawDataRowError'), require('./model/RawDataRowReport'), require('./model/RawDataRowReportPaginationSlice'), require('./model/RawDataSource'), require('./model/RawDataSourceReport'), require('./model/RawDataSourceStatus'), require('./model/RelativeDateType'), require('./model/Row'), require('./model/SIEUploadQueue'), require('./model/SWOTArea'), require('./model/SWOTInbox'), require('./model/SWOTSession'), require('./model/SWOTSessionParticipant'), require('./model/SWOTSessionReport'), require('./model/SWOTTopic'), require('./model/SWOTTopicComment'), require('./model/SWOTTopicCommentPaginationSlice'), require('./model/SWOTTopicReport'), require('./model/SWOTTopicVote'), require('./model/SWOTTopicVoteBatch'), require('./model/SWOTTopicVoteBatchReport'), require('./model/SWOTTopicVoteBatchReportPaginationSlice'), require('./model/SessionInformation'), require('./model/SeveraIntegrationSettingsReport'), require('./model/SheetConfiguration'), require('./model/SheetConfigurationForecastDownloadFromSheetRule'), require('./model/SheetConfigurationForecastUploadToSheetRule'), require('./model/SheetExcelConfiguration'), require('./model/SheetExcelGenerationIndicatorDepthRule'), require('./model/SheetExcelGenerationSettings'), require('./model/SheetExcelGenerationValueWriteRule'), require('./model/SheetForecast'), require('./model/SheetForecastAggregatedBudgetReport'), require('./model/SheetForecastFile'), require('./model/SheetForecastFileReport'), require('./model/SheetForecastFileStatus'), require('./model/SheetForecastFileType'), require('./model/SheetForecastFileUserAccess'), require('./model/SheetForecastInputMethod'), require('./model/SheetForecastNotificationRecipient'), require('./model/SheetForecastNotificationReport'), require('./model/SheetForecastRelatedSheet'), require('./model/SheetForecastReport'), require('./model/SheetGenerationSettings'), require('./model/SheetGenerationSettingsIndicator'), require('./model/SheetGoogleConfiguration'), require('./model/SheetGoogleTemplateCopiedRange'), require('./model/SheetGoogleTemplateCopiedRangeSettings'), require('./model/SheetGoogleTemplateCopiedRangeValueType'), require('./model/SpecialMenuItem'), require('./model/Stakeholder'), require('./model/StakeholderBenchmark'), require('./model/StakeholderBenchmarkCustomItem'), require('./model/StakeholderBenchmarkCustomItemPaginationSlice'), require('./model/StakeholderBenchmarkDimension'), require('./model/StakeholderBenchmarkDimensionReport'), require('./model/StakeholderBenchmarkDimensionReportPaginationSlice'), require('./model/StakeholderBenchmarkDimensionValue'), require('./model/StakeholderBenchmarkDimensionValuePaginationSlice'), require('./model/StakeholderBenchmarkReport'), require('./model/StakeholderBenchmarkTemplate'), require('./model/StakeholderComment'), require('./model/StakeholderCommentPaginationSlice'), require('./model/StakeholderMarketPositioningMapView'), require('./model/StakeholderMarketPositioningMapViewCustomItem'), require('./model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice'), require('./model/StakeholderMarketPositioningMapViewPosition'), require('./model/StakeholderMarketPositioningMapViewPositionPaginationSlice'), require('./model/StakeholderMarketPositioningMapViewReport'), require('./model/StakeholderMarketPositioningMapViewTemplate'), require('./model/StakeholderNewsEntryAutomatedSource'), require('./model/StakeholderNewsWatchFilterLevel'), require('./model/StakeholderReport'), require('./model/StakeholderReportPaginationSlice'), require('./model/StakeholderType'), require('./model/StakeholderTypeReport'), require('./model/StrategicGoal'), require('./model/StrategicGoalCriticalSuccessFactor'), require('./model/StrategicGoalCriticalSuccessFactorReport'), require('./model/StrategicGoalMilestone'), require('./model/StrategicGoalMilestoneAchievability'), require('./model/StrategicGoalMilestoneComment'), require('./model/StrategicGoalMilestoneCommentPaginationSlice'), require('./model/StrategicGoalMilestoneFinalStatus'), require('./model/StrategicGoalMilestoneReport'), require('./model/StrategicGoalMilestoneSecondaryOwner'), require('./model/StrategicGoalMilestoneSecondaryStatusUpdate'), require('./model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice'), require('./model/StrategicGoalMilestoneStatus'), require('./model/StrategicGoalMilestoneStatusUpdate'), require('./model/StrategicGoalMilestoneStatusUpdatePaginationSlice'), require('./model/StrategicGoalMilestoneTeamLink'), require('./model/StrategicGoalReport'), require('./model/StrategicProgram'), require('./model/StrategicProgramComment'), require('./model/StrategicProgramCommentPaginationSlice'), require('./model/StrategicProgramConnection'), require('./model/StrategicProgramFinalStatus'), require('./model/StrategicProgramReport'), require('./model/StrategicProgramRiskLevel'), require('./model/StrategicProgramSecondaryOwner'), require('./model/StrategicProgramStatus'), require('./model/StrategicProgramStatusUpdate'), require('./model/StrategicProgramStatusUpdateRecipient'), require('./model/StrategicProgramStatusUpdateRecipientPaginationSlice'), require('./model/StrategicProgramStatusUpdateReport'), require('./model/StrategicProgramStatusUpdateReportPaginationSlice'), require('./model/StrategicProgramUpdateFrequency'), require('./model/StrategyBusinessReviewExportSettings'), require('./model/StrategyDescription'), require('./model/StrategyDescriptionAdministrator'), require('./model/StrategyDescriptionExternalLink'), require('./model/StrategyDescriptionParticipator'), require('./model/StrategyDescriptionPerformanceIndicator'), require('./model/StrategyDescriptionPerformanceIndicatorPaginationSlice'), require('./model/StrategyDescriptionReport'), require('./model/StrategyDescriptionStatus'), require('./model/StrategyElementType'), require('./model/StrategyExecutionCustomEntity'), require('./model/StrategyExecutionCustomEntityData'), require('./model/StrategyExecutionCustomField'), require('./model/StrategyExecutionCustomFieldLink'), require('./model/StrategyExecutionCustomFieldOption'), require('./model/StrategyExecutionCustomFieldReport'), require('./model/StrategyExecutionCustomFieldType'), require('./model/StrategyExecutionExportSettings'), require('./model/StrategyExecutionSecondaryStatusUpdateType'), require('./model/StrategyExecutionType'), require('./model/StrategyExportItemSettings'), require('./model/StrategyFreeNode'), require('./model/StrategyFreeNodeReport'), require('./model/StrategyHealthReport'), require('./model/StrategyNamingType'), require('./model/StrategyPageBlock'), require('./model/StrategyPageBlockType'), require('./model/StrategyPageMemoBlock'), require('./model/StrategyProcess'), require('./model/StrategyProcessPhase'), require('./model/StrategyProcessPhaseContent'), require('./model/StrategyProcessPhaseReport'), require('./model/StrategyProcessReport'), require('./model/StrategyProcessSubtheme'), require('./model/StrategyProcessSubthemeLink'), require('./model/StrategyProcessSubthemeReport'), require('./model/StrategyProcessSubthemeType'), require('./model/StrategyProcessTheme'), require('./model/StrategyProcessThemeReport'), require('./model/StrategyProgressCalculationMethod'), require('./model/StrategyProgressCalculationSource'), require('./model/StrategyPublishingLevel'), require('./model/StrategyPublishingType'), require('./model/StrategySavedView'), require('./model/StrategySelection'), require('./model/StrategySelectionReport'), require('./model/StrategyTaxonomy'), require('./model/SystemLanguage'), require('./model/SystemUserRole'), require('./model/SystemUserType'), require('./model/TrackingLevel'), require('./model/TrackingLevel1Item'), require('./model/TrackingLevel2Item'), require('./model/TrackingLevel3Item'), require('./model/TrackingLevel4Item'), require('./model/TrackingLevelItemBase'), require('./model/TranslationResource'), require('./model/TrendCategory'), require('./model/TrendScope'), require('./model/TrendSettings'), require('./model/TrendTopic'), require('./model/TrendTopicComment'), require('./model/TrendTopicCommentPaginationSlice'), require('./model/TrendTopicReport'), require('./model/TrendTopicType'), require('./model/User'), require('./model/UserActivityItem'), require('./model/UserActivityReport'), require('./model/UserCompanyAccess'), require('./model/UserCompanyAccessReport'), require('./model/UserCompanyFunctionalityAccess'), require('./model/UserDataVisibilityFunction'), require('./model/UserDataVisibilityLegalEntity'), require('./model/UserDataVisibilityProduct'), require('./model/UserDataVisibilitySettings'), require('./model/UserFeedbackReport'), require('./model/UserFunctionalityAccessReport'), require('./model/UserInterfaceText'), require('./model/UserInterfaceTranslationLanguage'), require('./model/UserListDataReport'), require('./model/UserLocal'), require('./model/UserNotificationEventSource'), require('./model/UserNotificationUserSettings'), require('./model/UserPartnerAccessReport'), require('./model/UserRole'), require('./model/UserRoleBillingUserType'), require('./model/UserRoleProduct'), require('./model/UserSyncExcelSettings'), require('./model/UserTrackingLevelLink'), require('./model/VATPeriodType'), require('./model/Workshop'), require('./model/WorkshopBackgroundImage'), require('./model/WorkshopCanvasItem'), require('./model/WorkshopCanvasItemType'), require('./model/WorkshopCloneSettings'), require('./model/WorkshopExternalContentType'), require('./model/WorkshopItem'), require('./model/WorkshopItemCategory'), require('./model/WorkshopItemCategoryConnection'), require('./model/WorkshopItemHistory'), require('./model/WorkshopItemRating'), require('./model/WorkshopItemRatingHistory'), require('./model/WorkshopParticipant'), require('./model/WorkshopParticipantRole'), require('./model/WorkshopPhase'), require('./model/WorkshopPhaseComparisonAxis'), require('./model/WorkshopPhaseComparisonDimension'), require('./model/WorkshopPhaseContentCreationRule'), require('./model/WorkshopPhaseContentRow'), require('./model/WorkshopPhaseContentRowLayout'), require('./model/WorkshopPhaseContentRowReport'), require('./model/WorkshopPhaseGridBlock'), require('./model/WorkshopPhaseParticipantRole'), require('./model/WorkshopPhaseReport'), require('./model/WorkshopPrioritizationVotingType'), require('./model/WorkshopQuestionnaireFilter'), require('./model/WorkshopQuestionnaireOption'), require('./model/WorkshopQuestionnaireQuestion'), require('./model/WorkshopQuestionnaireQuestionReport'), require('./model/WorkshopQuestionnaireQuestionType'), require('./model/WorkshopQuestionnaireResponse'), require('./model/WorkshopRatingPhaseCategoryWeight'), require('./model/WorkshopRatingPhaseSource'), require('./model/WorkshopRatingPhaseSourceReport'), require('./model/WorkshopRatingPhaseWeightedLevel'), require('./model/WorkshopReport'), require('./model/WorkshopResultPhaseSource'), require('./model/WorkshopResultPresentationType'), require('./model/WorkshopStrategyImportSettings'), require('./model/WorkshopVersionHistoryChangeType'), require('./model/WorkshopVideoCall'), require('./model/WorkshopWidget'), require('./model/WorkshopWidgetIdeaGenerationTheme'), require('./model/WorkshopWidgetIdeaGenerationThemeAnswer'), require('./model/WorkshopWidgetParticipantStatus'), require('./model/WorkshopWidgetReport'), require('./model/WorkshopWidgetStatus'), require('./model/WorkshopWidgetType'), require('./model/WorkspaceMindmap'), require('./model/WorkspaceMindmapNode'), require('./model/WorkspaceMindmapNodePaginationSlice'), require('./model/WorkspaceMindmapNodeType'), require('./model/WorkspaceMindmapReport'), require('./api/AccessFunctionalityApi'), require('./api/AccessFunctionalityAddOnApi'), require('./api/AccessModuleApi'), require('./api/AccessProfileApi'), require('./api/AccessTypeApi'), require('./api/AccountingDataApi'), require('./api/AccountingDataPreviewReportApi'), require('./api/AgendaFlagApi'), require('./api/AgendaThemeApi'), require('./api/AgendaTimeReservationApi'), require('./api/AgendaTimeSerieEventApi'), require('./api/AgendaTimeSerieRuleApi'), require('./api/AnalysisCategoryApi'), require('./api/BisnodeFinancialIndicatorValueApi'), require('./api/BusinessModelApi'), require('./api/BusinessModelAreaApi'), require('./api/BusinessModelCanvasAreaApi'), require('./api/BusinessModelCanvasItemApi'), require('./api/BusinessModelCanvasItemTypeApi'), require('./api/BusinessReviewExcludedSectionApi'), require('./api/BusinessReviewScheduleApi'), require('./api/BusinessReviewSectionTypeApi'), require('./api/BusinessReviewSessionApi'), require('./api/BusinessReviewSessionStatusApi'), require('./api/BusinessReviewStatusApi'), require('./api/BusinessReviewStepApi'), require('./api/BusinessReviewStepElementSideApi'), require('./api/BusinessReviewTemplateApi'), require('./api/BusinessReviewUserSettingsApi'), require('./api/BusinessSimulatorCashflowAccountReceivablesDistributionApi'), require('./api/BusinessSimulatorCashflowCapitalItemApi'), require('./api/BusinessSimulatorCashflowCapitalItemGroupApi'), require('./api/BusinessSimulatorCashflowCapitalItemValueApi'), require('./api/BusinessSimulatorCashflowSalesReceivablesDistributionApi'), require('./api/CashflowForecastIndicatorConnectionApi'), require('./api/CashflowForecastIndicatorDistributionEntryApi'), require('./api/CashflowForecastSettingsApi'), require('./api/CategoryApi'), require('./api/CompanyApi'), require('./api/CompanyAccessFunctionalityAddOnApi'), require('./api/CompanyAccessModuleApi'), require('./api/CompanyFunctionApi'), require('./api/CompanyLegalEntityApi'), require('./api/CompanyLegalEntityTypeApi'), require('./api/CompanySubscriptionReportApi'), require('./api/CompanyTemplateTypeApi'), require('./api/CompanyVirtualTeamApi'), require('./api/CompanyVirtualTeamMemberApi'), require('./api/CompetitorApi'), require('./api/ContentWatchSettingsApi'), require('./api/CorporateStructureFilterApi'), require('./api/CorporateStructureLinkApi'), require('./api/CorporateStructureLinkReportApi'), require('./api/CorporateStructureSortModeApi'), require('./api/CountryApi'), require('./api/CustomerApi'), require('./api/DashboardGroupApi'), require('./api/DashboardPageApi'), require('./api/DashboardPageBlockApi'), require('./api/DashboardPageBlockBubbleSettingsApi'), require('./api/DashboardPageBlockCartesianAxisApi'), require('./api/DashboardPageBlockCartesianSerieApi'), require('./api/DashboardPageBlockCartesianSerieGroupingApi'), require('./api/DashboardPageBlockCartesianSerieMilestoneApi'), require('./api/DashboardPageBlockCartesianSerieTypeApi'), require('./api/DashboardPageBlockCommentApi'), require('./api/DashboardPageBlockComparisonBarSerieApi'), require('./api/DashboardPageBlockComparisonBarSerieTypeApi'), require('./api/DashboardPageBlockComparisonColumnSerieApi'), require('./api/DashboardPageBlockComparisonColumnSerieTypeApi'), require('./api/DashboardPageBlockCustomTableColumnApi'), require('./api/DashboardPageBlockCustomTableColumnDefaultFilterApi'), require('./api/DashboardPageBlockCustomTableGraphSerieTypeApi'), require('./api/DashboardPageBlockCustomTableQueryApi'), require('./api/DashboardPageBlockExternalSettingsApi'), require('./api/DashboardPageBlockGoogleSheetSettingsApi'), require('./api/DashboardPageBlockMarketOverviewSettingsApi'), require('./api/DashboardPageBlockMilestoneApi'), require('./api/DashboardPageBlockNewsfeedApi'), require('./api/DashboardPageBlockNumberSerieApi'), require('./api/DashboardPageBlockPieSerieApi'), require('./api/DashboardPageBlockPollSettingsApi'), require('./api/DashboardPageBlockPowerBIEmbedApi'), require('./api/DashboardPageBlockSerieOrderApi'), require('./api/DashboardPageBlockSolidGaugeSerieApi'), require('./api/DashboardPageBlockStrategicActionApi'), require('./api/DashboardPageBlockStrategicActionViewTypeApi'), require('./api/DashboardPageBlockStrategyApi'), require('./api/DashboardPageBlockTableComparisonColumnApi'), require('./api/DashboardPageBlockTableComparisonRowApi'), require('./api/DashboardPageBlockTableDataColumnApi'), require('./api/DashboardPageBlockTableEmptyRowApi'), require('./api/DashboardPageBlockTableRollingComparisonApi'), require('./api/DashboardPageBlockTableSerieRowApi'), require('./api/DashboardPageBlockTableSerieRowExpandedIndicatorApi'), require('./api/DashboardPageBlockTableSumColumnApi'), require('./api/DashboardPageBlockTemplateApi'), require('./api/DashboardPageBlockTypeApi'), require('./api/DashboardPageHomeSettingsApi'), require('./api/DashboardPageTemplateApi'), require('./api/DashboardPageUserAccessApi'), require('./api/DashboardShareBatchApi'), require('./api/DecisionApi'), require('./api/DecisionPollApi'), require('./api/DecisionPollReplyOptionTypeApi'), require('./api/DecisionPollRespondentApi'), require('./api/DecisionPollTypeApi'), require('./api/DecisionTopicApi'), require('./api/DecisionTopicCommentApi'), require('./api/DecisionTopicPhaseApi'), require('./api/DecisionTopicTypeApi'), require('./api/DecisionTrackingTypeApi'), require('./api/DialogDistributionChannelApi'), require('./api/DialogFlowLogicGateMatchRuleApi'), require('./api/DialogFlowLogicGateValueSourceApi'), require('./api/DialogFlowMultiOptionDataSourceApi'), require('./api/DialogFlowSessionApi'), require('./api/DialogFlowTemplateApi'), require('./api/DialogFlowTemplateMessageApi'), require('./api/DialogFlowTemplateMessageConversionRuleApi'), require('./api/DialogFlowTemplateMessageOptionApi'), require('./api/DialogFlowTemplateMessageTypeApi'), require('./api/DialogScheduleBatchApi'), require('./api/DialogScheduleFlowApi'), require('./api/DialogScheduleRhytmApi'), require('./api/DialogScheduleSettingsApi'), require('./api/DialogScheduleUserApi'), require('./api/ERPAccountListApi'), require('./api/ERPAdminCostDivisionRuleApi'), require('./api/ERPAdminCostDivisionRuleFixedRuleApi'), require('./api/ERPAdminCostDivisionRuleFromAccountApi'), require('./api/ERPAdminCostDivisionRuleLevelApi'), require('./api/ERPAdminCostDivisionRuleSourceFilterApi'), require('./api/ERPAdminCostDivisionTypeApi'), require('./api/ERPCorporateAccountApi'), require('./api/ERPDimensionMappingApi'), require('./api/ERPDimensionSyncSettingApi'), require('./api/ERPDimensionSyncTypeApi'), require('./api/ERPFinancialAdvisorySettingsApi'), require('./api/ERPFinancialCalculationErrorApi'), require('./api/ERPFivaldiIntegrationSettingsApi'), require('./api/ERPNetvisorIntegrationLockPeriodApi'), require('./api/ERPNetvisorIntegrationSettingsApi'), require('./api/ERPProcountorIntegrationSettingsApi'), require('./api/ERPSyncCustomerApi'), require('./api/ERPSyncProductApi'), require('./api/EntityChangeApi'), require('./api/FinancialIndicatorApi'), require('./api/ForecastModelApi'), require('./api/ForecastModelAggregationLevelApi'), require('./api/ForecastModelDataEntryApi'), require('./api/ForecastModelDataEntryCustomIndicatorApi'), require('./api/ForecastModelDataEntryStatusApi'), require('./api/ForecastModelDataEntryTypeApi'), require('./api/ForecastModelRecordDataApi'), require('./api/ForecastModelRecordDataActualSplitRangeApi'), require('./api/ForecastModelRecordDataFileApi'), require('./api/ForecastModelRecordDataImportPeriodTypeApi'), require('./api/ForesightScenarioApi'), require('./api/ForesightScenarioBaselineCalculationApi'), require('./api/ForesightScenarioElementApi'), require('./api/ForesightScenarioElementTypeApi'), require('./api/ForesightScenarioFactorApi'), require('./api/ForesightScenarioLevelApi'), require('./api/ForesightScenarioNotificationRecipientApi'), require('./api/FrontendErrorReportApi'), require('./api/GeneralSettingsApi'), require('./api/GeoAreaApi'), require('./api/GoalMetricApi'), require('./api/GoalMetricValueSourceApi'), require('./api/GoalMetricValueTypeApi'), require('./api/GoogleAnalyticsSettingsApi'), require('./api/GoogleOAuthUserApi'), require('./api/InsightApi'), require('./api/InsightDefaultExcludedDomainApi'), require('./api/InsightImageApi'), require('./api/InsightReactionLinkApi'), require('./api/InsightReactionTypeApi'), require('./api/InsightTypeApi'), require('./api/IntegrationDataMappingDimensionApi'), require('./api/IntegrationDataMappingMatchRuleApi'), require('./api/IntegrationDataMappingRuleApi'), require('./api/IntegrationDataMappingSourceApi'), require('./api/IntegrationFinancialUploadBatchApi'), require('./api/IntegrationPipedriveSettingsApi'), require('./api/IntegrationPipedriveSettingsPipelineApi'), require('./api/IntegrationPipedriveSettingsPipelineStageApi'), require('./api/IntegrationSettingsNetvisorSyncDefaultHandleTypeApi'), require('./api/IntegrationSourceApi'), require('./api/IntegrationSourceCompanyStatusApi'), require('./api/InvoicingDataApi'), require('./api/InvoicingDataPreviewReportApi'), require('./api/LastFinancialPeriodTypeApi'), require('./api/LemonsoftIntegrationSettingsApi'), require('./api/LivingStrategyDashboardReportApi'), require('./api/MapRegionApi'), require('./api/MarketApi'), require('./api/MarketFeedBingCognitiveApi'), require('./api/MarketFreeNodeApi'), require('./api/MarketPlayerTypeApi'), require('./api/MarketRSSWatchSettingApi'), require('./api/MarketRSSWatchSettingFeedDataApi'), require('./api/MarketRSSWatchSettingReportApi'), require('./api/MarketScopeTypeApi'), require('./api/MarketSearchTemplateReportApi'), require('./api/MasterSearchReportApi'), require('./api/MasterSearchUserInputApi'), require('./api/MeetingApi'), require('./api/MeetingAdministratorApi'), require('./api/MeetingInvitationPeriodTypeApi'), require('./api/MeetingMinutesApi'), require('./api/MeetingMinutesContentTypeApi'), require('./api/MeetingParticipantApi'), require('./api/MeetingSectionApi'), require('./api/MeetingSectionContentTypeApi'), require('./api/MeetingSectionTextTopicApi'), require('./api/MeetingSectionTopicApi'), require('./api/MeetingSectionTopicAttachmentApi'), require('./api/MeetingSectionTopicCommentApi'), require('./api/MeetingSectionTopicLinkApi'), require('./api/MeetingStatusApi'), require('./api/MeetingTemplateApi'), require('./api/MeetingTemplateAdministratorApi'), require('./api/MeetingTemplateParticipantApi'), require('./api/MeetingTemplateSectionApi'), require('./api/MeetingTemplateSectionTextTopicApi'), require('./api/MeetingTemplateSectionTopicApi'), require('./api/MeetingTemplateSectionTopicLinkApi'), require('./api/MicrosoftTeamsBotLinkedConversationApi'), require('./api/MobileClientTokenApi'), require('./api/NewsEntryApi'), require('./api/NewsEntryAutomatedSourceApi'), require('./api/NewsEntryCategoryApi'), require('./api/NewsEntryCommentApi'), require('./api/NewsEntryContributorApi'), require('./api/NewsEntryEntryStatusApi'), require('./api/NewsEntryInsightLinkApi'), require('./api/NewsEntrySourceApi'), require('./api/NewsEntrySourceCategoryApi'), require('./api/NewsEntrySourceReportApi'), require('./api/NewsEntrySourceTypeApi'), require('./api/NewsEntryUserStatusApi'), require('./api/NotificationReportApi'), require('./api/NotificationSendingTimeTypeApi'), require('./api/NotificationTypeApi'), require('./api/OpencorporatesOrganizationApi'), require('./api/OrganizationApi'), require('./api/OrganizationClassificationTypeApi'), require('./api/OtherPlayerApi'), require('./api/PartnerApi'), require('./api/PartnerClientCompanyApi'), require('./api/PartnerClientCompanyEventTypeApi'), require('./api/PartnerClientCompanyTypeApi'), require('./api/PartnerSupportLevelApi'), require('./api/PerformanceIndicatorApi'), require('./api/PerformanceIndicatorCalculationRangeApi'), require('./api/PerformanceIndicatorCollectionTypeApi'), require('./api/PerformanceIndicatorComparisonCalculationApi'), require('./api/PerformanceIndicatorComparisonTargetApi'), require('./api/PerformanceIndicatorConversationApi'), require('./api/PerformanceIndicatorDateRangeApi'), require('./api/PerformanceIndicatorDayDataApi'), require('./api/PerformanceIndicatorDimensionApi'), require('./api/PerformanceIndicatorFormulaApi'), require('./api/PerformanceIndicatorFormulaElementTypeApi'), require('./api/PerformanceIndicatorGroupApi'), require('./api/PerformanceIndicatorMonthDataApi'), require('./api/PerformanceIndicatorPeriodTypeApi'), require('./api/PerformanceIndicatorPointCalculationApi'), require('./api/PerformanceIndicatorPollBatchApi'), require('./api/PerformanceIndicatorPollBatchUserApi'), require('./api/PerformanceIndicatorPollGeneralResponseApi'), require('./api/PerformanceIndicatorPollSettingsApi'), require('./api/PerformanceIndicatorPollStatusApi'), require('./api/PerformanceIndicatorPollValueAggregationTypeApi'), require('./api/PerformanceIndicatorPollValueTypeApi'), require('./api/PerformanceIndicatorQuarterDataApi'), require('./api/PerformanceIndicatorRelativePeriodApi'), require('./api/PerformanceIndicatorSystemTypeApi'), require('./api/PerformanceIndicatorValueDependencyRuleApi'), require('./api/PerformanceIndicatorValueSourceApi'), require('./api/PerformanceIndicatorWeekDataApi'), require('./api/PerformanceIndicatorYearDataApi'), require('./api/PerformanceManagementAlertApi'), require('./api/PerformanceManagementAlertActivityStatusApi'), require('./api/PerformanceManagementAlertDashboardBlockApi'), require('./api/PerformanceManagementAlertDashboardBlockCommentApi'), require('./api/PerformanceManagementAlertDeliveryChannelApi'), require('./api/PerformanceManagementAlertEmailTitleTypeApi'), require('./api/PerformanceManagementAlertIndicatorApi'), require('./api/PerformanceManagementAlertRecipientApi'), require('./api/PerformanceManagementAlertReviewSectionApi'), require('./api/PerformanceManagementAlertReviewSectionCommentApi'), require('./api/PerformanceManagementAlertScoreApi'), require('./api/PerformanceManagementAlertTriggerIndicatorApi'), require('./api/PerformanceManagementAlertTriggerTypeApi'), require('./api/PerformancePerspectiveApi'), require('./api/PerformancePerspectiveGroupApi'), require('./api/PersonalTopicApi'), require('./api/PollReportApi'), require('./api/PollSettingsScaleApi'), require('./api/PowerBITokenApi'), require('./api/ProductApi'), require('./api/PublicExternalLinkApi'), require('./api/QuickStartApi'), require('./api/RawDataMappingApi'), require('./api/RawDataMappingColumnApi'), require('./api/RawDataMappingColumnDataTypeApi'), require('./api/RawDataMappingRuleApi'), require('./api/RawDataRowApi'), require('./api/RawDataSourceApi'), require('./api/RawDataSourceStatusApi'), require('./api/RelativeDateTypeApi'), require('./api/SIEUploadQueueApi'), require('./api/SWOTAreaApi'), require('./api/SWOTInboxApi'), require('./api/SWOTSessionApi'), require('./api/SWOTSessionParticipantApi'), require('./api/SWOTTopicApi'), require('./api/SWOTTopicCommentApi'), require('./api/SWOTTopicVoteApi'), require('./api/SWOTTopicVoteBatchApi'), require('./api/SessionInformationApi'), require('./api/SeveraIntegrationSettingsApi'), require('./api/SheetConfigurationApi'), require('./api/SheetConfigurationForecastDownloadFromSheetRuleApi'), require('./api/SheetConfigurationForecastUploadToSheetRuleApi'), require('./api/SheetExcelConfigurationApi'), require('./api/SheetExcelGenerationIndicatorDepthRuleApi'), require('./api/SheetExcelGenerationValueWriteRuleApi'), require('./api/SheetForecastApi'), require('./api/SheetForecastFileApi'), require('./api/SheetForecastFileStatusApi'), require('./api/SheetForecastFileTypeApi'), require('./api/SheetForecastFileUserAccessApi'), require('./api/SheetForecastInputMethodApi'), require('./api/SheetForecastNotificationApi'), require('./api/SheetForecastRelatedSheetApi'), require('./api/SheetGoogleConfigurationApi'), require('./api/SheetGoogleTemplateCopiedRangeValueTypeApi'), require('./api/StakeholderApi'), require('./api/StakeholderBenchmarkApi'), require('./api/StakeholderBenchmarkCustomItemApi'), require('./api/StakeholderBenchmarkDimensionApi'), require('./api/StakeholderBenchmarkDimensionValueApi'), require('./api/StakeholderBenchmarkTemplateApi'), require('./api/StakeholderCommentApi'), require('./api/StakeholderMarketPositioningMapViewApi'), require('./api/StakeholderMarketPositioningMapViewCustomItemApi'), require('./api/StakeholderMarketPositioningMapViewPositionApi'), require('./api/StakeholderMarketPositioningMapViewTemplateApi'), require('./api/StakeholderNewsEntryAutomatedSourceApi'), require('./api/StakeholderNewsWatchFilterLevelApi'), require('./api/StakeholderTypeApi'), require('./api/StrategicGoalApi'), require('./api/StrategicGoalCriticalSuccessFactorApi'), require('./api/StrategicGoalMilestoneApi'), require('./api/StrategicGoalMilestoneAchievabilityApi'), require('./api/StrategicGoalMilestoneCommentApi'), require('./api/StrategicGoalMilestoneFinalStatusApi'), require('./api/StrategicGoalMilestoneSecondaryOwnerApi'), require('./api/StrategicGoalMilestoneSecondaryStatusUpdateApi'), require('./api/StrategicGoalMilestoneStatusApi'), require('./api/StrategicGoalMilestoneStatusUpdateApi'), require('./api/StrategicGoalMilestoneTeamLinkApi'), require('./api/StrategicProgramApi'), require('./api/StrategicProgramCommentApi'), require('./api/StrategicProgramConnectionApi'), require('./api/StrategicProgramFinalStatusApi'), require('./api/StrategicProgramRiskLevelApi'), require('./api/StrategicProgramSecondaryOwnerApi'), require('./api/StrategicProgramStatusApi'), require('./api/StrategicProgramStatusUpdateApi'), require('./api/StrategicProgramStatusUpdateRecipientApi'), require('./api/StrategicProgramUpdateFrequencyApi'), require('./api/StrategyDescriptionApi'), require('./api/StrategyDescriptionAdministratorApi'), require('./api/StrategyDescriptionExternalLinkApi'), require('./api/StrategyDescriptionParticipatorApi'), require('./api/StrategyDescriptionPerformanceIndicatorApi'), require('./api/StrategyDescriptionStatusApi'), require('./api/StrategyElementTypeApi'), require('./api/StrategyExecutionCustomEntityApi'), require('./api/StrategyExecutionCustomEntityDataApi'), require('./api/StrategyExecutionCustomFieldApi'), require('./api/StrategyExecutionCustomFieldLinkApi'), require('./api/StrategyExecutionCustomFieldOptionApi'), require('./api/StrategyExecutionCustomFieldTypeApi'), require('./api/StrategyExecutionSecondaryStatusUpdateTypeApi'), require('./api/StrategyExecutionTypeApi'), require('./api/StrategyFreeNodeApi'), require('./api/StrategyHealthReportApi'), require('./api/StrategyNamingTypeApi'), require('./api/StrategyPageBlockApi'), require('./api/StrategyPageBlockTypeApi'), require('./api/StrategyPageMemoBlockApi'), require('./api/StrategyProcessApi'), require('./api/StrategyProcessPhaseApi'), require('./api/StrategyProcessPhaseContentApi'), require('./api/StrategyProcessSubthemeApi'), require('./api/StrategyProcessSubthemeLinkApi'), require('./api/StrategyProcessSubthemeTypeApi'), require('./api/StrategyProcessThemeApi'), require('./api/StrategyProgressCalculationMethodApi'), require('./api/StrategyProgressCalculationSourceApi'), require('./api/StrategyPublishingLevelApi'), require('./api/StrategyPublishingTypeApi'), require('./api/StrategySavedViewApi'), require('./api/StrategySelectionApi'), require('./api/StrategyTaxonomyApi'), require('./api/SupplierApi'), require('./api/SystemLanguageApi'), require('./api/SystemRegisterDataSourceApi'), require('./api/SystemUserRoleApi'), require('./api/SystemUserTypeApi'), require('./api/TrackingLevelApi'), require('./api/TrackingLevelItemApi'), require('./api/TrendCategoryApi'), require('./api/TrendScopeApi'), require('./api/TrendSettingsApi'), require('./api/TrendTopicApi'), require('./api/TrendTopicCommentApi'), require('./api/TrendTopicTypeApi'), require('./api/UserApi'), require('./api/UserActivityItemApi'), require('./api/UserActivityReportApi'), require('./api/UserCompanyAccessApi'), require('./api/UserCompanyFunctionalityAccessApi'), require('./api/UserDataVisibilityFunctionApi'), require('./api/UserDataVisibilityLegalEntityApi'), require('./api/UserDataVisibilityProductApi'), require('./api/UserDataVisibilitySettingsApi'), require('./api/UserEngagementActionApi'), require('./api/UserFeedbackReportApi'), require('./api/UserFunctionalityAccessReportApi'), require('./api/UserInterfaceTextApi'), require('./api/UserInterfaceTranslationLanguageApi'), require('./api/UserListDataReportApi'), require('./api/UserLocalApi'), require('./api/UserNotificationEventSourceApi'), require('./api/UserNotificationUserSettingsApi'), require('./api/UserPartnerAccessApi'), require('./api/UserRoleApi'), require('./api/UserRoleBillingUserTypeApi'), require('./api/UserRoleProductApi'), require('./api/UserSyncExcelSettingsApi'), require('./api/UserTrackingLevelLinkApi'), require('./api/VATPeriodTypeApi'), require('./api/WorkshopApi'), require('./api/WorkshopBackgroundImageApi'), require('./api/WorkshopCanvasItemApi'), require('./api/WorkshopCanvasItemTypeApi'), require('./api/WorkshopExternalContentTypeApi'), require('./api/WorkshopItemApi'), require('./api/WorkshopItemCategoryApi'), require('./api/WorkshopItemCategoryConnectionApi'), require('./api/WorkshopItemHistoryApi'), require('./api/WorkshopItemRatingApi'), require('./api/WorkshopItemRatingHistoryApi'), require('./api/WorkshopParticipantApi'), require('./api/WorkshopParticipantRoleApi'), require('./api/WorkshopPhaseApi'), require('./api/WorkshopPhaseComparisonAxisApi'), require('./api/WorkshopPhaseComparisonDimensionApi'), require('./api/WorkshopPhaseContentCreationRuleApi'), require('./api/WorkshopPhaseContentRowApi'), require('./api/WorkshopPhaseContentRowLayoutApi'), require('./api/WorkshopPhaseGridBlockApi'), require('./api/WorkshopPhaseParticipantRoleApi'), require('./api/WorkshopPrioritizationVotingTypeApi'), require('./api/WorkshopQuestionnaireFilterApi'), require('./api/WorkshopQuestionnaireOptionApi'), require('./api/WorkshopQuestionnaireQuestionApi'), require('./api/WorkshopQuestionnaireQuestionTypeApi'), require('./api/WorkshopQuestionnaireResponseApi'), require('./api/WorkshopRatingPhaseCategoryWeightApi'), require('./api/WorkshopRatingPhaseSourceApi'), require('./api/WorkshopRatingPhaseWeightedLevelApi'), require('./api/WorkshopResultPhaseSourceApi'), require('./api/WorkshopResultPresentationTypeApi'), require('./api/WorkshopVersionHistoryChangeTypeApi'), require('./api/WorkshopVideoCallApi'), require('./api/WorkshopWidgetApi'), require('./api/WorkshopWidgetIdeaGenerationThemeApi'), require('./api/WorkshopWidgetParticipantStatusApi'), require('./api/WorkshopWidgetStatusApi'), require('./api/WorkshopWidgetTypeApi'), require('./api/WorkspaceMindmapApi'), require('./api/WorkspaceMindmapNodeApi'), require('./api/WorkspaceMindmapNodeTypeApi'));
  }
}(function(ApiClient, AccessFunctionality, AccessFunctionalityAddOn, AccessModule, AccessProfile, AccessType, AccountingData, AccountingDataPaginationSlice, AccountingDataPreviewReport, AgendaFlag, AgendaTheme, AgendaTimeReservation, AgendaTimeSerieEvent, AgendaTimeSerieRule, AgendaTimeSerieRuleReport, AnalysisCategory, AutomatedSourceGeneratedNews, BingCognitiveItem, BingCognitiveSearchData, BisnodeFinancialIndicatorValue, BusinessModel, BusinessModelArea, BusinessModelCanvasArea, BusinessModelCanvasItem, BusinessModelCanvasItemType, BusinessModelReport, BusinessReviewExcludedSection, BusinessReviewSchedule, BusinessReviewSectionType, BusinessReviewSession, BusinessReviewSessionPaginationSlice, BusinessReviewSessionStatus, BusinessReviewStatus, BusinessReviewStep, BusinessReviewStepElementSide, BusinessReviewTemplate, BusinessReviewTemplateReport, BusinessReviewUserSettings, BusinessSimulatorCashflowAccountReceivablesDistribution, BusinessSimulatorCashflowCapitalItem, BusinessSimulatorCashflowCapitalItemGroup, BusinessSimulatorCashflowCapitalItemValue, BusinessSimulatorCashflowCapitalItemValuePaginationSlice, BusinessSimulatorCashflowSalesReceivablesDistribution, CashflowForecastDataReport, CashflowForecastIndicatorConnection, CashflowForecastIndicatorConnectionReport, CashflowForecastIndicatorDistributionEntry, CashflowForecastSettings, CashflowForecastSettingsReport, CategoryReport, Company, CompanyAccessFunctionalityAddOn, CompanyAccessModule, CompanyFunction, CompanyLegalEntity, CompanyLegalEntityType, CompanyResponsiblePerson, CompanyResponsiblePersonConnection, CompanySubscriptionReport, CompanySubscriptionServiceLevel, CompanyTemplateType, CompanyUserServiceLevelBase, CompanyVirtualTeam, CompanyVirtualTeamMember, ContentWatchSettings, ContentWatchSettingsPaginationSlice, CorporateStructureFilter, CorporateStructureLink, CorporateStructureLinkReport, CorporateStructureSortMode, Country, Customer, DashboardGroup, DashboardGroupLightReport, DashboardPage, DashboardPageBlock, DashboardPageBlockBubbleSettings, DashboardPageBlockCartesianAxis, DashboardPageBlockCartesianSerie, DashboardPageBlockCartesianSerieGrouping, DashboardPageBlockCartesianSerieMilestone, DashboardPageBlockCartesianSerieReport, DashboardPageBlockCartesianSerieType, DashboardPageBlockComment, DashboardPageBlockCommentPaginationSlice, DashboardPageBlockComparisonBarSerie, DashboardPageBlockComparisonBarSerieType, DashboardPageBlockComparisonColumnSerie, DashboardPageBlockComparisonColumnSerieType, DashboardPageBlockCustomTableColumn, DashboardPageBlockCustomTableColumnDefaultFilter, DashboardPageBlockCustomTableGraphSerieType, DashboardPageBlockCustomTableQuery, DashboardPageBlockExternalSettings, DashboardPageBlockGoogleSheetSettings, DashboardPageBlockImage, DashboardPageBlockLightReport, DashboardPageBlockMarketOverviewSettings, DashboardPageBlockMilestone, DashboardPageBlockNewsfeed, DashboardPageBlockNumberSerie, DashboardPageBlockPieSerie, DashboardPageBlockPollSettings, DashboardPageBlockPowerBIEmbed, DashboardPageBlockReport, DashboardPageBlockReportNestedPaginationSlice, DashboardPageBlockReportPaginationSlice, DashboardPageBlockSerieOrder, DashboardPageBlockSolidGaugeSerie, DashboardPageBlockStrategicAction, DashboardPageBlockStrategicActionViewType, DashboardPageBlockStrategy, DashboardPageBlockTableComparisonColumn, DashboardPageBlockTableComparisonRow, DashboardPageBlockTableDataColumn, DashboardPageBlockTableEmptyRow, DashboardPageBlockTableRollingComparison, DashboardPageBlockTableSerieRow, DashboardPageBlockTableSerieRowExpandedIndicator, DashboardPageBlockTableSerieRowReport, DashboardPageBlockTableSumColumn, DashboardPageBlockTemplate, DashboardPageBlockType, DashboardPageExportSettings, DashboardPageHomeSettings, DashboardPageLightReport, DashboardPageReport, DashboardPageTemplate, DashboardPageUserAccess, DashboardShareBatchBlock, DashboardShareBatchReport, Decision, DecisionPoll, DecisionPollReplyOptionTypeOption, DecisionPollReplyOptionTypeReport, DecisionPollReport, DecisionPollRespondent, DecisionPollType, DecisionReport, DecisionTopicComment, DecisionTopicCommentPaginationSlice, DecisionTopicPhase, DecisionTopicReport, DecisionTopicSuggestionSearchItem, DecisionTopicType, DecisionTrackingType, DialogDistributionChannel, DialogFlowLogicGateMatchRule, DialogFlowLogicGateValueSource, DialogFlowMultiOptionDataSource, DialogFlowSession, DialogFlowTemplate, DialogFlowTemplateMessage, DialogFlowTemplateMessageConversionRule, DialogFlowTemplateMessageOption, DialogFlowTemplateMessageReport, DialogFlowTemplateMessageType, DialogFlowTemplateReport, DialogScheduleBatch, DialogScheduleBatchReport, DialogScheduleFlow, DialogScheduleRhytm, DialogScheduleSettings, DialogScheduleSettingsReport, DialogScheduleUser, ERPAccountList, ERPAdminCostDivisionRule, ERPAdminCostDivisionRuleFixedRule, ERPAdminCostDivisionRuleFromAccount, ERPAdminCostDivisionRuleLevel, ERPAdminCostDivisionRuleReport, ERPAdminCostDivisionRuleSourceFilter, ERPAdminCostDivisionType, ERPCorporateAccount, ERPDimensionMapping, ERPDimensionSyncSetting, ERPDimensionSyncType, ERPFinancialAdvisorySettings, ERPFinancialCalculationError, ERPFivaldiIntegrationSettings, ERPNetvisorIntegrationLockPeriod, ERPNetvisorIntegrationSettings, ERPProcountorIntegrationSettings, ERPSyncCustomer, ERPSyncCustomerMonthData, ERPSyncCustomerReport, ERPSyncCustomerReportERPSyncItemPaginationSlice, ERPSyncProduct, ERPSyncProductMonthData, ERPSyncProductReport, ERPSyncProductReportERPSyncItemPaginationSlice, EntityChange, ExternalSourceLightSpreadsheet, ExternalSourceLightSpreadsheetSheet, FileTransferHelperEntity, FinancialBatchPreviewReport, FinancialIndicator, FinancialIndicatorDataFilter, FinancialIndicatorDataReport, FinancialIndicatorValueBase, FinancialsAndDecisionMakers, FinancialsFiscalReport, ForecastModel, ForecastModelAggregationLevel, ForecastModelAggregationLevelReport, ForecastModelAggregationReport, ForecastModelDataEntry, ForecastModelDataEntryCustomIndicator, ForecastModelDataEntryStatus, ForecastModelDataEntryType, ForecastModelRecordData, ForecastModelRecordDataActualSplitRange, ForecastModelRecordDataFile, ForecastModelRecordDataFileReport, ForecastModelRecordDataImportPeriodType, ForecastModelRecordDataReport, ForecastModelRecordDataTransferLog, ForecastModelReport, ForesightScenario, ForesightScenarioBaselineCalculation, ForesightScenarioElement, ForesightScenarioElementReport, ForesightScenarioElementType, ForesightScenarioFactor, ForesightScenarioLevel, ForesightScenarioLevelReport, ForesightScenarioNotificationRecipient, ForesightScenarioReport, FrontendErrorReport, GeneralSettings, GeoArea, GoalMetric, GoalMetricReport, GoalMetricReportPaginationSlice, GoalMetricValueSource, GoalMetricValueType, GoogleAnalyticsAccount, GoogleAnalyticsProfile, GoogleAnalyticsProperty, GoogleAnalyticsSettings, GoogleOAuthUser, GroupCount, HeaderColumn, ImportAccountingActualsFileRequest, InputValidationFeedback, Insight, InsightCompanyData, InsightDefaultExcludedDomain, InsightFilter, InsightImage, InsightLinkReport, InsightReactionLink, InsightReactionType, InsightReport, InsightTaggedUser, InsightType, IntegrationDataMappingDimension, IntegrationDataMappingMatchRule, IntegrationDataMappingRule, IntegrationDataMappingSource, IntegrationFinancialUploadBatch, IntegrationFinancialUploadBatchExcelFile, IntegrationFinancialUploadBatchFileReport, IntegrationPipedriveSettings, IntegrationPipedriveSettingsPipeline, IntegrationPipedriveSettingsPipelineReport, IntegrationPipedriveSettingsPipelineReportPaginationSlice, IntegrationPipedriveSettingsPipelineStage, IntegrationPipedriveSettingsPipelineStagePaginationSlice, IntegrationPipedriveSettingsReport, IntegrationSettingsNetvisorSyncDefaultHandleType, IntegrationSource, IntegrationSourceCompanyStatus, InvoicingDataLightReport, InvoicingDataLightReportPaginationSlice, InvoicingDataPreviewReport, InvoicingDataReceivableReport, InvoicingDataReceivableReportPaginationSlice, LSDStrategyProgressReport, LastFinancialPeriodType, LemonsoftIntegrationSettings, LivingStrategyDashboardReport, MapDataReport, MapRegionDataReport, Market, MarketFeedBingCognitive, MarketFreeNode, MarketRSSWatchSetting, MarketRSSWatchSettingFeedData, MarketRSSWatchSettingReport, MarketScopeType, MarketSearchTemplateQuery, MarketSearchTemplateReport, MasterSearchReport, MasterSearchReportItem, MasterSearchUserInput, Meeting, MeetingAdministrator, MeetingInvitationPeriodType, MeetingMinutesContentType, MeetingMinutesReport, MeetingMinutesSignature, MeetingParticipant, MeetingReport, MeetingSection, MeetingSectionContentType, MeetingSectionReport, MeetingSectionReportPaginationSlice, MeetingSectionTextTopic, MeetingSectionTopic, MeetingSectionTopicAttachment, MeetingSectionTopicComment, MeetingSectionTopicCommentPaginationSlice, MeetingSectionTopicLink, MeetingSectionTopicReport, MeetingStatus, MeetingTemplate, MeetingTemplateAdministrator, MeetingTemplateParticipant, MeetingTemplateReport, MeetingTemplateSection, MeetingTemplateSectionReport, MeetingTemplateSectionTextTopic, MeetingTemplateSectionTopic, MeetingTemplateSectionTopicLink, MeetingTemplateSectionTopicReport, MicrosoftTeamsBotLinkedConversation, MobileClientToken, NewsEntry, NewsEntryAutomatedSource, NewsEntryCategory, NewsEntryComment, NewsEntryCommentPaginationSlice, NewsEntryCommentReport, NewsEntryCommentReportPaginationSlice, NewsEntryContributor, NewsEntryContributorPaginationSlice, NewsEntryEntryStatus, NewsEntryFilter, NewsEntryFullReport, NewsEntryFullReportNewsEntryReportPaginationSlice, NewsEntryInsightLink, NewsEntryLightReport, NewsEntryLightReportNewsEntryReportPaginationSlice, NewsEntrySourceCategory, NewsEntrySourceReport, NewsEntrySourceReportPaginationSlice, NewsEntrySourceType, NewsEntryUserStatus, NotificationFilter, NotificationGroupCount, NotificationReport, NotificationReportPaginationSlice, NotificationSendingTimeType, NotificationType, OpencorporatesOrganization, OpencorporatesOrganizationPaginationSlice, Organization, OrganizationClassificationType, OrganizationIndexSearchResultExtended, OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport, OrganizationItemLight, OrganizationItemLightPaginationSlice, OrganizationPaginationSlice, PartnerClientCompany, PartnerClientCompanyEvent, PartnerClientCompanyEventType, PartnerClientCompanyReport, PartnerClientCompanyType, PartnerCompany, PartnerSupportLevel, PaymentDisturbance, PerformanceIndicator, PerformanceIndicatorAvailabilityReport, PerformanceIndicatorCalculationRange, PerformanceIndicatorCollectionType, PerformanceIndicatorComparisonCalculation, PerformanceIndicatorComparisonTarget, PerformanceIndicatorConversation, PerformanceIndicatorConversationReport, PerformanceIndicatorDataBase, PerformanceIndicatorDataCopySettings, PerformanceIndicatorDataExtrapolationSettings, PerformanceIndicatorDataFilter, PerformanceIndicatorDataReport, PerformanceIndicatorDateRange, PerformanceIndicatorDayData, PerformanceIndicatorDimension, PerformanceIndicatorDrillData, PerformanceIndicatorFormula, PerformanceIndicatorFormulaElementType, PerformanceIndicatorGroupReport, PerformanceIndicatorMonthData, PerformanceIndicatorPeriodType, PerformanceIndicatorPointCalculation, PerformanceIndicatorPollBatch, PerformanceIndicatorPollBatchPaginationSlice, PerformanceIndicatorPollBatchUserReport, PerformanceIndicatorPollBatchUserReportPaginationSlice, PerformanceIndicatorPollGeneralResponseReport, PerformanceIndicatorPollGeneralResponseReportPaginationSlice, PerformanceIndicatorPollSettings, PerformanceIndicatorPollSettingsLightReport, PerformanceIndicatorPollStatus, PerformanceIndicatorPollValueAggregationType, PerformanceIndicatorPollValueType, PerformanceIndicatorQuarterData, PerformanceIndicatorRelativePeriod, PerformanceIndicatorReport, PerformanceIndicatorSystemType, PerformanceIndicatorValueDependencyRule, PerformanceIndicatorValueSource, PerformanceIndicatorWeekData, PerformanceIndicatorYearData, PerformanceManagementAlert, PerformanceManagementAlertActivityStatus, PerformanceManagementAlertDashboardBlock, PerformanceManagementAlertDashboardBlockComment, PerformanceManagementAlertDashboardBlockReport, PerformanceManagementAlertDeliveryChannel, PerformanceManagementAlertEmailTitleType, PerformanceManagementAlertIndicator, PerformanceManagementAlertRecipient, PerformanceManagementAlertReport, PerformanceManagementAlertReportNestedPaginationSlice, PerformanceManagementAlertReviewSection, PerformanceManagementAlertReviewSectionComment, PerformanceManagementAlertReviewSectionReport, PerformanceManagementAlertScore, PerformanceManagementAlertTriggerIndicator, PerformanceManagementAlertTriggerType, PerformancePerspective, PerformancePerspectiveGroup, PersonalTopic, PollReport, PollReportQuestion, PollReportQuestionMatrixAxis, PollReportQuestionMultipleNumericValue, PollReportQuestionScaleValue, PollResponse, PollSettingsScale, PowerBIEmbedToken, PowerBIItem, PowerBIToken, PowerBIWorkspace, Product, PublicExternalLink, QuickStartReport, QuickStartStep, QuickStartStepCategoryReport, RawDataColumn, RawDataMapping, RawDataMappingColumn, RawDataMappingColumnDataType, RawDataMappingReport, RawDataMappingRule, RawDataRowColumn, RawDataRowError, RawDataRowReport, RawDataRowReportPaginationSlice, RawDataSource, RawDataSourceReport, RawDataSourceStatus, RelativeDateType, Row, SIEUploadQueue, SWOTArea, SWOTInbox, SWOTSession, SWOTSessionParticipant, SWOTSessionReport, SWOTTopic, SWOTTopicComment, SWOTTopicCommentPaginationSlice, SWOTTopicReport, SWOTTopicVote, SWOTTopicVoteBatch, SWOTTopicVoteBatchReport, SWOTTopicVoteBatchReportPaginationSlice, SessionInformation, SeveraIntegrationSettingsReport, SheetConfiguration, SheetConfigurationForecastDownloadFromSheetRule, SheetConfigurationForecastUploadToSheetRule, SheetExcelConfiguration, SheetExcelGenerationIndicatorDepthRule, SheetExcelGenerationSettings, SheetExcelGenerationValueWriteRule, SheetForecast, SheetForecastAggregatedBudgetReport, SheetForecastFile, SheetForecastFileReport, SheetForecastFileStatus, SheetForecastFileType, SheetForecastFileUserAccess, SheetForecastInputMethod, SheetForecastNotificationRecipient, SheetForecastNotificationReport, SheetForecastRelatedSheet, SheetForecastReport, SheetGenerationSettings, SheetGenerationSettingsIndicator, SheetGoogleConfiguration, SheetGoogleTemplateCopiedRange, SheetGoogleTemplateCopiedRangeSettings, SheetGoogleTemplateCopiedRangeValueType, SpecialMenuItem, Stakeholder, StakeholderBenchmark, StakeholderBenchmarkCustomItem, StakeholderBenchmarkCustomItemPaginationSlice, StakeholderBenchmarkDimension, StakeholderBenchmarkDimensionReport, StakeholderBenchmarkDimensionReportPaginationSlice, StakeholderBenchmarkDimensionValue, StakeholderBenchmarkDimensionValuePaginationSlice, StakeholderBenchmarkReport, StakeholderBenchmarkTemplate, StakeholderComment, StakeholderCommentPaginationSlice, StakeholderMarketPositioningMapView, StakeholderMarketPositioningMapViewCustomItem, StakeholderMarketPositioningMapViewCustomItemPaginationSlice, StakeholderMarketPositioningMapViewPosition, StakeholderMarketPositioningMapViewPositionPaginationSlice, StakeholderMarketPositioningMapViewReport, StakeholderMarketPositioningMapViewTemplate, StakeholderNewsEntryAutomatedSource, StakeholderNewsWatchFilterLevel, StakeholderReport, StakeholderReportPaginationSlice, StakeholderType, StakeholderTypeReport, StrategicGoal, StrategicGoalCriticalSuccessFactor, StrategicGoalCriticalSuccessFactorReport, StrategicGoalMilestone, StrategicGoalMilestoneAchievability, StrategicGoalMilestoneComment, StrategicGoalMilestoneCommentPaginationSlice, StrategicGoalMilestoneFinalStatus, StrategicGoalMilestoneReport, StrategicGoalMilestoneSecondaryOwner, StrategicGoalMilestoneSecondaryStatusUpdate, StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice, StrategicGoalMilestoneStatus, StrategicGoalMilestoneStatusUpdate, StrategicGoalMilestoneStatusUpdatePaginationSlice, StrategicGoalMilestoneTeamLink, StrategicGoalReport, StrategicProgram, StrategicProgramComment, StrategicProgramCommentPaginationSlice, StrategicProgramConnection, StrategicProgramFinalStatus, StrategicProgramReport, StrategicProgramRiskLevel, StrategicProgramSecondaryOwner, StrategicProgramStatus, StrategicProgramStatusUpdate, StrategicProgramStatusUpdateRecipient, StrategicProgramStatusUpdateRecipientPaginationSlice, StrategicProgramStatusUpdateReport, StrategicProgramStatusUpdateReportPaginationSlice, StrategicProgramUpdateFrequency, StrategyBusinessReviewExportSettings, StrategyDescription, StrategyDescriptionAdministrator, StrategyDescriptionExternalLink, StrategyDescriptionParticipator, StrategyDescriptionPerformanceIndicator, StrategyDescriptionPerformanceIndicatorPaginationSlice, StrategyDescriptionReport, StrategyDescriptionStatus, StrategyElementType, StrategyExecutionCustomEntity, StrategyExecutionCustomEntityData, StrategyExecutionCustomField, StrategyExecutionCustomFieldLink, StrategyExecutionCustomFieldOption, StrategyExecutionCustomFieldReport, StrategyExecutionCustomFieldType, StrategyExecutionExportSettings, StrategyExecutionSecondaryStatusUpdateType, StrategyExecutionType, StrategyExportItemSettings, StrategyFreeNode, StrategyFreeNodeReport, StrategyHealthReport, StrategyNamingType, StrategyPageBlock, StrategyPageBlockType, StrategyPageMemoBlock, StrategyProcess, StrategyProcessPhase, StrategyProcessPhaseContent, StrategyProcessPhaseReport, StrategyProcessReport, StrategyProcessSubtheme, StrategyProcessSubthemeLink, StrategyProcessSubthemeReport, StrategyProcessSubthemeType, StrategyProcessTheme, StrategyProcessThemeReport, StrategyProgressCalculationMethod, StrategyProgressCalculationSource, StrategyPublishingLevel, StrategyPublishingType, StrategySavedView, StrategySelection, StrategySelectionReport, StrategyTaxonomy, SystemLanguage, SystemUserRole, SystemUserType, TrackingLevel, TrackingLevel1Item, TrackingLevel2Item, TrackingLevel3Item, TrackingLevel4Item, TrackingLevelItemBase, TranslationResource, TrendCategory, TrendScope, TrendSettings, TrendTopic, TrendTopicComment, TrendTopicCommentPaginationSlice, TrendTopicReport, TrendTopicType, User, UserActivityItem, UserActivityReport, UserCompanyAccess, UserCompanyAccessReport, UserCompanyFunctionalityAccess, UserDataVisibilityFunction, UserDataVisibilityLegalEntity, UserDataVisibilityProduct, UserDataVisibilitySettings, UserFeedbackReport, UserFunctionalityAccessReport, UserInterfaceText, UserInterfaceTranslationLanguage, UserListDataReport, UserLocal, UserNotificationEventSource, UserNotificationUserSettings, UserPartnerAccessReport, UserRole, UserRoleBillingUserType, UserRoleProduct, UserSyncExcelSettings, UserTrackingLevelLink, VATPeriodType, Workshop, WorkshopBackgroundImage, WorkshopCanvasItem, WorkshopCanvasItemType, WorkshopCloneSettings, WorkshopExternalContentType, WorkshopItem, WorkshopItemCategory, WorkshopItemCategoryConnection, WorkshopItemHistory, WorkshopItemRating, WorkshopItemRatingHistory, WorkshopParticipant, WorkshopParticipantRole, WorkshopPhase, WorkshopPhaseComparisonAxis, WorkshopPhaseComparisonDimension, WorkshopPhaseContentCreationRule, WorkshopPhaseContentRow, WorkshopPhaseContentRowLayout, WorkshopPhaseContentRowReport, WorkshopPhaseGridBlock, WorkshopPhaseParticipantRole, WorkshopPhaseReport, WorkshopPrioritizationVotingType, WorkshopQuestionnaireFilter, WorkshopQuestionnaireOption, WorkshopQuestionnaireQuestion, WorkshopQuestionnaireQuestionReport, WorkshopQuestionnaireQuestionType, WorkshopQuestionnaireResponse, WorkshopRatingPhaseCategoryWeight, WorkshopRatingPhaseSource, WorkshopRatingPhaseSourceReport, WorkshopRatingPhaseWeightedLevel, WorkshopReport, WorkshopResultPhaseSource, WorkshopResultPresentationType, WorkshopStrategyImportSettings, WorkshopVersionHistoryChangeType, WorkshopVideoCall, WorkshopWidget, WorkshopWidgetIdeaGenerationTheme, WorkshopWidgetIdeaGenerationThemeAnswer, WorkshopWidgetParticipantStatus, WorkshopWidgetReport, WorkshopWidgetStatus, WorkshopWidgetType, WorkspaceMindmap, WorkspaceMindmapNode, WorkspaceMindmapNodePaginationSlice, WorkspaceMindmapNodeType, WorkspaceMindmapReport, AccessFunctionalityApi, AccessFunctionalityAddOnApi, AccessModuleApi, AccessProfileApi, AccessTypeApi, AccountingDataApi, AccountingDataPreviewReportApi, AgendaFlagApi, AgendaThemeApi, AgendaTimeReservationApi, AgendaTimeSerieEventApi, AgendaTimeSerieRuleApi, AnalysisCategoryApi, BisnodeFinancialIndicatorValueApi, BusinessModelApi, BusinessModelAreaApi, BusinessModelCanvasAreaApi, BusinessModelCanvasItemApi, BusinessModelCanvasItemTypeApi, BusinessReviewExcludedSectionApi, BusinessReviewScheduleApi, BusinessReviewSectionTypeApi, BusinessReviewSessionApi, BusinessReviewSessionStatusApi, BusinessReviewStatusApi, BusinessReviewStepApi, BusinessReviewStepElementSideApi, BusinessReviewTemplateApi, BusinessReviewUserSettingsApi, BusinessSimulatorCashflowAccountReceivablesDistributionApi, BusinessSimulatorCashflowCapitalItemApi, BusinessSimulatorCashflowCapitalItemGroupApi, BusinessSimulatorCashflowCapitalItemValueApi, BusinessSimulatorCashflowSalesReceivablesDistributionApi, CashflowForecastIndicatorConnectionApi, CashflowForecastIndicatorDistributionEntryApi, CashflowForecastSettingsApi, CategoryApi, CompanyApi, CompanyAccessFunctionalityAddOnApi, CompanyAccessModuleApi, CompanyFunctionApi, CompanyLegalEntityApi, CompanyLegalEntityTypeApi, CompanySubscriptionReportApi, CompanyTemplateTypeApi, CompanyVirtualTeamApi, CompanyVirtualTeamMemberApi, CompetitorApi, ContentWatchSettingsApi, CorporateStructureFilterApi, CorporateStructureLinkApi, CorporateStructureLinkReportApi, CorporateStructureSortModeApi, CountryApi, CustomerApi, DashboardGroupApi, DashboardPageApi, DashboardPageBlockApi, DashboardPageBlockBubbleSettingsApi, DashboardPageBlockCartesianAxisApi, DashboardPageBlockCartesianSerieApi, DashboardPageBlockCartesianSerieGroupingApi, DashboardPageBlockCartesianSerieMilestoneApi, DashboardPageBlockCartesianSerieTypeApi, DashboardPageBlockCommentApi, DashboardPageBlockComparisonBarSerieApi, DashboardPageBlockComparisonBarSerieTypeApi, DashboardPageBlockComparisonColumnSerieApi, DashboardPageBlockComparisonColumnSerieTypeApi, DashboardPageBlockCustomTableColumnApi, DashboardPageBlockCustomTableColumnDefaultFilterApi, DashboardPageBlockCustomTableGraphSerieTypeApi, DashboardPageBlockCustomTableQueryApi, DashboardPageBlockExternalSettingsApi, DashboardPageBlockGoogleSheetSettingsApi, DashboardPageBlockMarketOverviewSettingsApi, DashboardPageBlockMilestoneApi, DashboardPageBlockNewsfeedApi, DashboardPageBlockNumberSerieApi, DashboardPageBlockPieSerieApi, DashboardPageBlockPollSettingsApi, DashboardPageBlockPowerBIEmbedApi, DashboardPageBlockSerieOrderApi, DashboardPageBlockSolidGaugeSerieApi, DashboardPageBlockStrategicActionApi, DashboardPageBlockStrategicActionViewTypeApi, DashboardPageBlockStrategyApi, DashboardPageBlockTableComparisonColumnApi, DashboardPageBlockTableComparisonRowApi, DashboardPageBlockTableDataColumnApi, DashboardPageBlockTableEmptyRowApi, DashboardPageBlockTableRollingComparisonApi, DashboardPageBlockTableSerieRowApi, DashboardPageBlockTableSerieRowExpandedIndicatorApi, DashboardPageBlockTableSumColumnApi, DashboardPageBlockTemplateApi, DashboardPageBlockTypeApi, DashboardPageHomeSettingsApi, DashboardPageTemplateApi, DashboardPageUserAccessApi, DashboardShareBatchApi, DecisionApi, DecisionPollApi, DecisionPollReplyOptionTypeApi, DecisionPollRespondentApi, DecisionPollTypeApi, DecisionTopicApi, DecisionTopicCommentApi, DecisionTopicPhaseApi, DecisionTopicTypeApi, DecisionTrackingTypeApi, DialogDistributionChannelApi, DialogFlowLogicGateMatchRuleApi, DialogFlowLogicGateValueSourceApi, DialogFlowMultiOptionDataSourceApi, DialogFlowSessionApi, DialogFlowTemplateApi, DialogFlowTemplateMessageApi, DialogFlowTemplateMessageConversionRuleApi, DialogFlowTemplateMessageOptionApi, DialogFlowTemplateMessageTypeApi, DialogScheduleBatchApi, DialogScheduleFlowApi, DialogScheduleRhytmApi, DialogScheduleSettingsApi, DialogScheduleUserApi, ERPAccountListApi, ERPAdminCostDivisionRuleApi, ERPAdminCostDivisionRuleFixedRuleApi, ERPAdminCostDivisionRuleFromAccountApi, ERPAdminCostDivisionRuleLevelApi, ERPAdminCostDivisionRuleSourceFilterApi, ERPAdminCostDivisionTypeApi, ERPCorporateAccountApi, ERPDimensionMappingApi, ERPDimensionSyncSettingApi, ERPDimensionSyncTypeApi, ERPFinancialAdvisorySettingsApi, ERPFinancialCalculationErrorApi, ERPFivaldiIntegrationSettingsApi, ERPNetvisorIntegrationLockPeriodApi, ERPNetvisorIntegrationSettingsApi, ERPProcountorIntegrationSettingsApi, ERPSyncCustomerApi, ERPSyncProductApi, EntityChangeApi, FinancialIndicatorApi, ForecastModelApi, ForecastModelAggregationLevelApi, ForecastModelDataEntryApi, ForecastModelDataEntryCustomIndicatorApi, ForecastModelDataEntryStatusApi, ForecastModelDataEntryTypeApi, ForecastModelRecordDataApi, ForecastModelRecordDataActualSplitRangeApi, ForecastModelRecordDataFileApi, ForecastModelRecordDataImportPeriodTypeApi, ForesightScenarioApi, ForesightScenarioBaselineCalculationApi, ForesightScenarioElementApi, ForesightScenarioElementTypeApi, ForesightScenarioFactorApi, ForesightScenarioLevelApi, ForesightScenarioNotificationRecipientApi, FrontendErrorReportApi, GeneralSettingsApi, GeoAreaApi, GoalMetricApi, GoalMetricValueSourceApi, GoalMetricValueTypeApi, GoogleAnalyticsSettingsApi, GoogleOAuthUserApi, InsightApi, InsightDefaultExcludedDomainApi, InsightImageApi, InsightReactionLinkApi, InsightReactionTypeApi, InsightTypeApi, IntegrationDataMappingDimensionApi, IntegrationDataMappingMatchRuleApi, IntegrationDataMappingRuleApi, IntegrationDataMappingSourceApi, IntegrationFinancialUploadBatchApi, IntegrationPipedriveSettingsApi, IntegrationPipedriveSettingsPipelineApi, IntegrationPipedriveSettingsPipelineStageApi, IntegrationSettingsNetvisorSyncDefaultHandleTypeApi, IntegrationSourceApi, IntegrationSourceCompanyStatusApi, InvoicingDataApi, InvoicingDataPreviewReportApi, LastFinancialPeriodTypeApi, LemonsoftIntegrationSettingsApi, LivingStrategyDashboardReportApi, MapRegionApi, MarketApi, MarketFeedBingCognitiveApi, MarketFreeNodeApi, MarketPlayerTypeApi, MarketRSSWatchSettingApi, MarketRSSWatchSettingFeedDataApi, MarketRSSWatchSettingReportApi, MarketScopeTypeApi, MarketSearchTemplateReportApi, MasterSearchReportApi, MasterSearchUserInputApi, MeetingApi, MeetingAdministratorApi, MeetingInvitationPeriodTypeApi, MeetingMinutesApi, MeetingMinutesContentTypeApi, MeetingParticipantApi, MeetingSectionApi, MeetingSectionContentTypeApi, MeetingSectionTextTopicApi, MeetingSectionTopicApi, MeetingSectionTopicAttachmentApi, MeetingSectionTopicCommentApi, MeetingSectionTopicLinkApi, MeetingStatusApi, MeetingTemplateApi, MeetingTemplateAdministratorApi, MeetingTemplateParticipantApi, MeetingTemplateSectionApi, MeetingTemplateSectionTextTopicApi, MeetingTemplateSectionTopicApi, MeetingTemplateSectionTopicLinkApi, MicrosoftTeamsBotLinkedConversationApi, MobileClientTokenApi, NewsEntryApi, NewsEntryAutomatedSourceApi, NewsEntryCategoryApi, NewsEntryCommentApi, NewsEntryContributorApi, NewsEntryEntryStatusApi, NewsEntryInsightLinkApi, NewsEntrySourceApi, NewsEntrySourceCategoryApi, NewsEntrySourceReportApi, NewsEntrySourceTypeApi, NewsEntryUserStatusApi, NotificationReportApi, NotificationSendingTimeTypeApi, NotificationTypeApi, OpencorporatesOrganizationApi, OrganizationApi, OrganizationClassificationTypeApi, OtherPlayerApi, PartnerApi, PartnerClientCompanyApi, PartnerClientCompanyEventTypeApi, PartnerClientCompanyTypeApi, PartnerSupportLevelApi, PerformanceIndicatorApi, PerformanceIndicatorCalculationRangeApi, PerformanceIndicatorCollectionTypeApi, PerformanceIndicatorComparisonCalculationApi, PerformanceIndicatorComparisonTargetApi, PerformanceIndicatorConversationApi, PerformanceIndicatorDateRangeApi, PerformanceIndicatorDayDataApi, PerformanceIndicatorDimensionApi, PerformanceIndicatorFormulaApi, PerformanceIndicatorFormulaElementTypeApi, PerformanceIndicatorGroupApi, PerformanceIndicatorMonthDataApi, PerformanceIndicatorPeriodTypeApi, PerformanceIndicatorPointCalculationApi, PerformanceIndicatorPollBatchApi, PerformanceIndicatorPollBatchUserApi, PerformanceIndicatorPollGeneralResponseApi, PerformanceIndicatorPollSettingsApi, PerformanceIndicatorPollStatusApi, PerformanceIndicatorPollValueAggregationTypeApi, PerformanceIndicatorPollValueTypeApi, PerformanceIndicatorQuarterDataApi, PerformanceIndicatorRelativePeriodApi, PerformanceIndicatorSystemTypeApi, PerformanceIndicatorValueDependencyRuleApi, PerformanceIndicatorValueSourceApi, PerformanceIndicatorWeekDataApi, PerformanceIndicatorYearDataApi, PerformanceManagementAlertApi, PerformanceManagementAlertActivityStatusApi, PerformanceManagementAlertDashboardBlockApi, PerformanceManagementAlertDashboardBlockCommentApi, PerformanceManagementAlertDeliveryChannelApi, PerformanceManagementAlertEmailTitleTypeApi, PerformanceManagementAlertIndicatorApi, PerformanceManagementAlertRecipientApi, PerformanceManagementAlertReviewSectionApi, PerformanceManagementAlertReviewSectionCommentApi, PerformanceManagementAlertScoreApi, PerformanceManagementAlertTriggerIndicatorApi, PerformanceManagementAlertTriggerTypeApi, PerformancePerspectiveApi, PerformancePerspectiveGroupApi, PersonalTopicApi, PollReportApi, PollSettingsScaleApi, PowerBITokenApi, ProductApi, PublicExternalLinkApi, QuickStartApi, RawDataMappingApi, RawDataMappingColumnApi, RawDataMappingColumnDataTypeApi, RawDataMappingRuleApi, RawDataRowApi, RawDataSourceApi, RawDataSourceStatusApi, RelativeDateTypeApi, SIEUploadQueueApi, SWOTAreaApi, SWOTInboxApi, SWOTSessionApi, SWOTSessionParticipantApi, SWOTTopicApi, SWOTTopicCommentApi, SWOTTopicVoteApi, SWOTTopicVoteBatchApi, SessionInformationApi, SeveraIntegrationSettingsApi, SheetConfigurationApi, SheetConfigurationForecastDownloadFromSheetRuleApi, SheetConfigurationForecastUploadToSheetRuleApi, SheetExcelConfigurationApi, SheetExcelGenerationIndicatorDepthRuleApi, SheetExcelGenerationValueWriteRuleApi, SheetForecastApi, SheetForecastFileApi, SheetForecastFileStatusApi, SheetForecastFileTypeApi, SheetForecastFileUserAccessApi, SheetForecastInputMethodApi, SheetForecastNotificationApi, SheetForecastRelatedSheetApi, SheetGoogleConfigurationApi, SheetGoogleTemplateCopiedRangeValueTypeApi, StakeholderApi, StakeholderBenchmarkApi, StakeholderBenchmarkCustomItemApi, StakeholderBenchmarkDimensionApi, StakeholderBenchmarkDimensionValueApi, StakeholderBenchmarkTemplateApi, StakeholderCommentApi, StakeholderMarketPositioningMapViewApi, StakeholderMarketPositioningMapViewCustomItemApi, StakeholderMarketPositioningMapViewPositionApi, StakeholderMarketPositioningMapViewTemplateApi, StakeholderNewsEntryAutomatedSourceApi, StakeholderNewsWatchFilterLevelApi, StakeholderTypeApi, StrategicGoalApi, StrategicGoalCriticalSuccessFactorApi, StrategicGoalMilestoneApi, StrategicGoalMilestoneAchievabilityApi, StrategicGoalMilestoneCommentApi, StrategicGoalMilestoneFinalStatusApi, StrategicGoalMilestoneSecondaryOwnerApi, StrategicGoalMilestoneSecondaryStatusUpdateApi, StrategicGoalMilestoneStatusApi, StrategicGoalMilestoneStatusUpdateApi, StrategicGoalMilestoneTeamLinkApi, StrategicProgramApi, StrategicProgramCommentApi, StrategicProgramConnectionApi, StrategicProgramFinalStatusApi, StrategicProgramRiskLevelApi, StrategicProgramSecondaryOwnerApi, StrategicProgramStatusApi, StrategicProgramStatusUpdateApi, StrategicProgramStatusUpdateRecipientApi, StrategicProgramUpdateFrequencyApi, StrategyDescriptionApi, StrategyDescriptionAdministratorApi, StrategyDescriptionExternalLinkApi, StrategyDescriptionParticipatorApi, StrategyDescriptionPerformanceIndicatorApi, StrategyDescriptionStatusApi, StrategyElementTypeApi, StrategyExecutionCustomEntityApi, StrategyExecutionCustomEntityDataApi, StrategyExecutionCustomFieldApi, StrategyExecutionCustomFieldLinkApi, StrategyExecutionCustomFieldOptionApi, StrategyExecutionCustomFieldTypeApi, StrategyExecutionSecondaryStatusUpdateTypeApi, StrategyExecutionTypeApi, StrategyFreeNodeApi, StrategyHealthReportApi, StrategyNamingTypeApi, StrategyPageBlockApi, StrategyPageBlockTypeApi, StrategyPageMemoBlockApi, StrategyProcessApi, StrategyProcessPhaseApi, StrategyProcessPhaseContentApi, StrategyProcessSubthemeApi, StrategyProcessSubthemeLinkApi, StrategyProcessSubthemeTypeApi, StrategyProcessThemeApi, StrategyProgressCalculationMethodApi, StrategyProgressCalculationSourceApi, StrategyPublishingLevelApi, StrategyPublishingTypeApi, StrategySavedViewApi, StrategySelectionApi, StrategyTaxonomyApi, SupplierApi, SystemLanguageApi, SystemRegisterDataSourceApi, SystemUserRoleApi, SystemUserTypeApi, TrackingLevelApi, TrackingLevelItemApi, TrendCategoryApi, TrendScopeApi, TrendSettingsApi, TrendTopicApi, TrendTopicCommentApi, TrendTopicTypeApi, UserApi, UserActivityItemApi, UserActivityReportApi, UserCompanyAccessApi, UserCompanyFunctionalityAccessApi, UserDataVisibilityFunctionApi, UserDataVisibilityLegalEntityApi, UserDataVisibilityProductApi, UserDataVisibilitySettingsApi, UserEngagementActionApi, UserFeedbackReportApi, UserFunctionalityAccessReportApi, UserInterfaceTextApi, UserInterfaceTranslationLanguageApi, UserListDataReportApi, UserLocalApi, UserNotificationEventSourceApi, UserNotificationUserSettingsApi, UserPartnerAccessApi, UserRoleApi, UserRoleBillingUserTypeApi, UserRoleProductApi, UserSyncExcelSettingsApi, UserTrackingLevelLinkApi, VATPeriodTypeApi, WorkshopApi, WorkshopBackgroundImageApi, WorkshopCanvasItemApi, WorkshopCanvasItemTypeApi, WorkshopExternalContentTypeApi, WorkshopItemApi, WorkshopItemCategoryApi, WorkshopItemCategoryConnectionApi, WorkshopItemHistoryApi, WorkshopItemRatingApi, WorkshopItemRatingHistoryApi, WorkshopParticipantApi, WorkshopParticipantRoleApi, WorkshopPhaseApi, WorkshopPhaseComparisonAxisApi, WorkshopPhaseComparisonDimensionApi, WorkshopPhaseContentCreationRuleApi, WorkshopPhaseContentRowApi, WorkshopPhaseContentRowLayoutApi, WorkshopPhaseGridBlockApi, WorkshopPhaseParticipantRoleApi, WorkshopPrioritizationVotingTypeApi, WorkshopQuestionnaireFilterApi, WorkshopQuestionnaireOptionApi, WorkshopQuestionnaireQuestionApi, WorkshopQuestionnaireQuestionTypeApi, WorkshopQuestionnaireResponseApi, WorkshopRatingPhaseCategoryWeightApi, WorkshopRatingPhaseSourceApi, WorkshopRatingPhaseWeightedLevelApi, WorkshopResultPhaseSourceApi, WorkshopResultPresentationTypeApi, WorkshopVersionHistoryChangeTypeApi, WorkshopVideoCallApi, WorkshopWidgetApi, WorkshopWidgetIdeaGenerationThemeApi, WorkshopWidgetParticipantStatusApi, WorkshopWidgetStatusApi, WorkshopWidgetTypeApi, WorkspaceMindmapApi, WorkspaceMindmapNodeApi, WorkspaceMindmapNodeTypeApi) {
  'use strict';

  /**
   * Lead_your_organisations_full_potential_to_creating_results.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var ForStractionServiceApi = require('index'); // See note below*.
   * var xxxSvc = new ForStractionServiceApi.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new ForStractionServiceApi.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new ForStractionServiceApi.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new ForStractionServiceApi.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 2.0.1639219082
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The AccessFunctionality model constructor.
     * @property {module:model/AccessFunctionality}
     */
    AccessFunctionality: AccessFunctionality,
    /**
     * The AccessFunctionalityAddOn model constructor.
     * @property {module:model/AccessFunctionalityAddOn}
     */
    AccessFunctionalityAddOn: AccessFunctionalityAddOn,
    /**
     * The AccessModule model constructor.
     * @property {module:model/AccessModule}
     */
    AccessModule: AccessModule,
    /**
     * The AccessProfile model constructor.
     * @property {module:model/AccessProfile}
     */
    AccessProfile: AccessProfile,
    /**
     * The AccessType model constructor.
     * @property {module:model/AccessType}
     */
    AccessType: AccessType,
    /**
     * The AccountingData model constructor.
     * @property {module:model/AccountingData}
     */
    AccountingData: AccountingData,
    /**
     * The AccountingDataPaginationSlice model constructor.
     * @property {module:model/AccountingDataPaginationSlice}
     */
    AccountingDataPaginationSlice: AccountingDataPaginationSlice,
    /**
     * The AccountingDataPreviewReport model constructor.
     * @property {module:model/AccountingDataPreviewReport}
     */
    AccountingDataPreviewReport: AccountingDataPreviewReport,
    /**
     * The AgendaFlag model constructor.
     * @property {module:model/AgendaFlag}
     */
    AgendaFlag: AgendaFlag,
    /**
     * The AgendaTheme model constructor.
     * @property {module:model/AgendaTheme}
     */
    AgendaTheme: AgendaTheme,
    /**
     * The AgendaTimeReservation model constructor.
     * @property {module:model/AgendaTimeReservation}
     */
    AgendaTimeReservation: AgendaTimeReservation,
    /**
     * The AgendaTimeSerieEvent model constructor.
     * @property {module:model/AgendaTimeSerieEvent}
     */
    AgendaTimeSerieEvent: AgendaTimeSerieEvent,
    /**
     * The AgendaTimeSerieRule model constructor.
     * @property {module:model/AgendaTimeSerieRule}
     */
    AgendaTimeSerieRule: AgendaTimeSerieRule,
    /**
     * The AgendaTimeSerieRuleReport model constructor.
     * @property {module:model/AgendaTimeSerieRuleReport}
     */
    AgendaTimeSerieRuleReport: AgendaTimeSerieRuleReport,
    /**
     * The AnalysisCategory model constructor.
     * @property {module:model/AnalysisCategory}
     */
    AnalysisCategory: AnalysisCategory,
    /**
     * The AutomatedSourceGeneratedNews model constructor.
     * @property {module:model/AutomatedSourceGeneratedNews}
     */
    AutomatedSourceGeneratedNews: AutomatedSourceGeneratedNews,
    /**
     * The BingCognitiveItem model constructor.
     * @property {module:model/BingCognitiveItem}
     */
    BingCognitiveItem: BingCognitiveItem,
    /**
     * The BingCognitiveSearchData model constructor.
     * @property {module:model/BingCognitiveSearchData}
     */
    BingCognitiveSearchData: BingCognitiveSearchData,
    /**
     * The BisnodeFinancialIndicatorValue model constructor.
     * @property {module:model/BisnodeFinancialIndicatorValue}
     */
    BisnodeFinancialIndicatorValue: BisnodeFinancialIndicatorValue,
    /**
     * The BusinessModel model constructor.
     * @property {module:model/BusinessModel}
     */
    BusinessModel: BusinessModel,
    /**
     * The BusinessModelArea model constructor.
     * @property {module:model/BusinessModelArea}
     */
    BusinessModelArea: BusinessModelArea,
    /**
     * The BusinessModelCanvasArea model constructor.
     * @property {module:model/BusinessModelCanvasArea}
     */
    BusinessModelCanvasArea: BusinessModelCanvasArea,
    /**
     * The BusinessModelCanvasItem model constructor.
     * @property {module:model/BusinessModelCanvasItem}
     */
    BusinessModelCanvasItem: BusinessModelCanvasItem,
    /**
     * The BusinessModelCanvasItemType model constructor.
     * @property {module:model/BusinessModelCanvasItemType}
     */
    BusinessModelCanvasItemType: BusinessModelCanvasItemType,
    /**
     * The BusinessModelReport model constructor.
     * @property {module:model/BusinessModelReport}
     */
    BusinessModelReport: BusinessModelReport,
    /**
     * The BusinessReviewExcludedSection model constructor.
     * @property {module:model/BusinessReviewExcludedSection}
     */
    BusinessReviewExcludedSection: BusinessReviewExcludedSection,
    /**
     * The BusinessReviewSchedule model constructor.
     * @property {module:model/BusinessReviewSchedule}
     */
    BusinessReviewSchedule: BusinessReviewSchedule,
    /**
     * The BusinessReviewSectionType model constructor.
     * @property {module:model/BusinessReviewSectionType}
     */
    BusinessReviewSectionType: BusinessReviewSectionType,
    /**
     * The BusinessReviewSession model constructor.
     * @property {module:model/BusinessReviewSession}
     */
    BusinessReviewSession: BusinessReviewSession,
    /**
     * The BusinessReviewSessionPaginationSlice model constructor.
     * @property {module:model/BusinessReviewSessionPaginationSlice}
     */
    BusinessReviewSessionPaginationSlice: BusinessReviewSessionPaginationSlice,
    /**
     * The BusinessReviewSessionStatus model constructor.
     * @property {module:model/BusinessReviewSessionStatus}
     */
    BusinessReviewSessionStatus: BusinessReviewSessionStatus,
    /**
     * The BusinessReviewStatus model constructor.
     * @property {module:model/BusinessReviewStatus}
     */
    BusinessReviewStatus: BusinessReviewStatus,
    /**
     * The BusinessReviewStep model constructor.
     * @property {module:model/BusinessReviewStep}
     */
    BusinessReviewStep: BusinessReviewStep,
    /**
     * The BusinessReviewStepElementSide model constructor.
     * @property {module:model/BusinessReviewStepElementSide}
     */
    BusinessReviewStepElementSide: BusinessReviewStepElementSide,
    /**
     * The BusinessReviewTemplate model constructor.
     * @property {module:model/BusinessReviewTemplate}
     */
    BusinessReviewTemplate: BusinessReviewTemplate,
    /**
     * The BusinessReviewTemplateReport model constructor.
     * @property {module:model/BusinessReviewTemplateReport}
     */
    BusinessReviewTemplateReport: BusinessReviewTemplateReport,
    /**
     * The BusinessReviewUserSettings model constructor.
     * @property {module:model/BusinessReviewUserSettings}
     */
    BusinessReviewUserSettings: BusinessReviewUserSettings,
    /**
     * The BusinessSimulatorCashflowAccountReceivablesDistribution model constructor.
     * @property {module:model/BusinessSimulatorCashflowAccountReceivablesDistribution}
     */
    BusinessSimulatorCashflowAccountReceivablesDistribution: BusinessSimulatorCashflowAccountReceivablesDistribution,
    /**
     * The BusinessSimulatorCashflowCapitalItem model constructor.
     * @property {module:model/BusinessSimulatorCashflowCapitalItem}
     */
    BusinessSimulatorCashflowCapitalItem: BusinessSimulatorCashflowCapitalItem,
    /**
     * The BusinessSimulatorCashflowCapitalItemGroup model constructor.
     * @property {module:model/BusinessSimulatorCashflowCapitalItemGroup}
     */
    BusinessSimulatorCashflowCapitalItemGroup: BusinessSimulatorCashflowCapitalItemGroup,
    /**
     * The BusinessSimulatorCashflowCapitalItemValue model constructor.
     * @property {module:model/BusinessSimulatorCashflowCapitalItemValue}
     */
    BusinessSimulatorCashflowCapitalItemValue: BusinessSimulatorCashflowCapitalItemValue,
    /**
     * The BusinessSimulatorCashflowCapitalItemValuePaginationSlice model constructor.
     * @property {module:model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice}
     */
    BusinessSimulatorCashflowCapitalItemValuePaginationSlice: BusinessSimulatorCashflowCapitalItemValuePaginationSlice,
    /**
     * The BusinessSimulatorCashflowSalesReceivablesDistribution model constructor.
     * @property {module:model/BusinessSimulatorCashflowSalesReceivablesDistribution}
     */
    BusinessSimulatorCashflowSalesReceivablesDistribution: BusinessSimulatorCashflowSalesReceivablesDistribution,
    /**
     * The CashflowForecastDataReport model constructor.
     * @property {module:model/CashflowForecastDataReport}
     */
    CashflowForecastDataReport: CashflowForecastDataReport,
    /**
     * The CashflowForecastIndicatorConnection model constructor.
     * @property {module:model/CashflowForecastIndicatorConnection}
     */
    CashflowForecastIndicatorConnection: CashflowForecastIndicatorConnection,
    /**
     * The CashflowForecastIndicatorConnectionReport model constructor.
     * @property {module:model/CashflowForecastIndicatorConnectionReport}
     */
    CashflowForecastIndicatorConnectionReport: CashflowForecastIndicatorConnectionReport,
    /**
     * The CashflowForecastIndicatorDistributionEntry model constructor.
     * @property {module:model/CashflowForecastIndicatorDistributionEntry}
     */
    CashflowForecastIndicatorDistributionEntry: CashflowForecastIndicatorDistributionEntry,
    /**
     * The CashflowForecastSettings model constructor.
     * @property {module:model/CashflowForecastSettings}
     */
    CashflowForecastSettings: CashflowForecastSettings,
    /**
     * The CashflowForecastSettingsReport model constructor.
     * @property {module:model/CashflowForecastSettingsReport}
     */
    CashflowForecastSettingsReport: CashflowForecastSettingsReport,
    /**
     * The CategoryReport model constructor.
     * @property {module:model/CategoryReport}
     */
    CategoryReport: CategoryReport,
    /**
     * The Company model constructor.
     * @property {module:model/Company}
     */
    Company: Company,
    /**
     * The CompanyAccessFunctionalityAddOn model constructor.
     * @property {module:model/CompanyAccessFunctionalityAddOn}
     */
    CompanyAccessFunctionalityAddOn: CompanyAccessFunctionalityAddOn,
    /**
     * The CompanyAccessModule model constructor.
     * @property {module:model/CompanyAccessModule}
     */
    CompanyAccessModule: CompanyAccessModule,
    /**
     * The CompanyFunction model constructor.
     * @property {module:model/CompanyFunction}
     */
    CompanyFunction: CompanyFunction,
    /**
     * The CompanyLegalEntity model constructor.
     * @property {module:model/CompanyLegalEntity}
     */
    CompanyLegalEntity: CompanyLegalEntity,
    /**
     * The CompanyLegalEntityType model constructor.
     * @property {module:model/CompanyLegalEntityType}
     */
    CompanyLegalEntityType: CompanyLegalEntityType,
    /**
     * The CompanyResponsiblePerson model constructor.
     * @property {module:model/CompanyResponsiblePerson}
     */
    CompanyResponsiblePerson: CompanyResponsiblePerson,
    /**
     * The CompanyResponsiblePersonConnection model constructor.
     * @property {module:model/CompanyResponsiblePersonConnection}
     */
    CompanyResponsiblePersonConnection: CompanyResponsiblePersonConnection,
    /**
     * The CompanySubscriptionReport model constructor.
     * @property {module:model/CompanySubscriptionReport}
     */
    CompanySubscriptionReport: CompanySubscriptionReport,
    /**
     * The CompanySubscriptionServiceLevel model constructor.
     * @property {module:model/CompanySubscriptionServiceLevel}
     */
    CompanySubscriptionServiceLevel: CompanySubscriptionServiceLevel,
    /**
     * The CompanyTemplateType model constructor.
     * @property {module:model/CompanyTemplateType}
     */
    CompanyTemplateType: CompanyTemplateType,
    /**
     * The CompanyUserServiceLevelBase model constructor.
     * @property {module:model/CompanyUserServiceLevelBase}
     */
    CompanyUserServiceLevelBase: CompanyUserServiceLevelBase,
    /**
     * The CompanyVirtualTeam model constructor.
     * @property {module:model/CompanyVirtualTeam}
     */
    CompanyVirtualTeam: CompanyVirtualTeam,
    /**
     * The CompanyVirtualTeamMember model constructor.
     * @property {module:model/CompanyVirtualTeamMember}
     */
    CompanyVirtualTeamMember: CompanyVirtualTeamMember,
    /**
     * The ContentWatchSettings model constructor.
     * @property {module:model/ContentWatchSettings}
     */
    ContentWatchSettings: ContentWatchSettings,
    /**
     * The ContentWatchSettingsPaginationSlice model constructor.
     * @property {module:model/ContentWatchSettingsPaginationSlice}
     */
    ContentWatchSettingsPaginationSlice: ContentWatchSettingsPaginationSlice,
    /**
     * The CorporateStructureFilter model constructor.
     * @property {module:model/CorporateStructureFilter}
     */
    CorporateStructureFilter: CorporateStructureFilter,
    /**
     * The CorporateStructureLink model constructor.
     * @property {module:model/CorporateStructureLink}
     */
    CorporateStructureLink: CorporateStructureLink,
    /**
     * The CorporateStructureLinkReport model constructor.
     * @property {module:model/CorporateStructureLinkReport}
     */
    CorporateStructureLinkReport: CorporateStructureLinkReport,
    /**
     * The CorporateStructureSortMode model constructor.
     * @property {module:model/CorporateStructureSortMode}
     */
    CorporateStructureSortMode: CorporateStructureSortMode,
    /**
     * The Country model constructor.
     * @property {module:model/Country}
     */
    Country: Country,
    /**
     * The Customer model constructor.
     * @property {module:model/Customer}
     */
    Customer: Customer,
    /**
     * The DashboardGroup model constructor.
     * @property {module:model/DashboardGroup}
     */
    DashboardGroup: DashboardGroup,
    /**
     * The DashboardGroupLightReport model constructor.
     * @property {module:model/DashboardGroupLightReport}
     */
    DashboardGroupLightReport: DashboardGroupLightReport,
    /**
     * The DashboardPage model constructor.
     * @property {module:model/DashboardPage}
     */
    DashboardPage: DashboardPage,
    /**
     * The DashboardPageBlock model constructor.
     * @property {module:model/DashboardPageBlock}
     */
    DashboardPageBlock: DashboardPageBlock,
    /**
     * The DashboardPageBlockBubbleSettings model constructor.
     * @property {module:model/DashboardPageBlockBubbleSettings}
     */
    DashboardPageBlockBubbleSettings: DashboardPageBlockBubbleSettings,
    /**
     * The DashboardPageBlockCartesianAxis model constructor.
     * @property {module:model/DashboardPageBlockCartesianAxis}
     */
    DashboardPageBlockCartesianAxis: DashboardPageBlockCartesianAxis,
    /**
     * The DashboardPageBlockCartesianSerie model constructor.
     * @property {module:model/DashboardPageBlockCartesianSerie}
     */
    DashboardPageBlockCartesianSerie: DashboardPageBlockCartesianSerie,
    /**
     * The DashboardPageBlockCartesianSerieGrouping model constructor.
     * @property {module:model/DashboardPageBlockCartesianSerieGrouping}
     */
    DashboardPageBlockCartesianSerieGrouping: DashboardPageBlockCartesianSerieGrouping,
    /**
     * The DashboardPageBlockCartesianSerieMilestone model constructor.
     * @property {module:model/DashboardPageBlockCartesianSerieMilestone}
     */
    DashboardPageBlockCartesianSerieMilestone: DashboardPageBlockCartesianSerieMilestone,
    /**
     * The DashboardPageBlockCartesianSerieReport model constructor.
     * @property {module:model/DashboardPageBlockCartesianSerieReport}
     */
    DashboardPageBlockCartesianSerieReport: DashboardPageBlockCartesianSerieReport,
    /**
     * The DashboardPageBlockCartesianSerieType model constructor.
     * @property {module:model/DashboardPageBlockCartesianSerieType}
     */
    DashboardPageBlockCartesianSerieType: DashboardPageBlockCartesianSerieType,
    /**
     * The DashboardPageBlockComment model constructor.
     * @property {module:model/DashboardPageBlockComment}
     */
    DashboardPageBlockComment: DashboardPageBlockComment,
    /**
     * The DashboardPageBlockCommentPaginationSlice model constructor.
     * @property {module:model/DashboardPageBlockCommentPaginationSlice}
     */
    DashboardPageBlockCommentPaginationSlice: DashboardPageBlockCommentPaginationSlice,
    /**
     * The DashboardPageBlockComparisonBarSerie model constructor.
     * @property {module:model/DashboardPageBlockComparisonBarSerie}
     */
    DashboardPageBlockComparisonBarSerie: DashboardPageBlockComparisonBarSerie,
    /**
     * The DashboardPageBlockComparisonBarSerieType model constructor.
     * @property {module:model/DashboardPageBlockComparisonBarSerieType}
     */
    DashboardPageBlockComparisonBarSerieType: DashboardPageBlockComparisonBarSerieType,
    /**
     * The DashboardPageBlockComparisonColumnSerie model constructor.
     * @property {module:model/DashboardPageBlockComparisonColumnSerie}
     */
    DashboardPageBlockComparisonColumnSerie: DashboardPageBlockComparisonColumnSerie,
    /**
     * The DashboardPageBlockComparisonColumnSerieType model constructor.
     * @property {module:model/DashboardPageBlockComparisonColumnSerieType}
     */
    DashboardPageBlockComparisonColumnSerieType: DashboardPageBlockComparisonColumnSerieType,
    /**
     * The DashboardPageBlockCustomTableColumn model constructor.
     * @property {module:model/DashboardPageBlockCustomTableColumn}
     */
    DashboardPageBlockCustomTableColumn: DashboardPageBlockCustomTableColumn,
    /**
     * The DashboardPageBlockCustomTableColumnDefaultFilter model constructor.
     * @property {module:model/DashboardPageBlockCustomTableColumnDefaultFilter}
     */
    DashboardPageBlockCustomTableColumnDefaultFilter: DashboardPageBlockCustomTableColumnDefaultFilter,
    /**
     * The DashboardPageBlockCustomTableGraphSerieType model constructor.
     * @property {module:model/DashboardPageBlockCustomTableGraphSerieType}
     */
    DashboardPageBlockCustomTableGraphSerieType: DashboardPageBlockCustomTableGraphSerieType,
    /**
     * The DashboardPageBlockCustomTableQuery model constructor.
     * @property {module:model/DashboardPageBlockCustomTableQuery}
     */
    DashboardPageBlockCustomTableQuery: DashboardPageBlockCustomTableQuery,
    /**
     * The DashboardPageBlockExternalSettings model constructor.
     * @property {module:model/DashboardPageBlockExternalSettings}
     */
    DashboardPageBlockExternalSettings: DashboardPageBlockExternalSettings,
    /**
     * The DashboardPageBlockGoogleSheetSettings model constructor.
     * @property {module:model/DashboardPageBlockGoogleSheetSettings}
     */
    DashboardPageBlockGoogleSheetSettings: DashboardPageBlockGoogleSheetSettings,
    /**
     * The DashboardPageBlockImage model constructor.
     * @property {module:model/DashboardPageBlockImage}
     */
    DashboardPageBlockImage: DashboardPageBlockImage,
    /**
     * The DashboardPageBlockLightReport model constructor.
     * @property {module:model/DashboardPageBlockLightReport}
     */
    DashboardPageBlockLightReport: DashboardPageBlockLightReport,
    /**
     * The DashboardPageBlockMarketOverviewSettings model constructor.
     * @property {module:model/DashboardPageBlockMarketOverviewSettings}
     */
    DashboardPageBlockMarketOverviewSettings: DashboardPageBlockMarketOverviewSettings,
    /**
     * The DashboardPageBlockMilestone model constructor.
     * @property {module:model/DashboardPageBlockMilestone}
     */
    DashboardPageBlockMilestone: DashboardPageBlockMilestone,
    /**
     * The DashboardPageBlockNewsfeed model constructor.
     * @property {module:model/DashboardPageBlockNewsfeed}
     */
    DashboardPageBlockNewsfeed: DashboardPageBlockNewsfeed,
    /**
     * The DashboardPageBlockNumberSerie model constructor.
     * @property {module:model/DashboardPageBlockNumberSerie}
     */
    DashboardPageBlockNumberSerie: DashboardPageBlockNumberSerie,
    /**
     * The DashboardPageBlockPieSerie model constructor.
     * @property {module:model/DashboardPageBlockPieSerie}
     */
    DashboardPageBlockPieSerie: DashboardPageBlockPieSerie,
    /**
     * The DashboardPageBlockPollSettings model constructor.
     * @property {module:model/DashboardPageBlockPollSettings}
     */
    DashboardPageBlockPollSettings: DashboardPageBlockPollSettings,
    /**
     * The DashboardPageBlockPowerBIEmbed model constructor.
     * @property {module:model/DashboardPageBlockPowerBIEmbed}
     */
    DashboardPageBlockPowerBIEmbed: DashboardPageBlockPowerBIEmbed,
    /**
     * The DashboardPageBlockReport model constructor.
     * @property {module:model/DashboardPageBlockReport}
     */
    DashboardPageBlockReport: DashboardPageBlockReport,
    /**
     * The DashboardPageBlockReportNestedPaginationSlice model constructor.
     * @property {module:model/DashboardPageBlockReportNestedPaginationSlice}
     */
    DashboardPageBlockReportNestedPaginationSlice: DashboardPageBlockReportNestedPaginationSlice,
    /**
     * The DashboardPageBlockReportPaginationSlice model constructor.
     * @property {module:model/DashboardPageBlockReportPaginationSlice}
     */
    DashboardPageBlockReportPaginationSlice: DashboardPageBlockReportPaginationSlice,
    /**
     * The DashboardPageBlockSerieOrder model constructor.
     * @property {module:model/DashboardPageBlockSerieOrder}
     */
    DashboardPageBlockSerieOrder: DashboardPageBlockSerieOrder,
    /**
     * The DashboardPageBlockSolidGaugeSerie model constructor.
     * @property {module:model/DashboardPageBlockSolidGaugeSerie}
     */
    DashboardPageBlockSolidGaugeSerie: DashboardPageBlockSolidGaugeSerie,
    /**
     * The DashboardPageBlockStrategicAction model constructor.
     * @property {module:model/DashboardPageBlockStrategicAction}
     */
    DashboardPageBlockStrategicAction: DashboardPageBlockStrategicAction,
    /**
     * The DashboardPageBlockStrategicActionViewType model constructor.
     * @property {module:model/DashboardPageBlockStrategicActionViewType}
     */
    DashboardPageBlockStrategicActionViewType: DashboardPageBlockStrategicActionViewType,
    /**
     * The DashboardPageBlockStrategy model constructor.
     * @property {module:model/DashboardPageBlockStrategy}
     */
    DashboardPageBlockStrategy: DashboardPageBlockStrategy,
    /**
     * The DashboardPageBlockTableComparisonColumn model constructor.
     * @property {module:model/DashboardPageBlockTableComparisonColumn}
     */
    DashboardPageBlockTableComparisonColumn: DashboardPageBlockTableComparisonColumn,
    /**
     * The DashboardPageBlockTableComparisonRow model constructor.
     * @property {module:model/DashboardPageBlockTableComparisonRow}
     */
    DashboardPageBlockTableComparisonRow: DashboardPageBlockTableComparisonRow,
    /**
     * The DashboardPageBlockTableDataColumn model constructor.
     * @property {module:model/DashboardPageBlockTableDataColumn}
     */
    DashboardPageBlockTableDataColumn: DashboardPageBlockTableDataColumn,
    /**
     * The DashboardPageBlockTableEmptyRow model constructor.
     * @property {module:model/DashboardPageBlockTableEmptyRow}
     */
    DashboardPageBlockTableEmptyRow: DashboardPageBlockTableEmptyRow,
    /**
     * The DashboardPageBlockTableRollingComparison model constructor.
     * @property {module:model/DashboardPageBlockTableRollingComparison}
     */
    DashboardPageBlockTableRollingComparison: DashboardPageBlockTableRollingComparison,
    /**
     * The DashboardPageBlockTableSerieRow model constructor.
     * @property {module:model/DashboardPageBlockTableSerieRow}
     */
    DashboardPageBlockTableSerieRow: DashboardPageBlockTableSerieRow,
    /**
     * The DashboardPageBlockTableSerieRowExpandedIndicator model constructor.
     * @property {module:model/DashboardPageBlockTableSerieRowExpandedIndicator}
     */
    DashboardPageBlockTableSerieRowExpandedIndicator: DashboardPageBlockTableSerieRowExpandedIndicator,
    /**
     * The DashboardPageBlockTableSerieRowReport model constructor.
     * @property {module:model/DashboardPageBlockTableSerieRowReport}
     */
    DashboardPageBlockTableSerieRowReport: DashboardPageBlockTableSerieRowReport,
    /**
     * The DashboardPageBlockTableSumColumn model constructor.
     * @property {module:model/DashboardPageBlockTableSumColumn}
     */
    DashboardPageBlockTableSumColumn: DashboardPageBlockTableSumColumn,
    /**
     * The DashboardPageBlockTemplate model constructor.
     * @property {module:model/DashboardPageBlockTemplate}
     */
    DashboardPageBlockTemplate: DashboardPageBlockTemplate,
    /**
     * The DashboardPageBlockType model constructor.
     * @property {module:model/DashboardPageBlockType}
     */
    DashboardPageBlockType: DashboardPageBlockType,
    /**
     * The DashboardPageExportSettings model constructor.
     * @property {module:model/DashboardPageExportSettings}
     */
    DashboardPageExportSettings: DashboardPageExportSettings,
    /**
     * The DashboardPageHomeSettings model constructor.
     * @property {module:model/DashboardPageHomeSettings}
     */
    DashboardPageHomeSettings: DashboardPageHomeSettings,
    /**
     * The DashboardPageLightReport model constructor.
     * @property {module:model/DashboardPageLightReport}
     */
    DashboardPageLightReport: DashboardPageLightReport,
    /**
     * The DashboardPageReport model constructor.
     * @property {module:model/DashboardPageReport}
     */
    DashboardPageReport: DashboardPageReport,
    /**
     * The DashboardPageTemplate model constructor.
     * @property {module:model/DashboardPageTemplate}
     */
    DashboardPageTemplate: DashboardPageTemplate,
    /**
     * The DashboardPageUserAccess model constructor.
     * @property {module:model/DashboardPageUserAccess}
     */
    DashboardPageUserAccess: DashboardPageUserAccess,
    /**
     * The DashboardShareBatchBlock model constructor.
     * @property {module:model/DashboardShareBatchBlock}
     */
    DashboardShareBatchBlock: DashboardShareBatchBlock,
    /**
     * The DashboardShareBatchReport model constructor.
     * @property {module:model/DashboardShareBatchReport}
     */
    DashboardShareBatchReport: DashboardShareBatchReport,
    /**
     * The Decision model constructor.
     * @property {module:model/Decision}
     */
    Decision: Decision,
    /**
     * The DecisionPoll model constructor.
     * @property {module:model/DecisionPoll}
     */
    DecisionPoll: DecisionPoll,
    /**
     * The DecisionPollReplyOptionTypeOption model constructor.
     * @property {module:model/DecisionPollReplyOptionTypeOption}
     */
    DecisionPollReplyOptionTypeOption: DecisionPollReplyOptionTypeOption,
    /**
     * The DecisionPollReplyOptionTypeReport model constructor.
     * @property {module:model/DecisionPollReplyOptionTypeReport}
     */
    DecisionPollReplyOptionTypeReport: DecisionPollReplyOptionTypeReport,
    /**
     * The DecisionPollReport model constructor.
     * @property {module:model/DecisionPollReport}
     */
    DecisionPollReport: DecisionPollReport,
    /**
     * The DecisionPollRespondent model constructor.
     * @property {module:model/DecisionPollRespondent}
     */
    DecisionPollRespondent: DecisionPollRespondent,
    /**
     * The DecisionPollType model constructor.
     * @property {module:model/DecisionPollType}
     */
    DecisionPollType: DecisionPollType,
    /**
     * The DecisionReport model constructor.
     * @property {module:model/DecisionReport}
     */
    DecisionReport: DecisionReport,
    /**
     * The DecisionTopicComment model constructor.
     * @property {module:model/DecisionTopicComment}
     */
    DecisionTopicComment: DecisionTopicComment,
    /**
     * The DecisionTopicCommentPaginationSlice model constructor.
     * @property {module:model/DecisionTopicCommentPaginationSlice}
     */
    DecisionTopicCommentPaginationSlice: DecisionTopicCommentPaginationSlice,
    /**
     * The DecisionTopicPhase model constructor.
     * @property {module:model/DecisionTopicPhase}
     */
    DecisionTopicPhase: DecisionTopicPhase,
    /**
     * The DecisionTopicReport model constructor.
     * @property {module:model/DecisionTopicReport}
     */
    DecisionTopicReport: DecisionTopicReport,
    /**
     * The DecisionTopicSuggestionSearchItem model constructor.
     * @property {module:model/DecisionTopicSuggestionSearchItem}
     */
    DecisionTopicSuggestionSearchItem: DecisionTopicSuggestionSearchItem,
    /**
     * The DecisionTopicType model constructor.
     * @property {module:model/DecisionTopicType}
     */
    DecisionTopicType: DecisionTopicType,
    /**
     * The DecisionTrackingType model constructor.
     * @property {module:model/DecisionTrackingType}
     */
    DecisionTrackingType: DecisionTrackingType,
    /**
     * The DialogDistributionChannel model constructor.
     * @property {module:model/DialogDistributionChannel}
     */
    DialogDistributionChannel: DialogDistributionChannel,
    /**
     * The DialogFlowLogicGateMatchRule model constructor.
     * @property {module:model/DialogFlowLogicGateMatchRule}
     */
    DialogFlowLogicGateMatchRule: DialogFlowLogicGateMatchRule,
    /**
     * The DialogFlowLogicGateValueSource model constructor.
     * @property {module:model/DialogFlowLogicGateValueSource}
     */
    DialogFlowLogicGateValueSource: DialogFlowLogicGateValueSource,
    /**
     * The DialogFlowMultiOptionDataSource model constructor.
     * @property {module:model/DialogFlowMultiOptionDataSource}
     */
    DialogFlowMultiOptionDataSource: DialogFlowMultiOptionDataSource,
    /**
     * The DialogFlowSession model constructor.
     * @property {module:model/DialogFlowSession}
     */
    DialogFlowSession: DialogFlowSession,
    /**
     * The DialogFlowTemplate model constructor.
     * @property {module:model/DialogFlowTemplate}
     */
    DialogFlowTemplate: DialogFlowTemplate,
    /**
     * The DialogFlowTemplateMessage model constructor.
     * @property {module:model/DialogFlowTemplateMessage}
     */
    DialogFlowTemplateMessage: DialogFlowTemplateMessage,
    /**
     * The DialogFlowTemplateMessageConversionRule model constructor.
     * @property {module:model/DialogFlowTemplateMessageConversionRule}
     */
    DialogFlowTemplateMessageConversionRule: DialogFlowTemplateMessageConversionRule,
    /**
     * The DialogFlowTemplateMessageOption model constructor.
     * @property {module:model/DialogFlowTemplateMessageOption}
     */
    DialogFlowTemplateMessageOption: DialogFlowTemplateMessageOption,
    /**
     * The DialogFlowTemplateMessageReport model constructor.
     * @property {module:model/DialogFlowTemplateMessageReport}
     */
    DialogFlowTemplateMessageReport: DialogFlowTemplateMessageReport,
    /**
     * The DialogFlowTemplateMessageType model constructor.
     * @property {module:model/DialogFlowTemplateMessageType}
     */
    DialogFlowTemplateMessageType: DialogFlowTemplateMessageType,
    /**
     * The DialogFlowTemplateReport model constructor.
     * @property {module:model/DialogFlowTemplateReport}
     */
    DialogFlowTemplateReport: DialogFlowTemplateReport,
    /**
     * The DialogScheduleBatch model constructor.
     * @property {module:model/DialogScheduleBatch}
     */
    DialogScheduleBatch: DialogScheduleBatch,
    /**
     * The DialogScheduleBatchReport model constructor.
     * @property {module:model/DialogScheduleBatchReport}
     */
    DialogScheduleBatchReport: DialogScheduleBatchReport,
    /**
     * The DialogScheduleFlow model constructor.
     * @property {module:model/DialogScheduleFlow}
     */
    DialogScheduleFlow: DialogScheduleFlow,
    /**
     * The DialogScheduleRhytm model constructor.
     * @property {module:model/DialogScheduleRhytm}
     */
    DialogScheduleRhytm: DialogScheduleRhytm,
    /**
     * The DialogScheduleSettings model constructor.
     * @property {module:model/DialogScheduleSettings}
     */
    DialogScheduleSettings: DialogScheduleSettings,
    /**
     * The DialogScheduleSettingsReport model constructor.
     * @property {module:model/DialogScheduleSettingsReport}
     */
    DialogScheduleSettingsReport: DialogScheduleSettingsReport,
    /**
     * The DialogScheduleUser model constructor.
     * @property {module:model/DialogScheduleUser}
     */
    DialogScheduleUser: DialogScheduleUser,
    /**
     * The ERPAccountList model constructor.
     * @property {module:model/ERPAccountList}
     */
    ERPAccountList: ERPAccountList,
    /**
     * The ERPAdminCostDivisionRule model constructor.
     * @property {module:model/ERPAdminCostDivisionRule}
     */
    ERPAdminCostDivisionRule: ERPAdminCostDivisionRule,
    /**
     * The ERPAdminCostDivisionRuleFixedRule model constructor.
     * @property {module:model/ERPAdminCostDivisionRuleFixedRule}
     */
    ERPAdminCostDivisionRuleFixedRule: ERPAdminCostDivisionRuleFixedRule,
    /**
     * The ERPAdminCostDivisionRuleFromAccount model constructor.
     * @property {module:model/ERPAdminCostDivisionRuleFromAccount}
     */
    ERPAdminCostDivisionRuleFromAccount: ERPAdminCostDivisionRuleFromAccount,
    /**
     * The ERPAdminCostDivisionRuleLevel model constructor.
     * @property {module:model/ERPAdminCostDivisionRuleLevel}
     */
    ERPAdminCostDivisionRuleLevel: ERPAdminCostDivisionRuleLevel,
    /**
     * The ERPAdminCostDivisionRuleReport model constructor.
     * @property {module:model/ERPAdminCostDivisionRuleReport}
     */
    ERPAdminCostDivisionRuleReport: ERPAdminCostDivisionRuleReport,
    /**
     * The ERPAdminCostDivisionRuleSourceFilter model constructor.
     * @property {module:model/ERPAdminCostDivisionRuleSourceFilter}
     */
    ERPAdminCostDivisionRuleSourceFilter: ERPAdminCostDivisionRuleSourceFilter,
    /**
     * The ERPAdminCostDivisionType model constructor.
     * @property {module:model/ERPAdminCostDivisionType}
     */
    ERPAdminCostDivisionType: ERPAdminCostDivisionType,
    /**
     * The ERPCorporateAccount model constructor.
     * @property {module:model/ERPCorporateAccount}
     */
    ERPCorporateAccount: ERPCorporateAccount,
    /**
     * The ERPDimensionMapping model constructor.
     * @property {module:model/ERPDimensionMapping}
     */
    ERPDimensionMapping: ERPDimensionMapping,
    /**
     * The ERPDimensionSyncSetting model constructor.
     * @property {module:model/ERPDimensionSyncSetting}
     */
    ERPDimensionSyncSetting: ERPDimensionSyncSetting,
    /**
     * The ERPDimensionSyncType model constructor.
     * @property {module:model/ERPDimensionSyncType}
     */
    ERPDimensionSyncType: ERPDimensionSyncType,
    /**
     * The ERPFinancialAdvisorySettings model constructor.
     * @property {module:model/ERPFinancialAdvisorySettings}
     */
    ERPFinancialAdvisorySettings: ERPFinancialAdvisorySettings,
    /**
     * The ERPFinancialCalculationError model constructor.
     * @property {module:model/ERPFinancialCalculationError}
     */
    ERPFinancialCalculationError: ERPFinancialCalculationError,
    /**
     * The ERPFivaldiIntegrationSettings model constructor.
     * @property {module:model/ERPFivaldiIntegrationSettings}
     */
    ERPFivaldiIntegrationSettings: ERPFivaldiIntegrationSettings,
    /**
     * The ERPNetvisorIntegrationLockPeriod model constructor.
     * @property {module:model/ERPNetvisorIntegrationLockPeriod}
     */
    ERPNetvisorIntegrationLockPeriod: ERPNetvisorIntegrationLockPeriod,
    /**
     * The ERPNetvisorIntegrationSettings model constructor.
     * @property {module:model/ERPNetvisorIntegrationSettings}
     */
    ERPNetvisorIntegrationSettings: ERPNetvisorIntegrationSettings,
    /**
     * The ERPProcountorIntegrationSettings model constructor.
     * @property {module:model/ERPProcountorIntegrationSettings}
     */
    ERPProcountorIntegrationSettings: ERPProcountorIntegrationSettings,
    /**
     * The ERPSyncCustomer model constructor.
     * @property {module:model/ERPSyncCustomer}
     */
    ERPSyncCustomer: ERPSyncCustomer,
    /**
     * The ERPSyncCustomerMonthData model constructor.
     * @property {module:model/ERPSyncCustomerMonthData}
     */
    ERPSyncCustomerMonthData: ERPSyncCustomerMonthData,
    /**
     * The ERPSyncCustomerReport model constructor.
     * @property {module:model/ERPSyncCustomerReport}
     */
    ERPSyncCustomerReport: ERPSyncCustomerReport,
    /**
     * The ERPSyncCustomerReportERPSyncItemPaginationSlice model constructor.
     * @property {module:model/ERPSyncCustomerReportERPSyncItemPaginationSlice}
     */
    ERPSyncCustomerReportERPSyncItemPaginationSlice: ERPSyncCustomerReportERPSyncItemPaginationSlice,
    /**
     * The ERPSyncProduct model constructor.
     * @property {module:model/ERPSyncProduct}
     */
    ERPSyncProduct: ERPSyncProduct,
    /**
     * The ERPSyncProductMonthData model constructor.
     * @property {module:model/ERPSyncProductMonthData}
     */
    ERPSyncProductMonthData: ERPSyncProductMonthData,
    /**
     * The ERPSyncProductReport model constructor.
     * @property {module:model/ERPSyncProductReport}
     */
    ERPSyncProductReport: ERPSyncProductReport,
    /**
     * The ERPSyncProductReportERPSyncItemPaginationSlice model constructor.
     * @property {module:model/ERPSyncProductReportERPSyncItemPaginationSlice}
     */
    ERPSyncProductReportERPSyncItemPaginationSlice: ERPSyncProductReportERPSyncItemPaginationSlice,
    /**
     * The EntityChange model constructor.
     * @property {module:model/EntityChange}
     */
    EntityChange: EntityChange,
    /**
     * The ExternalSourceLightSpreadsheet model constructor.
     * @property {module:model/ExternalSourceLightSpreadsheet}
     */
    ExternalSourceLightSpreadsheet: ExternalSourceLightSpreadsheet,
    /**
     * The ExternalSourceLightSpreadsheetSheet model constructor.
     * @property {module:model/ExternalSourceLightSpreadsheetSheet}
     */
    ExternalSourceLightSpreadsheetSheet: ExternalSourceLightSpreadsheetSheet,
    /**
     * The FileTransferHelperEntity model constructor.
     * @property {module:model/FileTransferHelperEntity}
     */
    FileTransferHelperEntity: FileTransferHelperEntity,
    /**
     * The FinancialBatchPreviewReport model constructor.
     * @property {module:model/FinancialBatchPreviewReport}
     */
    FinancialBatchPreviewReport: FinancialBatchPreviewReport,
    /**
     * The FinancialIndicator model constructor.
     * @property {module:model/FinancialIndicator}
     */
    FinancialIndicator: FinancialIndicator,
    /**
     * The FinancialIndicatorDataFilter model constructor.
     * @property {module:model/FinancialIndicatorDataFilter}
     */
    FinancialIndicatorDataFilter: FinancialIndicatorDataFilter,
    /**
     * The FinancialIndicatorDataReport model constructor.
     * @property {module:model/FinancialIndicatorDataReport}
     */
    FinancialIndicatorDataReport: FinancialIndicatorDataReport,
    /**
     * The FinancialIndicatorValueBase model constructor.
     * @property {module:model/FinancialIndicatorValueBase}
     */
    FinancialIndicatorValueBase: FinancialIndicatorValueBase,
    /**
     * The FinancialsAndDecisionMakers model constructor.
     * @property {module:model/FinancialsAndDecisionMakers}
     */
    FinancialsAndDecisionMakers: FinancialsAndDecisionMakers,
    /**
     * The FinancialsFiscalReport model constructor.
     * @property {module:model/FinancialsFiscalReport}
     */
    FinancialsFiscalReport: FinancialsFiscalReport,
    /**
     * The ForecastModel model constructor.
     * @property {module:model/ForecastModel}
     */
    ForecastModel: ForecastModel,
    /**
     * The ForecastModelAggregationLevel model constructor.
     * @property {module:model/ForecastModelAggregationLevel}
     */
    ForecastModelAggregationLevel: ForecastModelAggregationLevel,
    /**
     * The ForecastModelAggregationLevelReport model constructor.
     * @property {module:model/ForecastModelAggregationLevelReport}
     */
    ForecastModelAggregationLevelReport: ForecastModelAggregationLevelReport,
    /**
     * The ForecastModelAggregationReport model constructor.
     * @property {module:model/ForecastModelAggregationReport}
     */
    ForecastModelAggregationReport: ForecastModelAggregationReport,
    /**
     * The ForecastModelDataEntry model constructor.
     * @property {module:model/ForecastModelDataEntry}
     */
    ForecastModelDataEntry: ForecastModelDataEntry,
    /**
     * The ForecastModelDataEntryCustomIndicator model constructor.
     * @property {module:model/ForecastModelDataEntryCustomIndicator}
     */
    ForecastModelDataEntryCustomIndicator: ForecastModelDataEntryCustomIndicator,
    /**
     * The ForecastModelDataEntryStatus model constructor.
     * @property {module:model/ForecastModelDataEntryStatus}
     */
    ForecastModelDataEntryStatus: ForecastModelDataEntryStatus,
    /**
     * The ForecastModelDataEntryType model constructor.
     * @property {module:model/ForecastModelDataEntryType}
     */
    ForecastModelDataEntryType: ForecastModelDataEntryType,
    /**
     * The ForecastModelRecordData model constructor.
     * @property {module:model/ForecastModelRecordData}
     */
    ForecastModelRecordData: ForecastModelRecordData,
    /**
     * The ForecastModelRecordDataActualSplitRange model constructor.
     * @property {module:model/ForecastModelRecordDataActualSplitRange}
     */
    ForecastModelRecordDataActualSplitRange: ForecastModelRecordDataActualSplitRange,
    /**
     * The ForecastModelRecordDataFile model constructor.
     * @property {module:model/ForecastModelRecordDataFile}
     */
    ForecastModelRecordDataFile: ForecastModelRecordDataFile,
    /**
     * The ForecastModelRecordDataFileReport model constructor.
     * @property {module:model/ForecastModelRecordDataFileReport}
     */
    ForecastModelRecordDataFileReport: ForecastModelRecordDataFileReport,
    /**
     * The ForecastModelRecordDataImportPeriodType model constructor.
     * @property {module:model/ForecastModelRecordDataImportPeriodType}
     */
    ForecastModelRecordDataImportPeriodType: ForecastModelRecordDataImportPeriodType,
    /**
     * The ForecastModelRecordDataReport model constructor.
     * @property {module:model/ForecastModelRecordDataReport}
     */
    ForecastModelRecordDataReport: ForecastModelRecordDataReport,
    /**
     * The ForecastModelRecordDataTransferLog model constructor.
     * @property {module:model/ForecastModelRecordDataTransferLog}
     */
    ForecastModelRecordDataTransferLog: ForecastModelRecordDataTransferLog,
    /**
     * The ForecastModelReport model constructor.
     * @property {module:model/ForecastModelReport}
     */
    ForecastModelReport: ForecastModelReport,
    /**
     * The ForesightScenario model constructor.
     * @property {module:model/ForesightScenario}
     */
    ForesightScenario: ForesightScenario,
    /**
     * The ForesightScenarioBaselineCalculation model constructor.
     * @property {module:model/ForesightScenarioBaselineCalculation}
     */
    ForesightScenarioBaselineCalculation: ForesightScenarioBaselineCalculation,
    /**
     * The ForesightScenarioElement model constructor.
     * @property {module:model/ForesightScenarioElement}
     */
    ForesightScenarioElement: ForesightScenarioElement,
    /**
     * The ForesightScenarioElementReport model constructor.
     * @property {module:model/ForesightScenarioElementReport}
     */
    ForesightScenarioElementReport: ForesightScenarioElementReport,
    /**
     * The ForesightScenarioElementType model constructor.
     * @property {module:model/ForesightScenarioElementType}
     */
    ForesightScenarioElementType: ForesightScenarioElementType,
    /**
     * The ForesightScenarioFactor model constructor.
     * @property {module:model/ForesightScenarioFactor}
     */
    ForesightScenarioFactor: ForesightScenarioFactor,
    /**
     * The ForesightScenarioLevel model constructor.
     * @property {module:model/ForesightScenarioLevel}
     */
    ForesightScenarioLevel: ForesightScenarioLevel,
    /**
     * The ForesightScenarioLevelReport model constructor.
     * @property {module:model/ForesightScenarioLevelReport}
     */
    ForesightScenarioLevelReport: ForesightScenarioLevelReport,
    /**
     * The ForesightScenarioNotificationRecipient model constructor.
     * @property {module:model/ForesightScenarioNotificationRecipient}
     */
    ForesightScenarioNotificationRecipient: ForesightScenarioNotificationRecipient,
    /**
     * The ForesightScenarioReport model constructor.
     * @property {module:model/ForesightScenarioReport}
     */
    ForesightScenarioReport: ForesightScenarioReport,
    /**
     * The FrontendErrorReport model constructor.
     * @property {module:model/FrontendErrorReport}
     */
    FrontendErrorReport: FrontendErrorReport,
    /**
     * The GeneralSettings model constructor.
     * @property {module:model/GeneralSettings}
     */
    GeneralSettings: GeneralSettings,
    /**
     * The GeoArea model constructor.
     * @property {module:model/GeoArea}
     */
    GeoArea: GeoArea,
    /**
     * The GoalMetric model constructor.
     * @property {module:model/GoalMetric}
     */
    GoalMetric: GoalMetric,
    /**
     * The GoalMetricReport model constructor.
     * @property {module:model/GoalMetricReport}
     */
    GoalMetricReport: GoalMetricReport,
    /**
     * The GoalMetricReportPaginationSlice model constructor.
     * @property {module:model/GoalMetricReportPaginationSlice}
     */
    GoalMetricReportPaginationSlice: GoalMetricReportPaginationSlice,
    /**
     * The GoalMetricValueSource model constructor.
     * @property {module:model/GoalMetricValueSource}
     */
    GoalMetricValueSource: GoalMetricValueSource,
    /**
     * The GoalMetricValueType model constructor.
     * @property {module:model/GoalMetricValueType}
     */
    GoalMetricValueType: GoalMetricValueType,
    /**
     * The GoogleAnalyticsAccount model constructor.
     * @property {module:model/GoogleAnalyticsAccount}
     */
    GoogleAnalyticsAccount: GoogleAnalyticsAccount,
    /**
     * The GoogleAnalyticsProfile model constructor.
     * @property {module:model/GoogleAnalyticsProfile}
     */
    GoogleAnalyticsProfile: GoogleAnalyticsProfile,
    /**
     * The GoogleAnalyticsProperty model constructor.
     * @property {module:model/GoogleAnalyticsProperty}
     */
    GoogleAnalyticsProperty: GoogleAnalyticsProperty,
    /**
     * The GoogleAnalyticsSettings model constructor.
     * @property {module:model/GoogleAnalyticsSettings}
     */
    GoogleAnalyticsSettings: GoogleAnalyticsSettings,
    /**
     * The GoogleOAuthUser model constructor.
     * @property {module:model/GoogleOAuthUser}
     */
    GoogleOAuthUser: GoogleOAuthUser,
    /**
     * The GroupCount model constructor.
     * @property {module:model/GroupCount}
     */
    GroupCount: GroupCount,
    /**
     * The HeaderColumn model constructor.
     * @property {module:model/HeaderColumn}
     */
    HeaderColumn: HeaderColumn,
    /**
     * The ImportAccountingActualsFileRequest model constructor.
     * @property {module:model/ImportAccountingActualsFileRequest}
     */
    ImportAccountingActualsFileRequest: ImportAccountingActualsFileRequest,
    /**
     * The InputValidationFeedback model constructor.
     * @property {module:model/InputValidationFeedback}
     */
    InputValidationFeedback: InputValidationFeedback,
    /**
     * The Insight model constructor.
     * @property {module:model/Insight}
     */
    Insight: Insight,
    /**
     * The InsightCompanyData model constructor.
     * @property {module:model/InsightCompanyData}
     */
    InsightCompanyData: InsightCompanyData,
    /**
     * The InsightDefaultExcludedDomain model constructor.
     * @property {module:model/InsightDefaultExcludedDomain}
     */
    InsightDefaultExcludedDomain: InsightDefaultExcludedDomain,
    /**
     * The InsightFilter model constructor.
     * @property {module:model/InsightFilter}
     */
    InsightFilter: InsightFilter,
    /**
     * The InsightImage model constructor.
     * @property {module:model/InsightImage}
     */
    InsightImage: InsightImage,
    /**
     * The InsightLinkReport model constructor.
     * @property {module:model/InsightLinkReport}
     */
    InsightLinkReport: InsightLinkReport,
    /**
     * The InsightReactionLink model constructor.
     * @property {module:model/InsightReactionLink}
     */
    InsightReactionLink: InsightReactionLink,
    /**
     * The InsightReactionType model constructor.
     * @property {module:model/InsightReactionType}
     */
    InsightReactionType: InsightReactionType,
    /**
     * The InsightReport model constructor.
     * @property {module:model/InsightReport}
     */
    InsightReport: InsightReport,
    /**
     * The InsightTaggedUser model constructor.
     * @property {module:model/InsightTaggedUser}
     */
    InsightTaggedUser: InsightTaggedUser,
    /**
     * The InsightType model constructor.
     * @property {module:model/InsightType}
     */
    InsightType: InsightType,
    /**
     * The IntegrationDataMappingDimension model constructor.
     * @property {module:model/IntegrationDataMappingDimension}
     */
    IntegrationDataMappingDimension: IntegrationDataMappingDimension,
    /**
     * The IntegrationDataMappingMatchRule model constructor.
     * @property {module:model/IntegrationDataMappingMatchRule}
     */
    IntegrationDataMappingMatchRule: IntegrationDataMappingMatchRule,
    /**
     * The IntegrationDataMappingRule model constructor.
     * @property {module:model/IntegrationDataMappingRule}
     */
    IntegrationDataMappingRule: IntegrationDataMappingRule,
    /**
     * The IntegrationDataMappingSource model constructor.
     * @property {module:model/IntegrationDataMappingSource}
     */
    IntegrationDataMappingSource: IntegrationDataMappingSource,
    /**
     * The IntegrationFinancialUploadBatch model constructor.
     * @property {module:model/IntegrationFinancialUploadBatch}
     */
    IntegrationFinancialUploadBatch: IntegrationFinancialUploadBatch,
    /**
     * The IntegrationFinancialUploadBatchExcelFile model constructor.
     * @property {module:model/IntegrationFinancialUploadBatchExcelFile}
     */
    IntegrationFinancialUploadBatchExcelFile: IntegrationFinancialUploadBatchExcelFile,
    /**
     * The IntegrationFinancialUploadBatchFileReport model constructor.
     * @property {module:model/IntegrationFinancialUploadBatchFileReport}
     */
    IntegrationFinancialUploadBatchFileReport: IntegrationFinancialUploadBatchFileReport,
    /**
     * The IntegrationPipedriveSettings model constructor.
     * @property {module:model/IntegrationPipedriveSettings}
     */
    IntegrationPipedriveSettings: IntegrationPipedriveSettings,
    /**
     * The IntegrationPipedriveSettingsPipeline model constructor.
     * @property {module:model/IntegrationPipedriveSettingsPipeline}
     */
    IntegrationPipedriveSettingsPipeline: IntegrationPipedriveSettingsPipeline,
    /**
     * The IntegrationPipedriveSettingsPipelineReport model constructor.
     * @property {module:model/IntegrationPipedriveSettingsPipelineReport}
     */
    IntegrationPipedriveSettingsPipelineReport: IntegrationPipedriveSettingsPipelineReport,
    /**
     * The IntegrationPipedriveSettingsPipelineReportPaginationSlice model constructor.
     * @property {module:model/IntegrationPipedriveSettingsPipelineReportPaginationSlice}
     */
    IntegrationPipedriveSettingsPipelineReportPaginationSlice: IntegrationPipedriveSettingsPipelineReportPaginationSlice,
    /**
     * The IntegrationPipedriveSettingsPipelineStage model constructor.
     * @property {module:model/IntegrationPipedriveSettingsPipelineStage}
     */
    IntegrationPipedriveSettingsPipelineStage: IntegrationPipedriveSettingsPipelineStage,
    /**
     * The IntegrationPipedriveSettingsPipelineStagePaginationSlice model constructor.
     * @property {module:model/IntegrationPipedriveSettingsPipelineStagePaginationSlice}
     */
    IntegrationPipedriveSettingsPipelineStagePaginationSlice: IntegrationPipedriveSettingsPipelineStagePaginationSlice,
    /**
     * The IntegrationPipedriveSettingsReport model constructor.
     * @property {module:model/IntegrationPipedriveSettingsReport}
     */
    IntegrationPipedriveSettingsReport: IntegrationPipedriveSettingsReport,
    /**
     * The IntegrationSettingsNetvisorSyncDefaultHandleType model constructor.
     * @property {module:model/IntegrationSettingsNetvisorSyncDefaultHandleType}
     */
    IntegrationSettingsNetvisorSyncDefaultHandleType: IntegrationSettingsNetvisorSyncDefaultHandleType,
    /**
     * The IntegrationSource model constructor.
     * @property {module:model/IntegrationSource}
     */
    IntegrationSource: IntegrationSource,
    /**
     * The IntegrationSourceCompanyStatus model constructor.
     * @property {module:model/IntegrationSourceCompanyStatus}
     */
    IntegrationSourceCompanyStatus: IntegrationSourceCompanyStatus,
    /**
     * The InvoicingDataLightReport model constructor.
     * @property {module:model/InvoicingDataLightReport}
     */
    InvoicingDataLightReport: InvoicingDataLightReport,
    /**
     * The InvoicingDataLightReportPaginationSlice model constructor.
     * @property {module:model/InvoicingDataLightReportPaginationSlice}
     */
    InvoicingDataLightReportPaginationSlice: InvoicingDataLightReportPaginationSlice,
    /**
     * The InvoicingDataPreviewReport model constructor.
     * @property {module:model/InvoicingDataPreviewReport}
     */
    InvoicingDataPreviewReport: InvoicingDataPreviewReport,
    /**
     * The InvoicingDataReceivableReport model constructor.
     * @property {module:model/InvoicingDataReceivableReport}
     */
    InvoicingDataReceivableReport: InvoicingDataReceivableReport,
    /**
     * The InvoicingDataReceivableReportPaginationSlice model constructor.
     * @property {module:model/InvoicingDataReceivableReportPaginationSlice}
     */
    InvoicingDataReceivableReportPaginationSlice: InvoicingDataReceivableReportPaginationSlice,
    /**
     * The LSDStrategyProgressReport model constructor.
     * @property {module:model/LSDStrategyProgressReport}
     */
    LSDStrategyProgressReport: LSDStrategyProgressReport,
    /**
     * The LastFinancialPeriodType model constructor.
     * @property {module:model/LastFinancialPeriodType}
     */
    LastFinancialPeriodType: LastFinancialPeriodType,
    /**
     * The LemonsoftIntegrationSettings model constructor.
     * @property {module:model/LemonsoftIntegrationSettings}
     */
    LemonsoftIntegrationSettings: LemonsoftIntegrationSettings,
    /**
     * The LivingStrategyDashboardReport model constructor.
     * @property {module:model/LivingStrategyDashboardReport}
     */
    LivingStrategyDashboardReport: LivingStrategyDashboardReport,
    /**
     * The MapDataReport model constructor.
     * @property {module:model/MapDataReport}
     */
    MapDataReport: MapDataReport,
    /**
     * The MapRegionDataReport model constructor.
     * @property {module:model/MapRegionDataReport}
     */
    MapRegionDataReport: MapRegionDataReport,
    /**
     * The Market model constructor.
     * @property {module:model/Market}
     */
    Market: Market,
    /**
     * The MarketFeedBingCognitive model constructor.
     * @property {module:model/MarketFeedBingCognitive}
     */
    MarketFeedBingCognitive: MarketFeedBingCognitive,
    /**
     * The MarketFreeNode model constructor.
     * @property {module:model/MarketFreeNode}
     */
    MarketFreeNode: MarketFreeNode,
    /**
     * The MarketRSSWatchSetting model constructor.
     * @property {module:model/MarketRSSWatchSetting}
     */
    MarketRSSWatchSetting: MarketRSSWatchSetting,
    /**
     * The MarketRSSWatchSettingFeedData model constructor.
     * @property {module:model/MarketRSSWatchSettingFeedData}
     */
    MarketRSSWatchSettingFeedData: MarketRSSWatchSettingFeedData,
    /**
     * The MarketRSSWatchSettingReport model constructor.
     * @property {module:model/MarketRSSWatchSettingReport}
     */
    MarketRSSWatchSettingReport: MarketRSSWatchSettingReport,
    /**
     * The MarketScopeType model constructor.
     * @property {module:model/MarketScopeType}
     */
    MarketScopeType: MarketScopeType,
    /**
     * The MarketSearchTemplateQuery model constructor.
     * @property {module:model/MarketSearchTemplateQuery}
     */
    MarketSearchTemplateQuery: MarketSearchTemplateQuery,
    /**
     * The MarketSearchTemplateReport model constructor.
     * @property {module:model/MarketSearchTemplateReport}
     */
    MarketSearchTemplateReport: MarketSearchTemplateReport,
    /**
     * The MasterSearchReport model constructor.
     * @property {module:model/MasterSearchReport}
     */
    MasterSearchReport: MasterSearchReport,
    /**
     * The MasterSearchReportItem model constructor.
     * @property {module:model/MasterSearchReportItem}
     */
    MasterSearchReportItem: MasterSearchReportItem,
    /**
     * The MasterSearchUserInput model constructor.
     * @property {module:model/MasterSearchUserInput}
     */
    MasterSearchUserInput: MasterSearchUserInput,
    /**
     * The Meeting model constructor.
     * @property {module:model/Meeting}
     */
    Meeting: Meeting,
    /**
     * The MeetingAdministrator model constructor.
     * @property {module:model/MeetingAdministrator}
     */
    MeetingAdministrator: MeetingAdministrator,
    /**
     * The MeetingInvitationPeriodType model constructor.
     * @property {module:model/MeetingInvitationPeriodType}
     */
    MeetingInvitationPeriodType: MeetingInvitationPeriodType,
    /**
     * The MeetingMinutesContentType model constructor.
     * @property {module:model/MeetingMinutesContentType}
     */
    MeetingMinutesContentType: MeetingMinutesContentType,
    /**
     * The MeetingMinutesReport model constructor.
     * @property {module:model/MeetingMinutesReport}
     */
    MeetingMinutesReport: MeetingMinutesReport,
    /**
     * The MeetingMinutesSignature model constructor.
     * @property {module:model/MeetingMinutesSignature}
     */
    MeetingMinutesSignature: MeetingMinutesSignature,
    /**
     * The MeetingParticipant model constructor.
     * @property {module:model/MeetingParticipant}
     */
    MeetingParticipant: MeetingParticipant,
    /**
     * The MeetingReport model constructor.
     * @property {module:model/MeetingReport}
     */
    MeetingReport: MeetingReport,
    /**
     * The MeetingSection model constructor.
     * @property {module:model/MeetingSection}
     */
    MeetingSection: MeetingSection,
    /**
     * The MeetingSectionContentType model constructor.
     * @property {module:model/MeetingSectionContentType}
     */
    MeetingSectionContentType: MeetingSectionContentType,
    /**
     * The MeetingSectionReport model constructor.
     * @property {module:model/MeetingSectionReport}
     */
    MeetingSectionReport: MeetingSectionReport,
    /**
     * The MeetingSectionReportPaginationSlice model constructor.
     * @property {module:model/MeetingSectionReportPaginationSlice}
     */
    MeetingSectionReportPaginationSlice: MeetingSectionReportPaginationSlice,
    /**
     * The MeetingSectionTextTopic model constructor.
     * @property {module:model/MeetingSectionTextTopic}
     */
    MeetingSectionTextTopic: MeetingSectionTextTopic,
    /**
     * The MeetingSectionTopic model constructor.
     * @property {module:model/MeetingSectionTopic}
     */
    MeetingSectionTopic: MeetingSectionTopic,
    /**
     * The MeetingSectionTopicAttachment model constructor.
     * @property {module:model/MeetingSectionTopicAttachment}
     */
    MeetingSectionTopicAttachment: MeetingSectionTopicAttachment,
    /**
     * The MeetingSectionTopicComment model constructor.
     * @property {module:model/MeetingSectionTopicComment}
     */
    MeetingSectionTopicComment: MeetingSectionTopicComment,
    /**
     * The MeetingSectionTopicCommentPaginationSlice model constructor.
     * @property {module:model/MeetingSectionTopicCommentPaginationSlice}
     */
    MeetingSectionTopicCommentPaginationSlice: MeetingSectionTopicCommentPaginationSlice,
    /**
     * The MeetingSectionTopicLink model constructor.
     * @property {module:model/MeetingSectionTopicLink}
     */
    MeetingSectionTopicLink: MeetingSectionTopicLink,
    /**
     * The MeetingSectionTopicReport model constructor.
     * @property {module:model/MeetingSectionTopicReport}
     */
    MeetingSectionTopicReport: MeetingSectionTopicReport,
    /**
     * The MeetingStatus model constructor.
     * @property {module:model/MeetingStatus}
     */
    MeetingStatus: MeetingStatus,
    /**
     * The MeetingTemplate model constructor.
     * @property {module:model/MeetingTemplate}
     */
    MeetingTemplate: MeetingTemplate,
    /**
     * The MeetingTemplateAdministrator model constructor.
     * @property {module:model/MeetingTemplateAdministrator}
     */
    MeetingTemplateAdministrator: MeetingTemplateAdministrator,
    /**
     * The MeetingTemplateParticipant model constructor.
     * @property {module:model/MeetingTemplateParticipant}
     */
    MeetingTemplateParticipant: MeetingTemplateParticipant,
    /**
     * The MeetingTemplateReport model constructor.
     * @property {module:model/MeetingTemplateReport}
     */
    MeetingTemplateReport: MeetingTemplateReport,
    /**
     * The MeetingTemplateSection model constructor.
     * @property {module:model/MeetingTemplateSection}
     */
    MeetingTemplateSection: MeetingTemplateSection,
    /**
     * The MeetingTemplateSectionReport model constructor.
     * @property {module:model/MeetingTemplateSectionReport}
     */
    MeetingTemplateSectionReport: MeetingTemplateSectionReport,
    /**
     * The MeetingTemplateSectionTextTopic model constructor.
     * @property {module:model/MeetingTemplateSectionTextTopic}
     */
    MeetingTemplateSectionTextTopic: MeetingTemplateSectionTextTopic,
    /**
     * The MeetingTemplateSectionTopic model constructor.
     * @property {module:model/MeetingTemplateSectionTopic}
     */
    MeetingTemplateSectionTopic: MeetingTemplateSectionTopic,
    /**
     * The MeetingTemplateSectionTopicLink model constructor.
     * @property {module:model/MeetingTemplateSectionTopicLink}
     */
    MeetingTemplateSectionTopicLink: MeetingTemplateSectionTopicLink,
    /**
     * The MeetingTemplateSectionTopicReport model constructor.
     * @property {module:model/MeetingTemplateSectionTopicReport}
     */
    MeetingTemplateSectionTopicReport: MeetingTemplateSectionTopicReport,
    /**
     * The MicrosoftTeamsBotLinkedConversation model constructor.
     * @property {module:model/MicrosoftTeamsBotLinkedConversation}
     */
    MicrosoftTeamsBotLinkedConversation: MicrosoftTeamsBotLinkedConversation,
    /**
     * The MobileClientToken model constructor.
     * @property {module:model/MobileClientToken}
     */
    MobileClientToken: MobileClientToken,
    /**
     * The NewsEntry model constructor.
     * @property {module:model/NewsEntry}
     */
    NewsEntry: NewsEntry,
    /**
     * The NewsEntryAutomatedSource model constructor.
     * @property {module:model/NewsEntryAutomatedSource}
     */
    NewsEntryAutomatedSource: NewsEntryAutomatedSource,
    /**
     * The NewsEntryCategory model constructor.
     * @property {module:model/NewsEntryCategory}
     */
    NewsEntryCategory: NewsEntryCategory,
    /**
     * The NewsEntryComment model constructor.
     * @property {module:model/NewsEntryComment}
     */
    NewsEntryComment: NewsEntryComment,
    /**
     * The NewsEntryCommentPaginationSlice model constructor.
     * @property {module:model/NewsEntryCommentPaginationSlice}
     */
    NewsEntryCommentPaginationSlice: NewsEntryCommentPaginationSlice,
    /**
     * The NewsEntryCommentReport model constructor.
     * @property {module:model/NewsEntryCommentReport}
     */
    NewsEntryCommentReport: NewsEntryCommentReport,
    /**
     * The NewsEntryCommentReportPaginationSlice model constructor.
     * @property {module:model/NewsEntryCommentReportPaginationSlice}
     */
    NewsEntryCommentReportPaginationSlice: NewsEntryCommentReportPaginationSlice,
    /**
     * The NewsEntryContributor model constructor.
     * @property {module:model/NewsEntryContributor}
     */
    NewsEntryContributor: NewsEntryContributor,
    /**
     * The NewsEntryContributorPaginationSlice model constructor.
     * @property {module:model/NewsEntryContributorPaginationSlice}
     */
    NewsEntryContributorPaginationSlice: NewsEntryContributorPaginationSlice,
    /**
     * The NewsEntryEntryStatus model constructor.
     * @property {module:model/NewsEntryEntryStatus}
     */
    NewsEntryEntryStatus: NewsEntryEntryStatus,
    /**
     * The NewsEntryFilter model constructor.
     * @property {module:model/NewsEntryFilter}
     */
    NewsEntryFilter: NewsEntryFilter,
    /**
     * The NewsEntryFullReport model constructor.
     * @property {module:model/NewsEntryFullReport}
     */
    NewsEntryFullReport: NewsEntryFullReport,
    /**
     * The NewsEntryFullReportNewsEntryReportPaginationSlice model constructor.
     * @property {module:model/NewsEntryFullReportNewsEntryReportPaginationSlice}
     */
    NewsEntryFullReportNewsEntryReportPaginationSlice: NewsEntryFullReportNewsEntryReportPaginationSlice,
    /**
     * The NewsEntryInsightLink model constructor.
     * @property {module:model/NewsEntryInsightLink}
     */
    NewsEntryInsightLink: NewsEntryInsightLink,
    /**
     * The NewsEntryLightReport model constructor.
     * @property {module:model/NewsEntryLightReport}
     */
    NewsEntryLightReport: NewsEntryLightReport,
    /**
     * The NewsEntryLightReportNewsEntryReportPaginationSlice model constructor.
     * @property {module:model/NewsEntryLightReportNewsEntryReportPaginationSlice}
     */
    NewsEntryLightReportNewsEntryReportPaginationSlice: NewsEntryLightReportNewsEntryReportPaginationSlice,
    /**
     * The NewsEntrySourceCategory model constructor.
     * @property {module:model/NewsEntrySourceCategory}
     */
    NewsEntrySourceCategory: NewsEntrySourceCategory,
    /**
     * The NewsEntrySourceReport model constructor.
     * @property {module:model/NewsEntrySourceReport}
     */
    NewsEntrySourceReport: NewsEntrySourceReport,
    /**
     * The NewsEntrySourceReportPaginationSlice model constructor.
     * @property {module:model/NewsEntrySourceReportPaginationSlice}
     */
    NewsEntrySourceReportPaginationSlice: NewsEntrySourceReportPaginationSlice,
    /**
     * The NewsEntrySourceType model constructor.
     * @property {module:model/NewsEntrySourceType}
     */
    NewsEntrySourceType: NewsEntrySourceType,
    /**
     * The NewsEntryUserStatus model constructor.
     * @property {module:model/NewsEntryUserStatus}
     */
    NewsEntryUserStatus: NewsEntryUserStatus,
    /**
     * The NotificationFilter model constructor.
     * @property {module:model/NotificationFilter}
     */
    NotificationFilter: NotificationFilter,
    /**
     * The NotificationGroupCount model constructor.
     * @property {module:model/NotificationGroupCount}
     */
    NotificationGroupCount: NotificationGroupCount,
    /**
     * The NotificationReport model constructor.
     * @property {module:model/NotificationReport}
     */
    NotificationReport: NotificationReport,
    /**
     * The NotificationReportPaginationSlice model constructor.
     * @property {module:model/NotificationReportPaginationSlice}
     */
    NotificationReportPaginationSlice: NotificationReportPaginationSlice,
    /**
     * The NotificationSendingTimeType model constructor.
     * @property {module:model/NotificationSendingTimeType}
     */
    NotificationSendingTimeType: NotificationSendingTimeType,
    /**
     * The NotificationType model constructor.
     * @property {module:model/NotificationType}
     */
    NotificationType: NotificationType,
    /**
     * The OpencorporatesOrganization model constructor.
     * @property {module:model/OpencorporatesOrganization}
     */
    OpencorporatesOrganization: OpencorporatesOrganization,
    /**
     * The OpencorporatesOrganizationPaginationSlice model constructor.
     * @property {module:model/OpencorporatesOrganizationPaginationSlice}
     */
    OpencorporatesOrganizationPaginationSlice: OpencorporatesOrganizationPaginationSlice,
    /**
     * The Organization model constructor.
     * @property {module:model/Organization}
     */
    Organization: Organization,
    /**
     * The OrganizationClassificationType model constructor.
     * @property {module:model/OrganizationClassificationType}
     */
    OrganizationClassificationType: OrganizationClassificationType,
    /**
     * The OrganizationIndexSearchResultExtended model constructor.
     * @property {module:model/OrganizationIndexSearchResultExtended}
     */
    OrganizationIndexSearchResultExtended: OrganizationIndexSearchResultExtended,
    /**
     * The OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport model constructor.
     * @property {module:model/OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport}
     */
    OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport: OrganizationIndexSearchResultExtendedOrganizationKeywordSearchReport,
    /**
     * The OrganizationItemLight model constructor.
     * @property {module:model/OrganizationItemLight}
     */
    OrganizationItemLight: OrganizationItemLight,
    /**
     * The OrganizationItemLightPaginationSlice model constructor.
     * @property {module:model/OrganizationItemLightPaginationSlice}
     */
    OrganizationItemLightPaginationSlice: OrganizationItemLightPaginationSlice,
    /**
     * The OrganizationPaginationSlice model constructor.
     * @property {module:model/OrganizationPaginationSlice}
     */
    OrganizationPaginationSlice: OrganizationPaginationSlice,
    /**
     * The PartnerClientCompany model constructor.
     * @property {module:model/PartnerClientCompany}
     */
    PartnerClientCompany: PartnerClientCompany,
    /**
     * The PartnerClientCompanyEvent model constructor.
     * @property {module:model/PartnerClientCompanyEvent}
     */
    PartnerClientCompanyEvent: PartnerClientCompanyEvent,
    /**
     * The PartnerClientCompanyEventType model constructor.
     * @property {module:model/PartnerClientCompanyEventType}
     */
    PartnerClientCompanyEventType: PartnerClientCompanyEventType,
    /**
     * The PartnerClientCompanyReport model constructor.
     * @property {module:model/PartnerClientCompanyReport}
     */
    PartnerClientCompanyReport: PartnerClientCompanyReport,
    /**
     * The PartnerClientCompanyType model constructor.
     * @property {module:model/PartnerClientCompanyType}
     */
    PartnerClientCompanyType: PartnerClientCompanyType,
    /**
     * The PartnerCompany model constructor.
     * @property {module:model/PartnerCompany}
     */
    PartnerCompany: PartnerCompany,
    /**
     * The PartnerSupportLevel model constructor.
     * @property {module:model/PartnerSupportLevel}
     */
    PartnerSupportLevel: PartnerSupportLevel,
    /**
     * The PaymentDisturbance model constructor.
     * @property {module:model/PaymentDisturbance}
     */
    PaymentDisturbance: PaymentDisturbance,
    /**
     * The PerformanceIndicator model constructor.
     * @property {module:model/PerformanceIndicator}
     */
    PerformanceIndicator: PerformanceIndicator,
    /**
     * The PerformanceIndicatorAvailabilityReport model constructor.
     * @property {module:model/PerformanceIndicatorAvailabilityReport}
     */
    PerformanceIndicatorAvailabilityReport: PerformanceIndicatorAvailabilityReport,
    /**
     * The PerformanceIndicatorCalculationRange model constructor.
     * @property {module:model/PerformanceIndicatorCalculationRange}
     */
    PerformanceIndicatorCalculationRange: PerformanceIndicatorCalculationRange,
    /**
     * The PerformanceIndicatorCollectionType model constructor.
     * @property {module:model/PerformanceIndicatorCollectionType}
     */
    PerformanceIndicatorCollectionType: PerformanceIndicatorCollectionType,
    /**
     * The PerformanceIndicatorComparisonCalculation model constructor.
     * @property {module:model/PerformanceIndicatorComparisonCalculation}
     */
    PerformanceIndicatorComparisonCalculation: PerformanceIndicatorComparisonCalculation,
    /**
     * The PerformanceIndicatorComparisonTarget model constructor.
     * @property {module:model/PerformanceIndicatorComparisonTarget}
     */
    PerformanceIndicatorComparisonTarget: PerformanceIndicatorComparisonTarget,
    /**
     * The PerformanceIndicatorConversation model constructor.
     * @property {module:model/PerformanceIndicatorConversation}
     */
    PerformanceIndicatorConversation: PerformanceIndicatorConversation,
    /**
     * The PerformanceIndicatorConversationReport model constructor.
     * @property {module:model/PerformanceIndicatorConversationReport}
     */
    PerformanceIndicatorConversationReport: PerformanceIndicatorConversationReport,
    /**
     * The PerformanceIndicatorDataBase model constructor.
     * @property {module:model/PerformanceIndicatorDataBase}
     */
    PerformanceIndicatorDataBase: PerformanceIndicatorDataBase,
    /**
     * The PerformanceIndicatorDataCopySettings model constructor.
     * @property {module:model/PerformanceIndicatorDataCopySettings}
     */
    PerformanceIndicatorDataCopySettings: PerformanceIndicatorDataCopySettings,
    /**
     * The PerformanceIndicatorDataExtrapolationSettings model constructor.
     * @property {module:model/PerformanceIndicatorDataExtrapolationSettings}
     */
    PerformanceIndicatorDataExtrapolationSettings: PerformanceIndicatorDataExtrapolationSettings,
    /**
     * The PerformanceIndicatorDataFilter model constructor.
     * @property {module:model/PerformanceIndicatorDataFilter}
     */
    PerformanceIndicatorDataFilter: PerformanceIndicatorDataFilter,
    /**
     * The PerformanceIndicatorDataReport model constructor.
     * @property {module:model/PerformanceIndicatorDataReport}
     */
    PerformanceIndicatorDataReport: PerformanceIndicatorDataReport,
    /**
     * The PerformanceIndicatorDateRange model constructor.
     * @property {module:model/PerformanceIndicatorDateRange}
     */
    PerformanceIndicatorDateRange: PerformanceIndicatorDateRange,
    /**
     * The PerformanceIndicatorDayData model constructor.
     * @property {module:model/PerformanceIndicatorDayData}
     */
    PerformanceIndicatorDayData: PerformanceIndicatorDayData,
    /**
     * The PerformanceIndicatorDimension model constructor.
     * @property {module:model/PerformanceIndicatorDimension}
     */
    PerformanceIndicatorDimension: PerformanceIndicatorDimension,
    /**
     * The PerformanceIndicatorDrillData model constructor.
     * @property {module:model/PerformanceIndicatorDrillData}
     */
    PerformanceIndicatorDrillData: PerformanceIndicatorDrillData,
    /**
     * The PerformanceIndicatorFormula model constructor.
     * @property {module:model/PerformanceIndicatorFormula}
     */
    PerformanceIndicatorFormula: PerformanceIndicatorFormula,
    /**
     * The PerformanceIndicatorFormulaElementType model constructor.
     * @property {module:model/PerformanceIndicatorFormulaElementType}
     */
    PerformanceIndicatorFormulaElementType: PerformanceIndicatorFormulaElementType,
    /**
     * The PerformanceIndicatorGroupReport model constructor.
     * @property {module:model/PerformanceIndicatorGroupReport}
     */
    PerformanceIndicatorGroupReport: PerformanceIndicatorGroupReport,
    /**
     * The PerformanceIndicatorMonthData model constructor.
     * @property {module:model/PerformanceIndicatorMonthData}
     */
    PerformanceIndicatorMonthData: PerformanceIndicatorMonthData,
    /**
     * The PerformanceIndicatorPeriodType model constructor.
     * @property {module:model/PerformanceIndicatorPeriodType}
     */
    PerformanceIndicatorPeriodType: PerformanceIndicatorPeriodType,
    /**
     * The PerformanceIndicatorPointCalculation model constructor.
     * @property {module:model/PerformanceIndicatorPointCalculation}
     */
    PerformanceIndicatorPointCalculation: PerformanceIndicatorPointCalculation,
    /**
     * The PerformanceIndicatorPollBatch model constructor.
     * @property {module:model/PerformanceIndicatorPollBatch}
     */
    PerformanceIndicatorPollBatch: PerformanceIndicatorPollBatch,
    /**
     * The PerformanceIndicatorPollBatchPaginationSlice model constructor.
     * @property {module:model/PerformanceIndicatorPollBatchPaginationSlice}
     */
    PerformanceIndicatorPollBatchPaginationSlice: PerformanceIndicatorPollBatchPaginationSlice,
    /**
     * The PerformanceIndicatorPollBatchUserReport model constructor.
     * @property {module:model/PerformanceIndicatorPollBatchUserReport}
     */
    PerformanceIndicatorPollBatchUserReport: PerformanceIndicatorPollBatchUserReport,
    /**
     * The PerformanceIndicatorPollBatchUserReportPaginationSlice model constructor.
     * @property {module:model/PerformanceIndicatorPollBatchUserReportPaginationSlice}
     */
    PerformanceIndicatorPollBatchUserReportPaginationSlice: PerformanceIndicatorPollBatchUserReportPaginationSlice,
    /**
     * The PerformanceIndicatorPollGeneralResponseReport model constructor.
     * @property {module:model/PerformanceIndicatorPollGeneralResponseReport}
     */
    PerformanceIndicatorPollGeneralResponseReport: PerformanceIndicatorPollGeneralResponseReport,
    /**
     * The PerformanceIndicatorPollGeneralResponseReportPaginationSlice model constructor.
     * @property {module:model/PerformanceIndicatorPollGeneralResponseReportPaginationSlice}
     */
    PerformanceIndicatorPollGeneralResponseReportPaginationSlice: PerformanceIndicatorPollGeneralResponseReportPaginationSlice,
    /**
     * The PerformanceIndicatorPollSettings model constructor.
     * @property {module:model/PerformanceIndicatorPollSettings}
     */
    PerformanceIndicatorPollSettings: PerformanceIndicatorPollSettings,
    /**
     * The PerformanceIndicatorPollSettingsLightReport model constructor.
     * @property {module:model/PerformanceIndicatorPollSettingsLightReport}
     */
    PerformanceIndicatorPollSettingsLightReport: PerformanceIndicatorPollSettingsLightReport,
    /**
     * The PerformanceIndicatorPollStatus model constructor.
     * @property {module:model/PerformanceIndicatorPollStatus}
     */
    PerformanceIndicatorPollStatus: PerformanceIndicatorPollStatus,
    /**
     * The PerformanceIndicatorPollValueAggregationType model constructor.
     * @property {module:model/PerformanceIndicatorPollValueAggregationType}
     */
    PerformanceIndicatorPollValueAggregationType: PerformanceIndicatorPollValueAggregationType,
    /**
     * The PerformanceIndicatorPollValueType model constructor.
     * @property {module:model/PerformanceIndicatorPollValueType}
     */
    PerformanceIndicatorPollValueType: PerformanceIndicatorPollValueType,
    /**
     * The PerformanceIndicatorQuarterData model constructor.
     * @property {module:model/PerformanceIndicatorQuarterData}
     */
    PerformanceIndicatorQuarterData: PerformanceIndicatorQuarterData,
    /**
     * The PerformanceIndicatorRelativePeriod model constructor.
     * @property {module:model/PerformanceIndicatorRelativePeriod}
     */
    PerformanceIndicatorRelativePeriod: PerformanceIndicatorRelativePeriod,
    /**
     * The PerformanceIndicatorReport model constructor.
     * @property {module:model/PerformanceIndicatorReport}
     */
    PerformanceIndicatorReport: PerformanceIndicatorReport,
    /**
     * The PerformanceIndicatorSystemType model constructor.
     * @property {module:model/PerformanceIndicatorSystemType}
     */
    PerformanceIndicatorSystemType: PerformanceIndicatorSystemType,
    /**
     * The PerformanceIndicatorValueDependencyRule model constructor.
     * @property {module:model/PerformanceIndicatorValueDependencyRule}
     */
    PerformanceIndicatorValueDependencyRule: PerformanceIndicatorValueDependencyRule,
    /**
     * The PerformanceIndicatorValueSource model constructor.
     * @property {module:model/PerformanceIndicatorValueSource}
     */
    PerformanceIndicatorValueSource: PerformanceIndicatorValueSource,
    /**
     * The PerformanceIndicatorWeekData model constructor.
     * @property {module:model/PerformanceIndicatorWeekData}
     */
    PerformanceIndicatorWeekData: PerformanceIndicatorWeekData,
    /**
     * The PerformanceIndicatorYearData model constructor.
     * @property {module:model/PerformanceIndicatorYearData}
     */
    PerformanceIndicatorYearData: PerformanceIndicatorYearData,
    /**
     * The PerformanceManagementAlert model constructor.
     * @property {module:model/PerformanceManagementAlert}
     */
    PerformanceManagementAlert: PerformanceManagementAlert,
    /**
     * The PerformanceManagementAlertActivityStatus model constructor.
     * @property {module:model/PerformanceManagementAlertActivityStatus}
     */
    PerformanceManagementAlertActivityStatus: PerformanceManagementAlertActivityStatus,
    /**
     * The PerformanceManagementAlertDashboardBlock model constructor.
     * @property {module:model/PerformanceManagementAlertDashboardBlock}
     */
    PerformanceManagementAlertDashboardBlock: PerformanceManagementAlertDashboardBlock,
    /**
     * The PerformanceManagementAlertDashboardBlockComment model constructor.
     * @property {module:model/PerformanceManagementAlertDashboardBlockComment}
     */
    PerformanceManagementAlertDashboardBlockComment: PerformanceManagementAlertDashboardBlockComment,
    /**
     * The PerformanceManagementAlertDashboardBlockReport model constructor.
     * @property {module:model/PerformanceManagementAlertDashboardBlockReport}
     */
    PerformanceManagementAlertDashboardBlockReport: PerformanceManagementAlertDashboardBlockReport,
    /**
     * The PerformanceManagementAlertDeliveryChannel model constructor.
     * @property {module:model/PerformanceManagementAlertDeliveryChannel}
     */
    PerformanceManagementAlertDeliveryChannel: PerformanceManagementAlertDeliveryChannel,
    /**
     * The PerformanceManagementAlertEmailTitleType model constructor.
     * @property {module:model/PerformanceManagementAlertEmailTitleType}
     */
    PerformanceManagementAlertEmailTitleType: PerformanceManagementAlertEmailTitleType,
    /**
     * The PerformanceManagementAlertIndicator model constructor.
     * @property {module:model/PerformanceManagementAlertIndicator}
     */
    PerformanceManagementAlertIndicator: PerformanceManagementAlertIndicator,
    /**
     * The PerformanceManagementAlertRecipient model constructor.
     * @property {module:model/PerformanceManagementAlertRecipient}
     */
    PerformanceManagementAlertRecipient: PerformanceManagementAlertRecipient,
    /**
     * The PerformanceManagementAlertReport model constructor.
     * @property {module:model/PerformanceManagementAlertReport}
     */
    PerformanceManagementAlertReport: PerformanceManagementAlertReport,
    /**
     * The PerformanceManagementAlertReportNestedPaginationSlice model constructor.
     * @property {module:model/PerformanceManagementAlertReportNestedPaginationSlice}
     */
    PerformanceManagementAlertReportNestedPaginationSlice: PerformanceManagementAlertReportNestedPaginationSlice,
    /**
     * The PerformanceManagementAlertReviewSection model constructor.
     * @property {module:model/PerformanceManagementAlertReviewSection}
     */
    PerformanceManagementAlertReviewSection: PerformanceManagementAlertReviewSection,
    /**
     * The PerformanceManagementAlertReviewSectionComment model constructor.
     * @property {module:model/PerformanceManagementAlertReviewSectionComment}
     */
    PerformanceManagementAlertReviewSectionComment: PerformanceManagementAlertReviewSectionComment,
    /**
     * The PerformanceManagementAlertReviewSectionReport model constructor.
     * @property {module:model/PerformanceManagementAlertReviewSectionReport}
     */
    PerformanceManagementAlertReviewSectionReport: PerformanceManagementAlertReviewSectionReport,
    /**
     * The PerformanceManagementAlertScore model constructor.
     * @property {module:model/PerformanceManagementAlertScore}
     */
    PerformanceManagementAlertScore: PerformanceManagementAlertScore,
    /**
     * The PerformanceManagementAlertTriggerIndicator model constructor.
     * @property {module:model/PerformanceManagementAlertTriggerIndicator}
     */
    PerformanceManagementAlertTriggerIndicator: PerformanceManagementAlertTriggerIndicator,
    /**
     * The PerformanceManagementAlertTriggerType model constructor.
     * @property {module:model/PerformanceManagementAlertTriggerType}
     */
    PerformanceManagementAlertTriggerType: PerformanceManagementAlertTriggerType,
    /**
     * The PerformancePerspective model constructor.
     * @property {module:model/PerformancePerspective}
     */
    PerformancePerspective: PerformancePerspective,
    /**
     * The PerformancePerspectiveGroup model constructor.
     * @property {module:model/PerformancePerspectiveGroup}
     */
    PerformancePerspectiveGroup: PerformancePerspectiveGroup,
    /**
     * The PersonalTopic model constructor.
     * @property {module:model/PersonalTopic}
     */
    PersonalTopic: PersonalTopic,
    /**
     * The PollReport model constructor.
     * @property {module:model/PollReport}
     */
    PollReport: PollReport,
    /**
     * The PollReportQuestion model constructor.
     * @property {module:model/PollReportQuestion}
     */
    PollReportQuestion: PollReportQuestion,
    /**
     * The PollReportQuestionMatrixAxis model constructor.
     * @property {module:model/PollReportQuestionMatrixAxis}
     */
    PollReportQuestionMatrixAxis: PollReportQuestionMatrixAxis,
    /**
     * The PollReportQuestionMultipleNumericValue model constructor.
     * @property {module:model/PollReportQuestionMultipleNumericValue}
     */
    PollReportQuestionMultipleNumericValue: PollReportQuestionMultipleNumericValue,
    /**
     * The PollReportQuestionScaleValue model constructor.
     * @property {module:model/PollReportQuestionScaleValue}
     */
    PollReportQuestionScaleValue: PollReportQuestionScaleValue,
    /**
     * The PollResponse model constructor.
     * @property {module:model/PollResponse}
     */
    PollResponse: PollResponse,
    /**
     * The PollSettingsScale model constructor.
     * @property {module:model/PollSettingsScale}
     */
    PollSettingsScale: PollSettingsScale,
    /**
     * The PowerBIEmbedToken model constructor.
     * @property {module:model/PowerBIEmbedToken}
     */
    PowerBIEmbedToken: PowerBIEmbedToken,
    /**
     * The PowerBIItem model constructor.
     * @property {module:model/PowerBIItem}
     */
    PowerBIItem: PowerBIItem,
    /**
     * The PowerBIToken model constructor.
     * @property {module:model/PowerBIToken}
     */
    PowerBIToken: PowerBIToken,
    /**
     * The PowerBIWorkspace model constructor.
     * @property {module:model/PowerBIWorkspace}
     */
    PowerBIWorkspace: PowerBIWorkspace,
    /**
     * The Product model constructor.
     * @property {module:model/Product}
     */
    Product: Product,
    /**
     * The PublicExternalLink model constructor.
     * @property {module:model/PublicExternalLink}
     */
    PublicExternalLink: PublicExternalLink,
    /**
     * The QuickStartReport model constructor.
     * @property {module:model/QuickStartReport}
     */
    QuickStartReport: QuickStartReport,
    /**
     * The QuickStartStep model constructor.
     * @property {module:model/QuickStartStep}
     */
    QuickStartStep: QuickStartStep,
    /**
     * The QuickStartStepCategoryReport model constructor.
     * @property {module:model/QuickStartStepCategoryReport}
     */
    QuickStartStepCategoryReport: QuickStartStepCategoryReport,
    /**
     * The RawDataColumn model constructor.
     * @property {module:model/RawDataColumn}
     */
    RawDataColumn: RawDataColumn,
    /**
     * The RawDataMapping model constructor.
     * @property {module:model/RawDataMapping}
     */
    RawDataMapping: RawDataMapping,
    /**
     * The RawDataMappingColumn model constructor.
     * @property {module:model/RawDataMappingColumn}
     */
    RawDataMappingColumn: RawDataMappingColumn,
    /**
     * The RawDataMappingColumnDataType model constructor.
     * @property {module:model/RawDataMappingColumnDataType}
     */
    RawDataMappingColumnDataType: RawDataMappingColumnDataType,
    /**
     * The RawDataMappingReport model constructor.
     * @property {module:model/RawDataMappingReport}
     */
    RawDataMappingReport: RawDataMappingReport,
    /**
     * The RawDataMappingRule model constructor.
     * @property {module:model/RawDataMappingRule}
     */
    RawDataMappingRule: RawDataMappingRule,
    /**
     * The RawDataRowColumn model constructor.
     * @property {module:model/RawDataRowColumn}
     */
    RawDataRowColumn: RawDataRowColumn,
    /**
     * The RawDataRowError model constructor.
     * @property {module:model/RawDataRowError}
     */
    RawDataRowError: RawDataRowError,
    /**
     * The RawDataRowReport model constructor.
     * @property {module:model/RawDataRowReport}
     */
    RawDataRowReport: RawDataRowReport,
    /**
     * The RawDataRowReportPaginationSlice model constructor.
     * @property {module:model/RawDataRowReportPaginationSlice}
     */
    RawDataRowReportPaginationSlice: RawDataRowReportPaginationSlice,
    /**
     * The RawDataSource model constructor.
     * @property {module:model/RawDataSource}
     */
    RawDataSource: RawDataSource,
    /**
     * The RawDataSourceReport model constructor.
     * @property {module:model/RawDataSourceReport}
     */
    RawDataSourceReport: RawDataSourceReport,
    /**
     * The RawDataSourceStatus model constructor.
     * @property {module:model/RawDataSourceStatus}
     */
    RawDataSourceStatus: RawDataSourceStatus,
    /**
     * The RelativeDateType model constructor.
     * @property {module:model/RelativeDateType}
     */
    RelativeDateType: RelativeDateType,
    /**
     * The Row model constructor.
     * @property {module:model/Row}
     */
    Row: Row,
    /**
     * The SIEUploadQueue model constructor.
     * @property {module:model/SIEUploadQueue}
     */
    SIEUploadQueue: SIEUploadQueue,
    /**
     * The SWOTArea model constructor.
     * @property {module:model/SWOTArea}
     */
    SWOTArea: SWOTArea,
    /**
     * The SWOTInbox model constructor.
     * @property {module:model/SWOTInbox}
     */
    SWOTInbox: SWOTInbox,
    /**
     * The SWOTSession model constructor.
     * @property {module:model/SWOTSession}
     */
    SWOTSession: SWOTSession,
    /**
     * The SWOTSessionParticipant model constructor.
     * @property {module:model/SWOTSessionParticipant}
     */
    SWOTSessionParticipant: SWOTSessionParticipant,
    /**
     * The SWOTSessionReport model constructor.
     * @property {module:model/SWOTSessionReport}
     */
    SWOTSessionReport: SWOTSessionReport,
    /**
     * The SWOTTopic model constructor.
     * @property {module:model/SWOTTopic}
     */
    SWOTTopic: SWOTTopic,
    /**
     * The SWOTTopicComment model constructor.
     * @property {module:model/SWOTTopicComment}
     */
    SWOTTopicComment: SWOTTopicComment,
    /**
     * The SWOTTopicCommentPaginationSlice model constructor.
     * @property {module:model/SWOTTopicCommentPaginationSlice}
     */
    SWOTTopicCommentPaginationSlice: SWOTTopicCommentPaginationSlice,
    /**
     * The SWOTTopicReport model constructor.
     * @property {module:model/SWOTTopicReport}
     */
    SWOTTopicReport: SWOTTopicReport,
    /**
     * The SWOTTopicVote model constructor.
     * @property {module:model/SWOTTopicVote}
     */
    SWOTTopicVote: SWOTTopicVote,
    /**
     * The SWOTTopicVoteBatch model constructor.
     * @property {module:model/SWOTTopicVoteBatch}
     */
    SWOTTopicVoteBatch: SWOTTopicVoteBatch,
    /**
     * The SWOTTopicVoteBatchReport model constructor.
     * @property {module:model/SWOTTopicVoteBatchReport}
     */
    SWOTTopicVoteBatchReport: SWOTTopicVoteBatchReport,
    /**
     * The SWOTTopicVoteBatchReportPaginationSlice model constructor.
     * @property {module:model/SWOTTopicVoteBatchReportPaginationSlice}
     */
    SWOTTopicVoteBatchReportPaginationSlice: SWOTTopicVoteBatchReportPaginationSlice,
    /**
     * The SessionInformation model constructor.
     * @property {module:model/SessionInformation}
     */
    SessionInformation: SessionInformation,
    /**
     * The SeveraIntegrationSettingsReport model constructor.
     * @property {module:model/SeveraIntegrationSettingsReport}
     */
    SeveraIntegrationSettingsReport: SeveraIntegrationSettingsReport,
    /**
     * The SheetConfiguration model constructor.
     * @property {module:model/SheetConfiguration}
     */
    SheetConfiguration: SheetConfiguration,
    /**
     * The SheetConfigurationForecastDownloadFromSheetRule model constructor.
     * @property {module:model/SheetConfigurationForecastDownloadFromSheetRule}
     */
    SheetConfigurationForecastDownloadFromSheetRule: SheetConfigurationForecastDownloadFromSheetRule,
    /**
     * The SheetConfigurationForecastUploadToSheetRule model constructor.
     * @property {module:model/SheetConfigurationForecastUploadToSheetRule}
     */
    SheetConfigurationForecastUploadToSheetRule: SheetConfigurationForecastUploadToSheetRule,
    /**
     * The SheetExcelConfiguration model constructor.
     * @property {module:model/SheetExcelConfiguration}
     */
    SheetExcelConfiguration: SheetExcelConfiguration,
    /**
     * The SheetExcelGenerationIndicatorDepthRule model constructor.
     * @property {module:model/SheetExcelGenerationIndicatorDepthRule}
     */
    SheetExcelGenerationIndicatorDepthRule: SheetExcelGenerationIndicatorDepthRule,
    /**
     * The SheetExcelGenerationSettings model constructor.
     * @property {module:model/SheetExcelGenerationSettings}
     */
    SheetExcelGenerationSettings: SheetExcelGenerationSettings,
    /**
     * The SheetExcelGenerationValueWriteRule model constructor.
     * @property {module:model/SheetExcelGenerationValueWriteRule}
     */
    SheetExcelGenerationValueWriteRule: SheetExcelGenerationValueWriteRule,
    /**
     * The SheetForecast model constructor.
     * @property {module:model/SheetForecast}
     */
    SheetForecast: SheetForecast,
    /**
     * The SheetForecastAggregatedBudgetReport model constructor.
     * @property {module:model/SheetForecastAggregatedBudgetReport}
     */
    SheetForecastAggregatedBudgetReport: SheetForecastAggregatedBudgetReport,
    /**
     * The SheetForecastFile model constructor.
     * @property {module:model/SheetForecastFile}
     */
    SheetForecastFile: SheetForecastFile,
    /**
     * The SheetForecastFileReport model constructor.
     * @property {module:model/SheetForecastFileReport}
     */
    SheetForecastFileReport: SheetForecastFileReport,
    /**
     * The SheetForecastFileStatus model constructor.
     * @property {module:model/SheetForecastFileStatus}
     */
    SheetForecastFileStatus: SheetForecastFileStatus,
    /**
     * The SheetForecastFileType model constructor.
     * @property {module:model/SheetForecastFileType}
     */
    SheetForecastFileType: SheetForecastFileType,
    /**
     * The SheetForecastFileUserAccess model constructor.
     * @property {module:model/SheetForecastFileUserAccess}
     */
    SheetForecastFileUserAccess: SheetForecastFileUserAccess,
    /**
     * The SheetForecastInputMethod model constructor.
     * @property {module:model/SheetForecastInputMethod}
     */
    SheetForecastInputMethod: SheetForecastInputMethod,
    /**
     * The SheetForecastNotificationRecipient model constructor.
     * @property {module:model/SheetForecastNotificationRecipient}
     */
    SheetForecastNotificationRecipient: SheetForecastNotificationRecipient,
    /**
     * The SheetForecastNotificationReport model constructor.
     * @property {module:model/SheetForecastNotificationReport}
     */
    SheetForecastNotificationReport: SheetForecastNotificationReport,
    /**
     * The SheetForecastRelatedSheet model constructor.
     * @property {module:model/SheetForecastRelatedSheet}
     */
    SheetForecastRelatedSheet: SheetForecastRelatedSheet,
    /**
     * The SheetForecastReport model constructor.
     * @property {module:model/SheetForecastReport}
     */
    SheetForecastReport: SheetForecastReport,
    /**
     * The SheetGenerationSettings model constructor.
     * @property {module:model/SheetGenerationSettings}
     */
    SheetGenerationSettings: SheetGenerationSettings,
    /**
     * The SheetGenerationSettingsIndicator model constructor.
     * @property {module:model/SheetGenerationSettingsIndicator}
     */
    SheetGenerationSettingsIndicator: SheetGenerationSettingsIndicator,
    /**
     * The SheetGoogleConfiguration model constructor.
     * @property {module:model/SheetGoogleConfiguration}
     */
    SheetGoogleConfiguration: SheetGoogleConfiguration,
    /**
     * The SheetGoogleTemplateCopiedRange model constructor.
     * @property {module:model/SheetGoogleTemplateCopiedRange}
     */
    SheetGoogleTemplateCopiedRange: SheetGoogleTemplateCopiedRange,
    /**
     * The SheetGoogleTemplateCopiedRangeSettings model constructor.
     * @property {module:model/SheetGoogleTemplateCopiedRangeSettings}
     */
    SheetGoogleTemplateCopiedRangeSettings: SheetGoogleTemplateCopiedRangeSettings,
    /**
     * The SheetGoogleTemplateCopiedRangeValueType model constructor.
     * @property {module:model/SheetGoogleTemplateCopiedRangeValueType}
     */
    SheetGoogleTemplateCopiedRangeValueType: SheetGoogleTemplateCopiedRangeValueType,
    /**
     * The SpecialMenuItem model constructor.
     * @property {module:model/SpecialMenuItem}
     */
    SpecialMenuItem: SpecialMenuItem,
    /**
     * The Stakeholder model constructor.
     * @property {module:model/Stakeholder}
     */
    Stakeholder: Stakeholder,
    /**
     * The StakeholderBenchmark model constructor.
     * @property {module:model/StakeholderBenchmark}
     */
    StakeholderBenchmark: StakeholderBenchmark,
    /**
     * The StakeholderBenchmarkCustomItem model constructor.
     * @property {module:model/StakeholderBenchmarkCustomItem}
     */
    StakeholderBenchmarkCustomItem: StakeholderBenchmarkCustomItem,
    /**
     * The StakeholderBenchmarkCustomItemPaginationSlice model constructor.
     * @property {module:model/StakeholderBenchmarkCustomItemPaginationSlice}
     */
    StakeholderBenchmarkCustomItemPaginationSlice: StakeholderBenchmarkCustomItemPaginationSlice,
    /**
     * The StakeholderBenchmarkDimension model constructor.
     * @property {module:model/StakeholderBenchmarkDimension}
     */
    StakeholderBenchmarkDimension: StakeholderBenchmarkDimension,
    /**
     * The StakeholderBenchmarkDimensionReport model constructor.
     * @property {module:model/StakeholderBenchmarkDimensionReport}
     */
    StakeholderBenchmarkDimensionReport: StakeholderBenchmarkDimensionReport,
    /**
     * The StakeholderBenchmarkDimensionReportPaginationSlice model constructor.
     * @property {module:model/StakeholderBenchmarkDimensionReportPaginationSlice}
     */
    StakeholderBenchmarkDimensionReportPaginationSlice: StakeholderBenchmarkDimensionReportPaginationSlice,
    /**
     * The StakeholderBenchmarkDimensionValue model constructor.
     * @property {module:model/StakeholderBenchmarkDimensionValue}
     */
    StakeholderBenchmarkDimensionValue: StakeholderBenchmarkDimensionValue,
    /**
     * The StakeholderBenchmarkDimensionValuePaginationSlice model constructor.
     * @property {module:model/StakeholderBenchmarkDimensionValuePaginationSlice}
     */
    StakeholderBenchmarkDimensionValuePaginationSlice: StakeholderBenchmarkDimensionValuePaginationSlice,
    /**
     * The StakeholderBenchmarkReport model constructor.
     * @property {module:model/StakeholderBenchmarkReport}
     */
    StakeholderBenchmarkReport: StakeholderBenchmarkReport,
    /**
     * The StakeholderBenchmarkTemplate model constructor.
     * @property {module:model/StakeholderBenchmarkTemplate}
     */
    StakeholderBenchmarkTemplate: StakeholderBenchmarkTemplate,
    /**
     * The StakeholderComment model constructor.
     * @property {module:model/StakeholderComment}
     */
    StakeholderComment: StakeholderComment,
    /**
     * The StakeholderCommentPaginationSlice model constructor.
     * @property {module:model/StakeholderCommentPaginationSlice}
     */
    StakeholderCommentPaginationSlice: StakeholderCommentPaginationSlice,
    /**
     * The StakeholderMarketPositioningMapView model constructor.
     * @property {module:model/StakeholderMarketPositioningMapView}
     */
    StakeholderMarketPositioningMapView: StakeholderMarketPositioningMapView,
    /**
     * The StakeholderMarketPositioningMapViewCustomItem model constructor.
     * @property {module:model/StakeholderMarketPositioningMapViewCustomItem}
     */
    StakeholderMarketPositioningMapViewCustomItem: StakeholderMarketPositioningMapViewCustomItem,
    /**
     * The StakeholderMarketPositioningMapViewCustomItemPaginationSlice model constructor.
     * @property {module:model/StakeholderMarketPositioningMapViewCustomItemPaginationSlice}
     */
    StakeholderMarketPositioningMapViewCustomItemPaginationSlice: StakeholderMarketPositioningMapViewCustomItemPaginationSlice,
    /**
     * The StakeholderMarketPositioningMapViewPosition model constructor.
     * @property {module:model/StakeholderMarketPositioningMapViewPosition}
     */
    StakeholderMarketPositioningMapViewPosition: StakeholderMarketPositioningMapViewPosition,
    /**
     * The StakeholderMarketPositioningMapViewPositionPaginationSlice model constructor.
     * @property {module:model/StakeholderMarketPositioningMapViewPositionPaginationSlice}
     */
    StakeholderMarketPositioningMapViewPositionPaginationSlice: StakeholderMarketPositioningMapViewPositionPaginationSlice,
    /**
     * The StakeholderMarketPositioningMapViewReport model constructor.
     * @property {module:model/StakeholderMarketPositioningMapViewReport}
     */
    StakeholderMarketPositioningMapViewReport: StakeholderMarketPositioningMapViewReport,
    /**
     * The StakeholderMarketPositioningMapViewTemplate model constructor.
     * @property {module:model/StakeholderMarketPositioningMapViewTemplate}
     */
    StakeholderMarketPositioningMapViewTemplate: StakeholderMarketPositioningMapViewTemplate,
    /**
     * The StakeholderNewsEntryAutomatedSource model constructor.
     * @property {module:model/StakeholderNewsEntryAutomatedSource}
     */
    StakeholderNewsEntryAutomatedSource: StakeholderNewsEntryAutomatedSource,
    /**
     * The StakeholderNewsWatchFilterLevel model constructor.
     * @property {module:model/StakeholderNewsWatchFilterLevel}
     */
    StakeholderNewsWatchFilterLevel: StakeholderNewsWatchFilterLevel,
    /**
     * The StakeholderReport model constructor.
     * @property {module:model/StakeholderReport}
     */
    StakeholderReport: StakeholderReport,
    /**
     * The StakeholderReportPaginationSlice model constructor.
     * @property {module:model/StakeholderReportPaginationSlice}
     */
    StakeholderReportPaginationSlice: StakeholderReportPaginationSlice,
    /**
     * The StakeholderType model constructor.
     * @property {module:model/StakeholderType}
     */
    StakeholderType: StakeholderType,
    /**
     * The StakeholderTypeReport model constructor.
     * @property {module:model/StakeholderTypeReport}
     */
    StakeholderTypeReport: StakeholderTypeReport,
    /**
     * The StrategicGoal model constructor.
     * @property {module:model/StrategicGoal}
     */
    StrategicGoal: StrategicGoal,
    /**
     * The StrategicGoalCriticalSuccessFactor model constructor.
     * @property {module:model/StrategicGoalCriticalSuccessFactor}
     */
    StrategicGoalCriticalSuccessFactor: StrategicGoalCriticalSuccessFactor,
    /**
     * The StrategicGoalCriticalSuccessFactorReport model constructor.
     * @property {module:model/StrategicGoalCriticalSuccessFactorReport}
     */
    StrategicGoalCriticalSuccessFactorReport: StrategicGoalCriticalSuccessFactorReport,
    /**
     * The StrategicGoalMilestone model constructor.
     * @property {module:model/StrategicGoalMilestone}
     */
    StrategicGoalMilestone: StrategicGoalMilestone,
    /**
     * The StrategicGoalMilestoneAchievability model constructor.
     * @property {module:model/StrategicGoalMilestoneAchievability}
     */
    StrategicGoalMilestoneAchievability: StrategicGoalMilestoneAchievability,
    /**
     * The StrategicGoalMilestoneComment model constructor.
     * @property {module:model/StrategicGoalMilestoneComment}
     */
    StrategicGoalMilestoneComment: StrategicGoalMilestoneComment,
    /**
     * The StrategicGoalMilestoneCommentPaginationSlice model constructor.
     * @property {module:model/StrategicGoalMilestoneCommentPaginationSlice}
     */
    StrategicGoalMilestoneCommentPaginationSlice: StrategicGoalMilestoneCommentPaginationSlice,
    /**
     * The StrategicGoalMilestoneFinalStatus model constructor.
     * @property {module:model/StrategicGoalMilestoneFinalStatus}
     */
    StrategicGoalMilestoneFinalStatus: StrategicGoalMilestoneFinalStatus,
    /**
     * The StrategicGoalMilestoneReport model constructor.
     * @property {module:model/StrategicGoalMilestoneReport}
     */
    StrategicGoalMilestoneReport: StrategicGoalMilestoneReport,
    /**
     * The StrategicGoalMilestoneSecondaryOwner model constructor.
     * @property {module:model/StrategicGoalMilestoneSecondaryOwner}
     */
    StrategicGoalMilestoneSecondaryOwner: StrategicGoalMilestoneSecondaryOwner,
    /**
     * The StrategicGoalMilestoneSecondaryStatusUpdate model constructor.
     * @property {module:model/StrategicGoalMilestoneSecondaryStatusUpdate}
     */
    StrategicGoalMilestoneSecondaryStatusUpdate: StrategicGoalMilestoneSecondaryStatusUpdate,
    /**
     * The StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice model constructor.
     * @property {module:model/StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice}
     */
    StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice: StrategicGoalMilestoneSecondaryStatusUpdatePaginationSlice,
    /**
     * The StrategicGoalMilestoneStatus model constructor.
     * @property {module:model/StrategicGoalMilestoneStatus}
     */
    StrategicGoalMilestoneStatus: StrategicGoalMilestoneStatus,
    /**
     * The StrategicGoalMilestoneStatusUpdate model constructor.
     * @property {module:model/StrategicGoalMilestoneStatusUpdate}
     */
    StrategicGoalMilestoneStatusUpdate: StrategicGoalMilestoneStatusUpdate,
    /**
     * The StrategicGoalMilestoneStatusUpdatePaginationSlice model constructor.
     * @property {module:model/StrategicGoalMilestoneStatusUpdatePaginationSlice}
     */
    StrategicGoalMilestoneStatusUpdatePaginationSlice: StrategicGoalMilestoneStatusUpdatePaginationSlice,
    /**
     * The StrategicGoalMilestoneTeamLink model constructor.
     * @property {module:model/StrategicGoalMilestoneTeamLink}
     */
    StrategicGoalMilestoneTeamLink: StrategicGoalMilestoneTeamLink,
    /**
     * The StrategicGoalReport model constructor.
     * @property {module:model/StrategicGoalReport}
     */
    StrategicGoalReport: StrategicGoalReport,
    /**
     * The StrategicProgram model constructor.
     * @property {module:model/StrategicProgram}
     */
    StrategicProgram: StrategicProgram,
    /**
     * The StrategicProgramComment model constructor.
     * @property {module:model/StrategicProgramComment}
     */
    StrategicProgramComment: StrategicProgramComment,
    /**
     * The StrategicProgramCommentPaginationSlice model constructor.
     * @property {module:model/StrategicProgramCommentPaginationSlice}
     */
    StrategicProgramCommentPaginationSlice: StrategicProgramCommentPaginationSlice,
    /**
     * The StrategicProgramConnection model constructor.
     * @property {module:model/StrategicProgramConnection}
     */
    StrategicProgramConnection: StrategicProgramConnection,
    /**
     * The StrategicProgramFinalStatus model constructor.
     * @property {module:model/StrategicProgramFinalStatus}
     */
    StrategicProgramFinalStatus: StrategicProgramFinalStatus,
    /**
     * The StrategicProgramReport model constructor.
     * @property {module:model/StrategicProgramReport}
     */
    StrategicProgramReport: StrategicProgramReport,
    /**
     * The StrategicProgramRiskLevel model constructor.
     * @property {module:model/StrategicProgramRiskLevel}
     */
    StrategicProgramRiskLevel: StrategicProgramRiskLevel,
    /**
     * The StrategicProgramSecondaryOwner model constructor.
     * @property {module:model/StrategicProgramSecondaryOwner}
     */
    StrategicProgramSecondaryOwner: StrategicProgramSecondaryOwner,
    /**
     * The StrategicProgramStatus model constructor.
     * @property {module:model/StrategicProgramStatus}
     */
    StrategicProgramStatus: StrategicProgramStatus,
    /**
     * The StrategicProgramStatusUpdate model constructor.
     * @property {module:model/StrategicProgramStatusUpdate}
     */
    StrategicProgramStatusUpdate: StrategicProgramStatusUpdate,
    /**
     * The StrategicProgramStatusUpdateRecipient model constructor.
     * @property {module:model/StrategicProgramStatusUpdateRecipient}
     */
    StrategicProgramStatusUpdateRecipient: StrategicProgramStatusUpdateRecipient,
    /**
     * The StrategicProgramStatusUpdateRecipientPaginationSlice model constructor.
     * @property {module:model/StrategicProgramStatusUpdateRecipientPaginationSlice}
     */
    StrategicProgramStatusUpdateRecipientPaginationSlice: StrategicProgramStatusUpdateRecipientPaginationSlice,
    /**
     * The StrategicProgramStatusUpdateReport model constructor.
     * @property {module:model/StrategicProgramStatusUpdateReport}
     */
    StrategicProgramStatusUpdateReport: StrategicProgramStatusUpdateReport,
    /**
     * The StrategicProgramStatusUpdateReportPaginationSlice model constructor.
     * @property {module:model/StrategicProgramStatusUpdateReportPaginationSlice}
     */
    StrategicProgramStatusUpdateReportPaginationSlice: StrategicProgramStatusUpdateReportPaginationSlice,
    /**
     * The StrategicProgramUpdateFrequency model constructor.
     * @property {module:model/StrategicProgramUpdateFrequency}
     */
    StrategicProgramUpdateFrequency: StrategicProgramUpdateFrequency,
    /**
     * The StrategyBusinessReviewExportSettings model constructor.
     * @property {module:model/StrategyBusinessReviewExportSettings}
     */
    StrategyBusinessReviewExportSettings: StrategyBusinessReviewExportSettings,
    /**
     * The StrategyDescription model constructor.
     * @property {module:model/StrategyDescription}
     */
    StrategyDescription: StrategyDescription,
    /**
     * The StrategyDescriptionAdministrator model constructor.
     * @property {module:model/StrategyDescriptionAdministrator}
     */
    StrategyDescriptionAdministrator: StrategyDescriptionAdministrator,
    /**
     * The StrategyDescriptionExternalLink model constructor.
     * @property {module:model/StrategyDescriptionExternalLink}
     */
    StrategyDescriptionExternalLink: StrategyDescriptionExternalLink,
    /**
     * The StrategyDescriptionParticipator model constructor.
     * @property {module:model/StrategyDescriptionParticipator}
     */
    StrategyDescriptionParticipator: StrategyDescriptionParticipator,
    /**
     * The StrategyDescriptionPerformanceIndicator model constructor.
     * @property {module:model/StrategyDescriptionPerformanceIndicator}
     */
    StrategyDescriptionPerformanceIndicator: StrategyDescriptionPerformanceIndicator,
    /**
     * The StrategyDescriptionPerformanceIndicatorPaginationSlice model constructor.
     * @property {module:model/StrategyDescriptionPerformanceIndicatorPaginationSlice}
     */
    StrategyDescriptionPerformanceIndicatorPaginationSlice: StrategyDescriptionPerformanceIndicatorPaginationSlice,
    /**
     * The StrategyDescriptionReport model constructor.
     * @property {module:model/StrategyDescriptionReport}
     */
    StrategyDescriptionReport: StrategyDescriptionReport,
    /**
     * The StrategyDescriptionStatus model constructor.
     * @property {module:model/StrategyDescriptionStatus}
     */
    StrategyDescriptionStatus: StrategyDescriptionStatus,
    /**
     * The StrategyElementType model constructor.
     * @property {module:model/StrategyElementType}
     */
    StrategyElementType: StrategyElementType,
    /**
     * The StrategyExecutionCustomEntity model constructor.
     * @property {module:model/StrategyExecutionCustomEntity}
     */
    StrategyExecutionCustomEntity: StrategyExecutionCustomEntity,
    /**
     * The StrategyExecutionCustomEntityData model constructor.
     * @property {module:model/StrategyExecutionCustomEntityData}
     */
    StrategyExecutionCustomEntityData: StrategyExecutionCustomEntityData,
    /**
     * The StrategyExecutionCustomField model constructor.
     * @property {module:model/StrategyExecutionCustomField}
     */
    StrategyExecutionCustomField: StrategyExecutionCustomField,
    /**
     * The StrategyExecutionCustomFieldLink model constructor.
     * @property {module:model/StrategyExecutionCustomFieldLink}
     */
    StrategyExecutionCustomFieldLink: StrategyExecutionCustomFieldLink,
    /**
     * The StrategyExecutionCustomFieldOption model constructor.
     * @property {module:model/StrategyExecutionCustomFieldOption}
     */
    StrategyExecutionCustomFieldOption: StrategyExecutionCustomFieldOption,
    /**
     * The StrategyExecutionCustomFieldReport model constructor.
     * @property {module:model/StrategyExecutionCustomFieldReport}
     */
    StrategyExecutionCustomFieldReport: StrategyExecutionCustomFieldReport,
    /**
     * The StrategyExecutionCustomFieldType model constructor.
     * @property {module:model/StrategyExecutionCustomFieldType}
     */
    StrategyExecutionCustomFieldType: StrategyExecutionCustomFieldType,
    /**
     * The StrategyExecutionExportSettings model constructor.
     * @property {module:model/StrategyExecutionExportSettings}
     */
    StrategyExecutionExportSettings: StrategyExecutionExportSettings,
    /**
     * The StrategyExecutionSecondaryStatusUpdateType model constructor.
     * @property {module:model/StrategyExecutionSecondaryStatusUpdateType}
     */
    StrategyExecutionSecondaryStatusUpdateType: StrategyExecutionSecondaryStatusUpdateType,
    /**
     * The StrategyExecutionType model constructor.
     * @property {module:model/StrategyExecutionType}
     */
    StrategyExecutionType: StrategyExecutionType,
    /**
     * The StrategyExportItemSettings model constructor.
     * @property {module:model/StrategyExportItemSettings}
     */
    StrategyExportItemSettings: StrategyExportItemSettings,
    /**
     * The StrategyFreeNode model constructor.
     * @property {module:model/StrategyFreeNode}
     */
    StrategyFreeNode: StrategyFreeNode,
    /**
     * The StrategyFreeNodeReport model constructor.
     * @property {module:model/StrategyFreeNodeReport}
     */
    StrategyFreeNodeReport: StrategyFreeNodeReport,
    /**
     * The StrategyHealthReport model constructor.
     * @property {module:model/StrategyHealthReport}
     */
    StrategyHealthReport: StrategyHealthReport,
    /**
     * The StrategyNamingType model constructor.
     * @property {module:model/StrategyNamingType}
     */
    StrategyNamingType: StrategyNamingType,
    /**
     * The StrategyPageBlock model constructor.
     * @property {module:model/StrategyPageBlock}
     */
    StrategyPageBlock: StrategyPageBlock,
    /**
     * The StrategyPageBlockType model constructor.
     * @property {module:model/StrategyPageBlockType}
     */
    StrategyPageBlockType: StrategyPageBlockType,
    /**
     * The StrategyPageMemoBlock model constructor.
     * @property {module:model/StrategyPageMemoBlock}
     */
    StrategyPageMemoBlock: StrategyPageMemoBlock,
    /**
     * The StrategyProcess model constructor.
     * @property {module:model/StrategyProcess}
     */
    StrategyProcess: StrategyProcess,
    /**
     * The StrategyProcessPhase model constructor.
     * @property {module:model/StrategyProcessPhase}
     */
    StrategyProcessPhase: StrategyProcessPhase,
    /**
     * The StrategyProcessPhaseContent model constructor.
     * @property {module:model/StrategyProcessPhaseContent}
     */
    StrategyProcessPhaseContent: StrategyProcessPhaseContent,
    /**
     * The StrategyProcessPhaseReport model constructor.
     * @property {module:model/StrategyProcessPhaseReport}
     */
    StrategyProcessPhaseReport: StrategyProcessPhaseReport,
    /**
     * The StrategyProcessReport model constructor.
     * @property {module:model/StrategyProcessReport}
     */
    StrategyProcessReport: StrategyProcessReport,
    /**
     * The StrategyProcessSubtheme model constructor.
     * @property {module:model/StrategyProcessSubtheme}
     */
    StrategyProcessSubtheme: StrategyProcessSubtheme,
    /**
     * The StrategyProcessSubthemeLink model constructor.
     * @property {module:model/StrategyProcessSubthemeLink}
     */
    StrategyProcessSubthemeLink: StrategyProcessSubthemeLink,
    /**
     * The StrategyProcessSubthemeReport model constructor.
     * @property {module:model/StrategyProcessSubthemeReport}
     */
    StrategyProcessSubthemeReport: StrategyProcessSubthemeReport,
    /**
     * The StrategyProcessSubthemeType model constructor.
     * @property {module:model/StrategyProcessSubthemeType}
     */
    StrategyProcessSubthemeType: StrategyProcessSubthemeType,
    /**
     * The StrategyProcessTheme model constructor.
     * @property {module:model/StrategyProcessTheme}
     */
    StrategyProcessTheme: StrategyProcessTheme,
    /**
     * The StrategyProcessThemeReport model constructor.
     * @property {module:model/StrategyProcessThemeReport}
     */
    StrategyProcessThemeReport: StrategyProcessThemeReport,
    /**
     * The StrategyProgressCalculationMethod model constructor.
     * @property {module:model/StrategyProgressCalculationMethod}
     */
    StrategyProgressCalculationMethod: StrategyProgressCalculationMethod,
    /**
     * The StrategyProgressCalculationSource model constructor.
     * @property {module:model/StrategyProgressCalculationSource}
     */
    StrategyProgressCalculationSource: StrategyProgressCalculationSource,
    /**
     * The StrategyPublishingLevel model constructor.
     * @property {module:model/StrategyPublishingLevel}
     */
    StrategyPublishingLevel: StrategyPublishingLevel,
    /**
     * The StrategyPublishingType model constructor.
     * @property {module:model/StrategyPublishingType}
     */
    StrategyPublishingType: StrategyPublishingType,
    /**
     * The StrategySavedView model constructor.
     * @property {module:model/StrategySavedView}
     */
    StrategySavedView: StrategySavedView,
    /**
     * The StrategySelection model constructor.
     * @property {module:model/StrategySelection}
     */
    StrategySelection: StrategySelection,
    /**
     * The StrategySelectionReport model constructor.
     * @property {module:model/StrategySelectionReport}
     */
    StrategySelectionReport: StrategySelectionReport,
    /**
     * The StrategyTaxonomy model constructor.
     * @property {module:model/StrategyTaxonomy}
     */
    StrategyTaxonomy: StrategyTaxonomy,
    /**
     * The SystemLanguage model constructor.
     * @property {module:model/SystemLanguage}
     */
    SystemLanguage: SystemLanguage,
    /**
     * The SystemUserRole model constructor.
     * @property {module:model/SystemUserRole}
     */
    SystemUserRole: SystemUserRole,
    /**
     * The SystemUserType model constructor.
     * @property {module:model/SystemUserType}
     */
    SystemUserType: SystemUserType,
    /**
     * The TrackingLevel model constructor.
     * @property {module:model/TrackingLevel}
     */
    TrackingLevel: TrackingLevel,
    /**
     * The TrackingLevel1Item model constructor.
     * @property {module:model/TrackingLevel1Item}
     */
    TrackingLevel1Item: TrackingLevel1Item,
    /**
     * The TrackingLevel2Item model constructor.
     * @property {module:model/TrackingLevel2Item}
     */
    TrackingLevel2Item: TrackingLevel2Item,
    /**
     * The TrackingLevel3Item model constructor.
     * @property {module:model/TrackingLevel3Item}
     */
    TrackingLevel3Item: TrackingLevel3Item,
    /**
     * The TrackingLevel4Item model constructor.
     * @property {module:model/TrackingLevel4Item}
     */
    TrackingLevel4Item: TrackingLevel4Item,
    /**
     * The TrackingLevelItemBase model constructor.
     * @property {module:model/TrackingLevelItemBase}
     */
    TrackingLevelItemBase: TrackingLevelItemBase,
    /**
     * The TranslationResource model constructor.
     * @property {module:model/TranslationResource}
     */
    TranslationResource: TranslationResource,
    /**
     * The TrendCategory model constructor.
     * @property {module:model/TrendCategory}
     */
    TrendCategory: TrendCategory,
    /**
     * The TrendScope model constructor.
     * @property {module:model/TrendScope}
     */
    TrendScope: TrendScope,
    /**
     * The TrendSettings model constructor.
     * @property {module:model/TrendSettings}
     */
    TrendSettings: TrendSettings,
    /**
     * The TrendTopic model constructor.
     * @property {module:model/TrendTopic}
     */
    TrendTopic: TrendTopic,
    /**
     * The TrendTopicComment model constructor.
     * @property {module:model/TrendTopicComment}
     */
    TrendTopicComment: TrendTopicComment,
    /**
     * The TrendTopicCommentPaginationSlice model constructor.
     * @property {module:model/TrendTopicCommentPaginationSlice}
     */
    TrendTopicCommentPaginationSlice: TrendTopicCommentPaginationSlice,
    /**
     * The TrendTopicReport model constructor.
     * @property {module:model/TrendTopicReport}
     */
    TrendTopicReport: TrendTopicReport,
    /**
     * The TrendTopicType model constructor.
     * @property {module:model/TrendTopicType}
     */
    TrendTopicType: TrendTopicType,
    /**
     * The User model constructor.
     * @property {module:model/User}
     */
    User: User,
    /**
     * The UserActivityItem model constructor.
     * @property {module:model/UserActivityItem}
     */
    UserActivityItem: UserActivityItem,
    /**
     * The UserActivityReport model constructor.
     * @property {module:model/UserActivityReport}
     */
    UserActivityReport: UserActivityReport,
    /**
     * The UserCompanyAccess model constructor.
     * @property {module:model/UserCompanyAccess}
     */
    UserCompanyAccess: UserCompanyAccess,
    /**
     * The UserCompanyAccessReport model constructor.
     * @property {module:model/UserCompanyAccessReport}
     */
    UserCompanyAccessReport: UserCompanyAccessReport,
    /**
     * The UserCompanyFunctionalityAccess model constructor.
     * @property {module:model/UserCompanyFunctionalityAccess}
     */
    UserCompanyFunctionalityAccess: UserCompanyFunctionalityAccess,
    /**
     * The UserDataVisibilityFunction model constructor.
     * @property {module:model/UserDataVisibilityFunction}
     */
    UserDataVisibilityFunction: UserDataVisibilityFunction,
    /**
     * The UserDataVisibilityLegalEntity model constructor.
     * @property {module:model/UserDataVisibilityLegalEntity}
     */
    UserDataVisibilityLegalEntity: UserDataVisibilityLegalEntity,
    /**
     * The UserDataVisibilityProduct model constructor.
     * @property {module:model/UserDataVisibilityProduct}
     */
    UserDataVisibilityProduct: UserDataVisibilityProduct,
    /**
     * The UserDataVisibilitySettings model constructor.
     * @property {module:model/UserDataVisibilitySettings}
     */
    UserDataVisibilitySettings: UserDataVisibilitySettings,
    /**
     * The UserFeedbackReport model constructor.
     * @property {module:model/UserFeedbackReport}
     */
    UserFeedbackReport: UserFeedbackReport,
    /**
     * The UserFunctionalityAccessReport model constructor.
     * @property {module:model/UserFunctionalityAccessReport}
     */
    UserFunctionalityAccessReport: UserFunctionalityAccessReport,
    /**
     * The UserInterfaceText model constructor.
     * @property {module:model/UserInterfaceText}
     */
    UserInterfaceText: UserInterfaceText,
    /**
     * The UserInterfaceTranslationLanguage model constructor.
     * @property {module:model/UserInterfaceTranslationLanguage}
     */
    UserInterfaceTranslationLanguage: UserInterfaceTranslationLanguage,
    /**
     * The UserListDataReport model constructor.
     * @property {module:model/UserListDataReport}
     */
    UserListDataReport: UserListDataReport,
    /**
     * The UserLocal model constructor.
     * @property {module:model/UserLocal}
     */
    UserLocal: UserLocal,
    /**
     * The UserNotificationEventSource model constructor.
     * @property {module:model/UserNotificationEventSource}
     */
    UserNotificationEventSource: UserNotificationEventSource,
    /**
     * The UserNotificationUserSettings model constructor.
     * @property {module:model/UserNotificationUserSettings}
     */
    UserNotificationUserSettings: UserNotificationUserSettings,
    /**
     * The UserPartnerAccessReport model constructor.
     * @property {module:model/UserPartnerAccessReport}
     */
    UserPartnerAccessReport: UserPartnerAccessReport,
    /**
     * The UserRole model constructor.
     * @property {module:model/UserRole}
     */
    UserRole: UserRole,
    /**
     * The UserRoleBillingUserType model constructor.
     * @property {module:model/UserRoleBillingUserType}
     */
    UserRoleBillingUserType: UserRoleBillingUserType,
    /**
     * The UserRoleProduct model constructor.
     * @property {module:model/UserRoleProduct}
     */
    UserRoleProduct: UserRoleProduct,
    /**
     * The UserSyncExcelSettings model constructor.
     * @property {module:model/UserSyncExcelSettings}
     */
    UserSyncExcelSettings: UserSyncExcelSettings,
    /**
     * The UserTrackingLevelLink model constructor.
     * @property {module:model/UserTrackingLevelLink}
     */
    UserTrackingLevelLink: UserTrackingLevelLink,
    /**
     * The VATPeriodType model constructor.
     * @property {module:model/VATPeriodType}
     */
    VATPeriodType: VATPeriodType,
    /**
     * The Workshop model constructor.
     * @property {module:model/Workshop}
     */
    Workshop: Workshop,
    /**
     * The WorkshopBackgroundImage model constructor.
     * @property {module:model/WorkshopBackgroundImage}
     */
    WorkshopBackgroundImage: WorkshopBackgroundImage,
    /**
     * The WorkshopCanvasItem model constructor.
     * @property {module:model/WorkshopCanvasItem}
     */
    WorkshopCanvasItem: WorkshopCanvasItem,
    /**
     * The WorkshopCanvasItemType model constructor.
     * @property {module:model/WorkshopCanvasItemType}
     */
    WorkshopCanvasItemType: WorkshopCanvasItemType,
    /**
     * The WorkshopCloneSettings model constructor.
     * @property {module:model/WorkshopCloneSettings}
     */
    WorkshopCloneSettings: WorkshopCloneSettings,
    /**
     * The WorkshopExternalContentType model constructor.
     * @property {module:model/WorkshopExternalContentType}
     */
    WorkshopExternalContentType: WorkshopExternalContentType,
    /**
     * The WorkshopItem model constructor.
     * @property {module:model/WorkshopItem}
     */
    WorkshopItem: WorkshopItem,
    /**
     * The WorkshopItemCategory model constructor.
     * @property {module:model/WorkshopItemCategory}
     */
    WorkshopItemCategory: WorkshopItemCategory,
    /**
     * The WorkshopItemCategoryConnection model constructor.
     * @property {module:model/WorkshopItemCategoryConnection}
     */
    WorkshopItemCategoryConnection: WorkshopItemCategoryConnection,
    /**
     * The WorkshopItemHistory model constructor.
     * @property {module:model/WorkshopItemHistory}
     */
    WorkshopItemHistory: WorkshopItemHistory,
    /**
     * The WorkshopItemRating model constructor.
     * @property {module:model/WorkshopItemRating}
     */
    WorkshopItemRating: WorkshopItemRating,
    /**
     * The WorkshopItemRatingHistory model constructor.
     * @property {module:model/WorkshopItemRatingHistory}
     */
    WorkshopItemRatingHistory: WorkshopItemRatingHistory,
    /**
     * The WorkshopParticipant model constructor.
     * @property {module:model/WorkshopParticipant}
     */
    WorkshopParticipant: WorkshopParticipant,
    /**
     * The WorkshopParticipantRole model constructor.
     * @property {module:model/WorkshopParticipantRole}
     */
    WorkshopParticipantRole: WorkshopParticipantRole,
    /**
     * The WorkshopPhase model constructor.
     * @property {module:model/WorkshopPhase}
     */
    WorkshopPhase: WorkshopPhase,
    /**
     * The WorkshopPhaseComparisonAxis model constructor.
     * @property {module:model/WorkshopPhaseComparisonAxis}
     */
    WorkshopPhaseComparisonAxis: WorkshopPhaseComparisonAxis,
    /**
     * The WorkshopPhaseComparisonDimension model constructor.
     * @property {module:model/WorkshopPhaseComparisonDimension}
     */
    WorkshopPhaseComparisonDimension: WorkshopPhaseComparisonDimension,
    /**
     * The WorkshopPhaseContentCreationRule model constructor.
     * @property {module:model/WorkshopPhaseContentCreationRule}
     */
    WorkshopPhaseContentCreationRule: WorkshopPhaseContentCreationRule,
    /**
     * The WorkshopPhaseContentRow model constructor.
     * @property {module:model/WorkshopPhaseContentRow}
     */
    WorkshopPhaseContentRow: WorkshopPhaseContentRow,
    /**
     * The WorkshopPhaseContentRowLayout model constructor.
     * @property {module:model/WorkshopPhaseContentRowLayout}
     */
    WorkshopPhaseContentRowLayout: WorkshopPhaseContentRowLayout,
    /**
     * The WorkshopPhaseContentRowReport model constructor.
     * @property {module:model/WorkshopPhaseContentRowReport}
     */
    WorkshopPhaseContentRowReport: WorkshopPhaseContentRowReport,
    /**
     * The WorkshopPhaseGridBlock model constructor.
     * @property {module:model/WorkshopPhaseGridBlock}
     */
    WorkshopPhaseGridBlock: WorkshopPhaseGridBlock,
    /**
     * The WorkshopPhaseParticipantRole model constructor.
     * @property {module:model/WorkshopPhaseParticipantRole}
     */
    WorkshopPhaseParticipantRole: WorkshopPhaseParticipantRole,
    /**
     * The WorkshopPhaseReport model constructor.
     * @property {module:model/WorkshopPhaseReport}
     */
    WorkshopPhaseReport: WorkshopPhaseReport,
    /**
     * The WorkshopPrioritizationVotingType model constructor.
     * @property {module:model/WorkshopPrioritizationVotingType}
     */
    WorkshopPrioritizationVotingType: WorkshopPrioritizationVotingType,
    /**
     * The WorkshopQuestionnaireFilter model constructor.
     * @property {module:model/WorkshopQuestionnaireFilter}
     */
    WorkshopQuestionnaireFilter: WorkshopQuestionnaireFilter,
    /**
     * The WorkshopQuestionnaireOption model constructor.
     * @property {module:model/WorkshopQuestionnaireOption}
     */
    WorkshopQuestionnaireOption: WorkshopQuestionnaireOption,
    /**
     * The WorkshopQuestionnaireQuestion model constructor.
     * @property {module:model/WorkshopQuestionnaireQuestion}
     */
    WorkshopQuestionnaireQuestion: WorkshopQuestionnaireQuestion,
    /**
     * The WorkshopQuestionnaireQuestionReport model constructor.
     * @property {module:model/WorkshopQuestionnaireQuestionReport}
     */
    WorkshopQuestionnaireQuestionReport: WorkshopQuestionnaireQuestionReport,
    /**
     * The WorkshopQuestionnaireQuestionType model constructor.
     * @property {module:model/WorkshopQuestionnaireQuestionType}
     */
    WorkshopQuestionnaireQuestionType: WorkshopQuestionnaireQuestionType,
    /**
     * The WorkshopQuestionnaireResponse model constructor.
     * @property {module:model/WorkshopQuestionnaireResponse}
     */
    WorkshopQuestionnaireResponse: WorkshopQuestionnaireResponse,
    /**
     * The WorkshopRatingPhaseCategoryWeight model constructor.
     * @property {module:model/WorkshopRatingPhaseCategoryWeight}
     */
    WorkshopRatingPhaseCategoryWeight: WorkshopRatingPhaseCategoryWeight,
    /**
     * The WorkshopRatingPhaseSource model constructor.
     * @property {module:model/WorkshopRatingPhaseSource}
     */
    WorkshopRatingPhaseSource: WorkshopRatingPhaseSource,
    /**
     * The WorkshopRatingPhaseSourceReport model constructor.
     * @property {module:model/WorkshopRatingPhaseSourceReport}
     */
    WorkshopRatingPhaseSourceReport: WorkshopRatingPhaseSourceReport,
    /**
     * The WorkshopRatingPhaseWeightedLevel model constructor.
     * @property {module:model/WorkshopRatingPhaseWeightedLevel}
     */
    WorkshopRatingPhaseWeightedLevel: WorkshopRatingPhaseWeightedLevel,
    /**
     * The WorkshopReport model constructor.
     * @property {module:model/WorkshopReport}
     */
    WorkshopReport: WorkshopReport,
    /**
     * The WorkshopResultPhaseSource model constructor.
     * @property {module:model/WorkshopResultPhaseSource}
     */
    WorkshopResultPhaseSource: WorkshopResultPhaseSource,
    /**
     * The WorkshopResultPresentationType model constructor.
     * @property {module:model/WorkshopResultPresentationType}
     */
    WorkshopResultPresentationType: WorkshopResultPresentationType,
    /**
     * The WorkshopStrategyImportSettings model constructor.
     * @property {module:model/WorkshopStrategyImportSettings}
     */
    WorkshopStrategyImportSettings: WorkshopStrategyImportSettings,
    /**
     * The WorkshopVersionHistoryChangeType model constructor.
     * @property {module:model/WorkshopVersionHistoryChangeType}
     */
    WorkshopVersionHistoryChangeType: WorkshopVersionHistoryChangeType,
    /**
     * The WorkshopVideoCall model constructor.
     * @property {module:model/WorkshopVideoCall}
     */
    WorkshopVideoCall: WorkshopVideoCall,
    /**
     * The WorkshopWidget model constructor.
     * @property {module:model/WorkshopWidget}
     */
    WorkshopWidget: WorkshopWidget,
    /**
     * The WorkshopWidgetIdeaGenerationTheme model constructor.
     * @property {module:model/WorkshopWidgetIdeaGenerationTheme}
     */
    WorkshopWidgetIdeaGenerationTheme: WorkshopWidgetIdeaGenerationTheme,
    /**
     * The WorkshopWidgetIdeaGenerationThemeAnswer model constructor.
     * @property {module:model/WorkshopWidgetIdeaGenerationThemeAnswer}
     */
    WorkshopWidgetIdeaGenerationThemeAnswer: WorkshopWidgetIdeaGenerationThemeAnswer,
    /**
     * The WorkshopWidgetParticipantStatus model constructor.
     * @property {module:model/WorkshopWidgetParticipantStatus}
     */
    WorkshopWidgetParticipantStatus: WorkshopWidgetParticipantStatus,
    /**
     * The WorkshopWidgetReport model constructor.
     * @property {module:model/WorkshopWidgetReport}
     */
    WorkshopWidgetReport: WorkshopWidgetReport,
    /**
     * The WorkshopWidgetStatus model constructor.
     * @property {module:model/WorkshopWidgetStatus}
     */
    WorkshopWidgetStatus: WorkshopWidgetStatus,
    /**
     * The WorkshopWidgetType model constructor.
     * @property {module:model/WorkshopWidgetType}
     */
    WorkshopWidgetType: WorkshopWidgetType,
    /**
     * The WorkspaceMindmap model constructor.
     * @property {module:model/WorkspaceMindmap}
     */
    WorkspaceMindmap: WorkspaceMindmap,
    /**
     * The WorkspaceMindmapNode model constructor.
     * @property {module:model/WorkspaceMindmapNode}
     */
    WorkspaceMindmapNode: WorkspaceMindmapNode,
    /**
     * The WorkspaceMindmapNodePaginationSlice model constructor.
     * @property {module:model/WorkspaceMindmapNodePaginationSlice}
     */
    WorkspaceMindmapNodePaginationSlice: WorkspaceMindmapNodePaginationSlice,
    /**
     * The WorkspaceMindmapNodeType model constructor.
     * @property {module:model/WorkspaceMindmapNodeType}
     */
    WorkspaceMindmapNodeType: WorkspaceMindmapNodeType,
    /**
     * The WorkspaceMindmapReport model constructor.
     * @property {module:model/WorkspaceMindmapReport}
     */
    WorkspaceMindmapReport: WorkspaceMindmapReport,
    /**
     * The AccessFunctionalityApi service constructor.
     * @property {module:api/AccessFunctionalityApi}
     */
    AccessFunctionalityApi: AccessFunctionalityApi,
    /**
     * The AccessFunctionalityAddOnApi service constructor.
     * @property {module:api/AccessFunctionalityAddOnApi}
     */
    AccessFunctionalityAddOnApi: AccessFunctionalityAddOnApi,
    /**
     * The AccessModuleApi service constructor.
     * @property {module:api/AccessModuleApi}
     */
    AccessModuleApi: AccessModuleApi,
    /**
     * The AccessProfileApi service constructor.
     * @property {module:api/AccessProfileApi}
     */
    AccessProfileApi: AccessProfileApi,
    /**
     * The AccessTypeApi service constructor.
     * @property {module:api/AccessTypeApi}
     */
    AccessTypeApi: AccessTypeApi,
    /**
     * The AccountingDataApi service constructor.
     * @property {module:api/AccountingDataApi}
     */
    AccountingDataApi: AccountingDataApi,
    /**
     * The AccountingDataPreviewReportApi service constructor.
     * @property {module:api/AccountingDataPreviewReportApi}
     */
    AccountingDataPreviewReportApi: AccountingDataPreviewReportApi,
    /**
     * The AgendaFlagApi service constructor.
     * @property {module:api/AgendaFlagApi}
     */
    AgendaFlagApi: AgendaFlagApi,
    /**
     * The AgendaThemeApi service constructor.
     * @property {module:api/AgendaThemeApi}
     */
    AgendaThemeApi: AgendaThemeApi,
    /**
     * The AgendaTimeReservationApi service constructor.
     * @property {module:api/AgendaTimeReservationApi}
     */
    AgendaTimeReservationApi: AgendaTimeReservationApi,
    /**
     * The AgendaTimeSerieEventApi service constructor.
     * @property {module:api/AgendaTimeSerieEventApi}
     */
    AgendaTimeSerieEventApi: AgendaTimeSerieEventApi,
    /**
     * The AgendaTimeSerieRuleApi service constructor.
     * @property {module:api/AgendaTimeSerieRuleApi}
     */
    AgendaTimeSerieRuleApi: AgendaTimeSerieRuleApi,
    /**
     * The AnalysisCategoryApi service constructor.
     * @property {module:api/AnalysisCategoryApi}
     */
    AnalysisCategoryApi: AnalysisCategoryApi,
    /**
     * The BisnodeFinancialIndicatorValueApi service constructor.
     * @property {module:api/BisnodeFinancialIndicatorValueApi}
     */
    BisnodeFinancialIndicatorValueApi: BisnodeFinancialIndicatorValueApi,
    /**
     * The BusinessModelApi service constructor.
     * @property {module:api/BusinessModelApi}
     */
    BusinessModelApi: BusinessModelApi,
    /**
     * The BusinessModelAreaApi service constructor.
     * @property {module:api/BusinessModelAreaApi}
     */
    BusinessModelAreaApi: BusinessModelAreaApi,
    /**
     * The BusinessModelCanvasAreaApi service constructor.
     * @property {module:api/BusinessModelCanvasAreaApi}
     */
    BusinessModelCanvasAreaApi: BusinessModelCanvasAreaApi,
    /**
     * The BusinessModelCanvasItemApi service constructor.
     * @property {module:api/BusinessModelCanvasItemApi}
     */
    BusinessModelCanvasItemApi: BusinessModelCanvasItemApi,
    /**
     * The BusinessModelCanvasItemTypeApi service constructor.
     * @property {module:api/BusinessModelCanvasItemTypeApi}
     */
    BusinessModelCanvasItemTypeApi: BusinessModelCanvasItemTypeApi,
    /**
     * The BusinessReviewExcludedSectionApi service constructor.
     * @property {module:api/BusinessReviewExcludedSectionApi}
     */
    BusinessReviewExcludedSectionApi: BusinessReviewExcludedSectionApi,
    /**
     * The BusinessReviewScheduleApi service constructor.
     * @property {module:api/BusinessReviewScheduleApi}
     */
    BusinessReviewScheduleApi: BusinessReviewScheduleApi,
    /**
     * The BusinessReviewSectionTypeApi service constructor.
     * @property {module:api/BusinessReviewSectionTypeApi}
     */
    BusinessReviewSectionTypeApi: BusinessReviewSectionTypeApi,
    /**
     * The BusinessReviewSessionApi service constructor.
     * @property {module:api/BusinessReviewSessionApi}
     */
    BusinessReviewSessionApi: BusinessReviewSessionApi,
    /**
     * The BusinessReviewSessionStatusApi service constructor.
     * @property {module:api/BusinessReviewSessionStatusApi}
     */
    BusinessReviewSessionStatusApi: BusinessReviewSessionStatusApi,
    /**
     * The BusinessReviewStatusApi service constructor.
     * @property {module:api/BusinessReviewStatusApi}
     */
    BusinessReviewStatusApi: BusinessReviewStatusApi,
    /**
     * The BusinessReviewStepApi service constructor.
     * @property {module:api/BusinessReviewStepApi}
     */
    BusinessReviewStepApi: BusinessReviewStepApi,
    /**
     * The BusinessReviewStepElementSideApi service constructor.
     * @property {module:api/BusinessReviewStepElementSideApi}
     */
    BusinessReviewStepElementSideApi: BusinessReviewStepElementSideApi,
    /**
     * The BusinessReviewTemplateApi service constructor.
     * @property {module:api/BusinessReviewTemplateApi}
     */
    BusinessReviewTemplateApi: BusinessReviewTemplateApi,
    /**
     * The BusinessReviewUserSettingsApi service constructor.
     * @property {module:api/BusinessReviewUserSettingsApi}
     */
    BusinessReviewUserSettingsApi: BusinessReviewUserSettingsApi,
    /**
     * The BusinessSimulatorCashflowAccountReceivablesDistributionApi service constructor.
     * @property {module:api/BusinessSimulatorCashflowAccountReceivablesDistributionApi}
     */
    BusinessSimulatorCashflowAccountReceivablesDistributionApi: BusinessSimulatorCashflowAccountReceivablesDistributionApi,
    /**
     * The BusinessSimulatorCashflowCapitalItemApi service constructor.
     * @property {module:api/BusinessSimulatorCashflowCapitalItemApi}
     */
    BusinessSimulatorCashflowCapitalItemApi: BusinessSimulatorCashflowCapitalItemApi,
    /**
     * The BusinessSimulatorCashflowCapitalItemGroupApi service constructor.
     * @property {module:api/BusinessSimulatorCashflowCapitalItemGroupApi}
     */
    BusinessSimulatorCashflowCapitalItemGroupApi: BusinessSimulatorCashflowCapitalItemGroupApi,
    /**
     * The BusinessSimulatorCashflowCapitalItemValueApi service constructor.
     * @property {module:api/BusinessSimulatorCashflowCapitalItemValueApi}
     */
    BusinessSimulatorCashflowCapitalItemValueApi: BusinessSimulatorCashflowCapitalItemValueApi,
    /**
     * The BusinessSimulatorCashflowSalesReceivablesDistributionApi service constructor.
     * @property {module:api/BusinessSimulatorCashflowSalesReceivablesDistributionApi}
     */
    BusinessSimulatorCashflowSalesReceivablesDistributionApi: BusinessSimulatorCashflowSalesReceivablesDistributionApi,
    /**
     * The CashflowForecastIndicatorConnectionApi service constructor.
     * @property {module:api/CashflowForecastIndicatorConnectionApi}
     */
    CashflowForecastIndicatorConnectionApi: CashflowForecastIndicatorConnectionApi,
    /**
     * The CashflowForecastIndicatorDistributionEntryApi service constructor.
     * @property {module:api/CashflowForecastIndicatorDistributionEntryApi}
     */
    CashflowForecastIndicatorDistributionEntryApi: CashflowForecastIndicatorDistributionEntryApi,
    /**
     * The CashflowForecastSettingsApi service constructor.
     * @property {module:api/CashflowForecastSettingsApi}
     */
    CashflowForecastSettingsApi: CashflowForecastSettingsApi,
    /**
     * The CategoryApi service constructor.
     * @property {module:api/CategoryApi}
     */
    CategoryApi: CategoryApi,
    /**
     * The CompanyApi service constructor.
     * @property {module:api/CompanyApi}
     */
    CompanyApi: CompanyApi,
    /**
     * The CompanyAccessFunctionalityAddOnApi service constructor.
     * @property {module:api/CompanyAccessFunctionalityAddOnApi}
     */
    CompanyAccessFunctionalityAddOnApi: CompanyAccessFunctionalityAddOnApi,
    /**
     * The CompanyAccessModuleApi service constructor.
     * @property {module:api/CompanyAccessModuleApi}
     */
    CompanyAccessModuleApi: CompanyAccessModuleApi,
    /**
     * The CompanyFunctionApi service constructor.
     * @property {module:api/CompanyFunctionApi}
     */
    CompanyFunctionApi: CompanyFunctionApi,
    /**
     * The CompanyLegalEntityApi service constructor.
     * @property {module:api/CompanyLegalEntityApi}
     */
    CompanyLegalEntityApi: CompanyLegalEntityApi,
    /**
     * The CompanyLegalEntityTypeApi service constructor.
     * @property {module:api/CompanyLegalEntityTypeApi}
     */
    CompanyLegalEntityTypeApi: CompanyLegalEntityTypeApi,
    /**
     * The CompanySubscriptionReportApi service constructor.
     * @property {module:api/CompanySubscriptionReportApi}
     */
    CompanySubscriptionReportApi: CompanySubscriptionReportApi,
    /**
     * The CompanyTemplateTypeApi service constructor.
     * @property {module:api/CompanyTemplateTypeApi}
     */
    CompanyTemplateTypeApi: CompanyTemplateTypeApi,
    /**
     * The CompanyVirtualTeamApi service constructor.
     * @property {module:api/CompanyVirtualTeamApi}
     */
    CompanyVirtualTeamApi: CompanyVirtualTeamApi,
    /**
     * The CompanyVirtualTeamMemberApi service constructor.
     * @property {module:api/CompanyVirtualTeamMemberApi}
     */
    CompanyVirtualTeamMemberApi: CompanyVirtualTeamMemberApi,
    /**
     * The CompetitorApi service constructor.
     * @property {module:api/CompetitorApi}
     */
    CompetitorApi: CompetitorApi,
    /**
     * The ContentWatchSettingsApi service constructor.
     * @property {module:api/ContentWatchSettingsApi}
     */
    ContentWatchSettingsApi: ContentWatchSettingsApi,
    /**
     * The CorporateStructureFilterApi service constructor.
     * @property {module:api/CorporateStructureFilterApi}
     */
    CorporateStructureFilterApi: CorporateStructureFilterApi,
    /**
     * The CorporateStructureLinkApi service constructor.
     * @property {module:api/CorporateStructureLinkApi}
     */
    CorporateStructureLinkApi: CorporateStructureLinkApi,
    /**
     * The CorporateStructureLinkReportApi service constructor.
     * @property {module:api/CorporateStructureLinkReportApi}
     */
    CorporateStructureLinkReportApi: CorporateStructureLinkReportApi,
    /**
     * The CorporateStructureSortModeApi service constructor.
     * @property {module:api/CorporateStructureSortModeApi}
     */
    CorporateStructureSortModeApi: CorporateStructureSortModeApi,
    /**
     * The CountryApi service constructor.
     * @property {module:api/CountryApi}
     */
    CountryApi: CountryApi,
    /**
     * The CustomerApi service constructor.
     * @property {module:api/CustomerApi}
     */
    CustomerApi: CustomerApi,
    /**
     * The DashboardGroupApi service constructor.
     * @property {module:api/DashboardGroupApi}
     */
    DashboardGroupApi: DashboardGroupApi,
    /**
     * The DashboardPageApi service constructor.
     * @property {module:api/DashboardPageApi}
     */
    DashboardPageApi: DashboardPageApi,
    /**
     * The DashboardPageBlockApi service constructor.
     * @property {module:api/DashboardPageBlockApi}
     */
    DashboardPageBlockApi: DashboardPageBlockApi,
    /**
     * The DashboardPageBlockBubbleSettingsApi service constructor.
     * @property {module:api/DashboardPageBlockBubbleSettingsApi}
     */
    DashboardPageBlockBubbleSettingsApi: DashboardPageBlockBubbleSettingsApi,
    /**
     * The DashboardPageBlockCartesianAxisApi service constructor.
     * @property {module:api/DashboardPageBlockCartesianAxisApi}
     */
    DashboardPageBlockCartesianAxisApi: DashboardPageBlockCartesianAxisApi,
    /**
     * The DashboardPageBlockCartesianSerieApi service constructor.
     * @property {module:api/DashboardPageBlockCartesianSerieApi}
     */
    DashboardPageBlockCartesianSerieApi: DashboardPageBlockCartesianSerieApi,
    /**
     * The DashboardPageBlockCartesianSerieGroupingApi service constructor.
     * @property {module:api/DashboardPageBlockCartesianSerieGroupingApi}
     */
    DashboardPageBlockCartesianSerieGroupingApi: DashboardPageBlockCartesianSerieGroupingApi,
    /**
     * The DashboardPageBlockCartesianSerieMilestoneApi service constructor.
     * @property {module:api/DashboardPageBlockCartesianSerieMilestoneApi}
     */
    DashboardPageBlockCartesianSerieMilestoneApi: DashboardPageBlockCartesianSerieMilestoneApi,
    /**
     * The DashboardPageBlockCartesianSerieTypeApi service constructor.
     * @property {module:api/DashboardPageBlockCartesianSerieTypeApi}
     */
    DashboardPageBlockCartesianSerieTypeApi: DashboardPageBlockCartesianSerieTypeApi,
    /**
     * The DashboardPageBlockCommentApi service constructor.
     * @property {module:api/DashboardPageBlockCommentApi}
     */
    DashboardPageBlockCommentApi: DashboardPageBlockCommentApi,
    /**
     * The DashboardPageBlockComparisonBarSerieApi service constructor.
     * @property {module:api/DashboardPageBlockComparisonBarSerieApi}
     */
    DashboardPageBlockComparisonBarSerieApi: DashboardPageBlockComparisonBarSerieApi,
    /**
     * The DashboardPageBlockComparisonBarSerieTypeApi service constructor.
     * @property {module:api/DashboardPageBlockComparisonBarSerieTypeApi}
     */
    DashboardPageBlockComparisonBarSerieTypeApi: DashboardPageBlockComparisonBarSerieTypeApi,
    /**
     * The DashboardPageBlockComparisonColumnSerieApi service constructor.
     * @property {module:api/DashboardPageBlockComparisonColumnSerieApi}
     */
    DashboardPageBlockComparisonColumnSerieApi: DashboardPageBlockComparisonColumnSerieApi,
    /**
     * The DashboardPageBlockComparisonColumnSerieTypeApi service constructor.
     * @property {module:api/DashboardPageBlockComparisonColumnSerieTypeApi}
     */
    DashboardPageBlockComparisonColumnSerieTypeApi: DashboardPageBlockComparisonColumnSerieTypeApi,
    /**
     * The DashboardPageBlockCustomTableColumnApi service constructor.
     * @property {module:api/DashboardPageBlockCustomTableColumnApi}
     */
    DashboardPageBlockCustomTableColumnApi: DashboardPageBlockCustomTableColumnApi,
    /**
     * The DashboardPageBlockCustomTableColumnDefaultFilterApi service constructor.
     * @property {module:api/DashboardPageBlockCustomTableColumnDefaultFilterApi}
     */
    DashboardPageBlockCustomTableColumnDefaultFilterApi: DashboardPageBlockCustomTableColumnDefaultFilterApi,
    /**
     * The DashboardPageBlockCustomTableGraphSerieTypeApi service constructor.
     * @property {module:api/DashboardPageBlockCustomTableGraphSerieTypeApi}
     */
    DashboardPageBlockCustomTableGraphSerieTypeApi: DashboardPageBlockCustomTableGraphSerieTypeApi,
    /**
     * The DashboardPageBlockCustomTableQueryApi service constructor.
     * @property {module:api/DashboardPageBlockCustomTableQueryApi}
     */
    DashboardPageBlockCustomTableQueryApi: DashboardPageBlockCustomTableQueryApi,
    /**
     * The DashboardPageBlockExternalSettingsApi service constructor.
     * @property {module:api/DashboardPageBlockExternalSettingsApi}
     */
    DashboardPageBlockExternalSettingsApi: DashboardPageBlockExternalSettingsApi,
    /**
     * The DashboardPageBlockGoogleSheetSettingsApi service constructor.
     * @property {module:api/DashboardPageBlockGoogleSheetSettingsApi}
     */
    DashboardPageBlockGoogleSheetSettingsApi: DashboardPageBlockGoogleSheetSettingsApi,
    /**
     * The DashboardPageBlockMarketOverviewSettingsApi service constructor.
     * @property {module:api/DashboardPageBlockMarketOverviewSettingsApi}
     */
    DashboardPageBlockMarketOverviewSettingsApi: DashboardPageBlockMarketOverviewSettingsApi,
    /**
     * The DashboardPageBlockMilestoneApi service constructor.
     * @property {module:api/DashboardPageBlockMilestoneApi}
     */
    DashboardPageBlockMilestoneApi: DashboardPageBlockMilestoneApi,
    /**
     * The DashboardPageBlockNewsfeedApi service constructor.
     * @property {module:api/DashboardPageBlockNewsfeedApi}
     */
    DashboardPageBlockNewsfeedApi: DashboardPageBlockNewsfeedApi,
    /**
     * The DashboardPageBlockNumberSerieApi service constructor.
     * @property {module:api/DashboardPageBlockNumberSerieApi}
     */
    DashboardPageBlockNumberSerieApi: DashboardPageBlockNumberSerieApi,
    /**
     * The DashboardPageBlockPieSerieApi service constructor.
     * @property {module:api/DashboardPageBlockPieSerieApi}
     */
    DashboardPageBlockPieSerieApi: DashboardPageBlockPieSerieApi,
    /**
     * The DashboardPageBlockPollSettingsApi service constructor.
     * @property {module:api/DashboardPageBlockPollSettingsApi}
     */
    DashboardPageBlockPollSettingsApi: DashboardPageBlockPollSettingsApi,
    /**
     * The DashboardPageBlockPowerBIEmbedApi service constructor.
     * @property {module:api/DashboardPageBlockPowerBIEmbedApi}
     */
    DashboardPageBlockPowerBIEmbedApi: DashboardPageBlockPowerBIEmbedApi,
    /**
     * The DashboardPageBlockSerieOrderApi service constructor.
     * @property {module:api/DashboardPageBlockSerieOrderApi}
     */
    DashboardPageBlockSerieOrderApi: DashboardPageBlockSerieOrderApi,
    /**
     * The DashboardPageBlockSolidGaugeSerieApi service constructor.
     * @property {module:api/DashboardPageBlockSolidGaugeSerieApi}
     */
    DashboardPageBlockSolidGaugeSerieApi: DashboardPageBlockSolidGaugeSerieApi,
    /**
     * The DashboardPageBlockStrategicActionApi service constructor.
     * @property {module:api/DashboardPageBlockStrategicActionApi}
     */
    DashboardPageBlockStrategicActionApi: DashboardPageBlockStrategicActionApi,
    /**
     * The DashboardPageBlockStrategicActionViewTypeApi service constructor.
     * @property {module:api/DashboardPageBlockStrategicActionViewTypeApi}
     */
    DashboardPageBlockStrategicActionViewTypeApi: DashboardPageBlockStrategicActionViewTypeApi,
    /**
     * The DashboardPageBlockStrategyApi service constructor.
     * @property {module:api/DashboardPageBlockStrategyApi}
     */
    DashboardPageBlockStrategyApi: DashboardPageBlockStrategyApi,
    /**
     * The DashboardPageBlockTableComparisonColumnApi service constructor.
     * @property {module:api/DashboardPageBlockTableComparisonColumnApi}
     */
    DashboardPageBlockTableComparisonColumnApi: DashboardPageBlockTableComparisonColumnApi,
    /**
     * The DashboardPageBlockTableComparisonRowApi service constructor.
     * @property {module:api/DashboardPageBlockTableComparisonRowApi}
     */
    DashboardPageBlockTableComparisonRowApi: DashboardPageBlockTableComparisonRowApi,
    /**
     * The DashboardPageBlockTableDataColumnApi service constructor.
     * @property {module:api/DashboardPageBlockTableDataColumnApi}
     */
    DashboardPageBlockTableDataColumnApi: DashboardPageBlockTableDataColumnApi,
    /**
     * The DashboardPageBlockTableEmptyRowApi service constructor.
     * @property {module:api/DashboardPageBlockTableEmptyRowApi}
     */
    DashboardPageBlockTableEmptyRowApi: DashboardPageBlockTableEmptyRowApi,
    /**
     * The DashboardPageBlockTableRollingComparisonApi service constructor.
     * @property {module:api/DashboardPageBlockTableRollingComparisonApi}
     */
    DashboardPageBlockTableRollingComparisonApi: DashboardPageBlockTableRollingComparisonApi,
    /**
     * The DashboardPageBlockTableSerieRowApi service constructor.
     * @property {module:api/DashboardPageBlockTableSerieRowApi}
     */
    DashboardPageBlockTableSerieRowApi: DashboardPageBlockTableSerieRowApi,
    /**
     * The DashboardPageBlockTableSerieRowExpandedIndicatorApi service constructor.
     * @property {module:api/DashboardPageBlockTableSerieRowExpandedIndicatorApi}
     */
    DashboardPageBlockTableSerieRowExpandedIndicatorApi: DashboardPageBlockTableSerieRowExpandedIndicatorApi,
    /**
     * The DashboardPageBlockTableSumColumnApi service constructor.
     * @property {module:api/DashboardPageBlockTableSumColumnApi}
     */
    DashboardPageBlockTableSumColumnApi: DashboardPageBlockTableSumColumnApi,
    /**
     * The DashboardPageBlockTemplateApi service constructor.
     * @property {module:api/DashboardPageBlockTemplateApi}
     */
    DashboardPageBlockTemplateApi: DashboardPageBlockTemplateApi,
    /**
     * The DashboardPageBlockTypeApi service constructor.
     * @property {module:api/DashboardPageBlockTypeApi}
     */
    DashboardPageBlockTypeApi: DashboardPageBlockTypeApi,
    /**
     * The DashboardPageHomeSettingsApi service constructor.
     * @property {module:api/DashboardPageHomeSettingsApi}
     */
    DashboardPageHomeSettingsApi: DashboardPageHomeSettingsApi,
    /**
     * The DashboardPageTemplateApi service constructor.
     * @property {module:api/DashboardPageTemplateApi}
     */
    DashboardPageTemplateApi: DashboardPageTemplateApi,
    /**
     * The DashboardPageUserAccessApi service constructor.
     * @property {module:api/DashboardPageUserAccessApi}
     */
    DashboardPageUserAccessApi: DashboardPageUserAccessApi,
    /**
     * The DashboardShareBatchApi service constructor.
     * @property {module:api/DashboardShareBatchApi}
     */
    DashboardShareBatchApi: DashboardShareBatchApi,
    /**
     * The DecisionApi service constructor.
     * @property {module:api/DecisionApi}
     */
    DecisionApi: DecisionApi,
    /**
     * The DecisionPollApi service constructor.
     * @property {module:api/DecisionPollApi}
     */
    DecisionPollApi: DecisionPollApi,
    /**
     * The DecisionPollReplyOptionTypeApi service constructor.
     * @property {module:api/DecisionPollReplyOptionTypeApi}
     */
    DecisionPollReplyOptionTypeApi: DecisionPollReplyOptionTypeApi,
    /**
     * The DecisionPollRespondentApi service constructor.
     * @property {module:api/DecisionPollRespondentApi}
     */
    DecisionPollRespondentApi: DecisionPollRespondentApi,
    /**
     * The DecisionPollTypeApi service constructor.
     * @property {module:api/DecisionPollTypeApi}
     */
    DecisionPollTypeApi: DecisionPollTypeApi,
    /**
     * The DecisionTopicApi service constructor.
     * @property {module:api/DecisionTopicApi}
     */
    DecisionTopicApi: DecisionTopicApi,
    /**
     * The DecisionTopicCommentApi service constructor.
     * @property {module:api/DecisionTopicCommentApi}
     */
    DecisionTopicCommentApi: DecisionTopicCommentApi,
    /**
     * The DecisionTopicPhaseApi service constructor.
     * @property {module:api/DecisionTopicPhaseApi}
     */
    DecisionTopicPhaseApi: DecisionTopicPhaseApi,
    /**
     * The DecisionTopicTypeApi service constructor.
     * @property {module:api/DecisionTopicTypeApi}
     */
    DecisionTopicTypeApi: DecisionTopicTypeApi,
    /**
     * The DecisionTrackingTypeApi service constructor.
     * @property {module:api/DecisionTrackingTypeApi}
     */
    DecisionTrackingTypeApi: DecisionTrackingTypeApi,
    /**
     * The DialogDistributionChannelApi service constructor.
     * @property {module:api/DialogDistributionChannelApi}
     */
    DialogDistributionChannelApi: DialogDistributionChannelApi,
    /**
     * The DialogFlowLogicGateMatchRuleApi service constructor.
     * @property {module:api/DialogFlowLogicGateMatchRuleApi}
     */
    DialogFlowLogicGateMatchRuleApi: DialogFlowLogicGateMatchRuleApi,
    /**
     * The DialogFlowLogicGateValueSourceApi service constructor.
     * @property {module:api/DialogFlowLogicGateValueSourceApi}
     */
    DialogFlowLogicGateValueSourceApi: DialogFlowLogicGateValueSourceApi,
    /**
     * The DialogFlowMultiOptionDataSourceApi service constructor.
     * @property {module:api/DialogFlowMultiOptionDataSourceApi}
     */
    DialogFlowMultiOptionDataSourceApi: DialogFlowMultiOptionDataSourceApi,
    /**
     * The DialogFlowSessionApi service constructor.
     * @property {module:api/DialogFlowSessionApi}
     */
    DialogFlowSessionApi: DialogFlowSessionApi,
    /**
     * The DialogFlowTemplateApi service constructor.
     * @property {module:api/DialogFlowTemplateApi}
     */
    DialogFlowTemplateApi: DialogFlowTemplateApi,
    /**
     * The DialogFlowTemplateMessageApi service constructor.
     * @property {module:api/DialogFlowTemplateMessageApi}
     */
    DialogFlowTemplateMessageApi: DialogFlowTemplateMessageApi,
    /**
     * The DialogFlowTemplateMessageConversionRuleApi service constructor.
     * @property {module:api/DialogFlowTemplateMessageConversionRuleApi}
     */
    DialogFlowTemplateMessageConversionRuleApi: DialogFlowTemplateMessageConversionRuleApi,
    /**
     * The DialogFlowTemplateMessageOptionApi service constructor.
     * @property {module:api/DialogFlowTemplateMessageOptionApi}
     */
    DialogFlowTemplateMessageOptionApi: DialogFlowTemplateMessageOptionApi,
    /**
     * The DialogFlowTemplateMessageTypeApi service constructor.
     * @property {module:api/DialogFlowTemplateMessageTypeApi}
     */
    DialogFlowTemplateMessageTypeApi: DialogFlowTemplateMessageTypeApi,
    /**
     * The DialogScheduleBatchApi service constructor.
     * @property {module:api/DialogScheduleBatchApi}
     */
    DialogScheduleBatchApi: DialogScheduleBatchApi,
    /**
     * The DialogScheduleFlowApi service constructor.
     * @property {module:api/DialogScheduleFlowApi}
     */
    DialogScheduleFlowApi: DialogScheduleFlowApi,
    /**
     * The DialogScheduleRhytmApi service constructor.
     * @property {module:api/DialogScheduleRhytmApi}
     */
    DialogScheduleRhytmApi: DialogScheduleRhytmApi,
    /**
     * The DialogScheduleSettingsApi service constructor.
     * @property {module:api/DialogScheduleSettingsApi}
     */
    DialogScheduleSettingsApi: DialogScheduleSettingsApi,
    /**
     * The DialogScheduleUserApi service constructor.
     * @property {module:api/DialogScheduleUserApi}
     */
    DialogScheduleUserApi: DialogScheduleUserApi,
    /**
     * The ERPAccountListApi service constructor.
     * @property {module:api/ERPAccountListApi}
     */
    ERPAccountListApi: ERPAccountListApi,
    /**
     * The ERPAdminCostDivisionRuleApi service constructor.
     * @property {module:api/ERPAdminCostDivisionRuleApi}
     */
    ERPAdminCostDivisionRuleApi: ERPAdminCostDivisionRuleApi,
    /**
     * The ERPAdminCostDivisionRuleFixedRuleApi service constructor.
     * @property {module:api/ERPAdminCostDivisionRuleFixedRuleApi}
     */
    ERPAdminCostDivisionRuleFixedRuleApi: ERPAdminCostDivisionRuleFixedRuleApi,
    /**
     * The ERPAdminCostDivisionRuleFromAccountApi service constructor.
     * @property {module:api/ERPAdminCostDivisionRuleFromAccountApi}
     */
    ERPAdminCostDivisionRuleFromAccountApi: ERPAdminCostDivisionRuleFromAccountApi,
    /**
     * The ERPAdminCostDivisionRuleLevelApi service constructor.
     * @property {module:api/ERPAdminCostDivisionRuleLevelApi}
     */
    ERPAdminCostDivisionRuleLevelApi: ERPAdminCostDivisionRuleLevelApi,
    /**
     * The ERPAdminCostDivisionRuleSourceFilterApi service constructor.
     * @property {module:api/ERPAdminCostDivisionRuleSourceFilterApi}
     */
    ERPAdminCostDivisionRuleSourceFilterApi: ERPAdminCostDivisionRuleSourceFilterApi,
    /**
     * The ERPAdminCostDivisionTypeApi service constructor.
     * @property {module:api/ERPAdminCostDivisionTypeApi}
     */
    ERPAdminCostDivisionTypeApi: ERPAdminCostDivisionTypeApi,
    /**
     * The ERPCorporateAccountApi service constructor.
     * @property {module:api/ERPCorporateAccountApi}
     */
    ERPCorporateAccountApi: ERPCorporateAccountApi,
    /**
     * The ERPDimensionMappingApi service constructor.
     * @property {module:api/ERPDimensionMappingApi}
     */
    ERPDimensionMappingApi: ERPDimensionMappingApi,
    /**
     * The ERPDimensionSyncSettingApi service constructor.
     * @property {module:api/ERPDimensionSyncSettingApi}
     */
    ERPDimensionSyncSettingApi: ERPDimensionSyncSettingApi,
    /**
     * The ERPDimensionSyncTypeApi service constructor.
     * @property {module:api/ERPDimensionSyncTypeApi}
     */
    ERPDimensionSyncTypeApi: ERPDimensionSyncTypeApi,
    /**
     * The ERPFinancialAdvisorySettingsApi service constructor.
     * @property {module:api/ERPFinancialAdvisorySettingsApi}
     */
    ERPFinancialAdvisorySettingsApi: ERPFinancialAdvisorySettingsApi,
    /**
     * The ERPFinancialCalculationErrorApi service constructor.
     * @property {module:api/ERPFinancialCalculationErrorApi}
     */
    ERPFinancialCalculationErrorApi: ERPFinancialCalculationErrorApi,
    /**
     * The ERPFivaldiIntegrationSettingsApi service constructor.
     * @property {module:api/ERPFivaldiIntegrationSettingsApi}
     */
    ERPFivaldiIntegrationSettingsApi: ERPFivaldiIntegrationSettingsApi,
    /**
     * The ERPNetvisorIntegrationLockPeriodApi service constructor.
     * @property {module:api/ERPNetvisorIntegrationLockPeriodApi}
     */
    ERPNetvisorIntegrationLockPeriodApi: ERPNetvisorIntegrationLockPeriodApi,
    /**
     * The ERPNetvisorIntegrationSettingsApi service constructor.
     * @property {module:api/ERPNetvisorIntegrationSettingsApi}
     */
    ERPNetvisorIntegrationSettingsApi: ERPNetvisorIntegrationSettingsApi,
    /**
     * The ERPProcountorIntegrationSettingsApi service constructor.
     * @property {module:api/ERPProcountorIntegrationSettingsApi}
     */
    ERPProcountorIntegrationSettingsApi: ERPProcountorIntegrationSettingsApi,
    /**
     * The ERPSyncCustomerApi service constructor.
     * @property {module:api/ERPSyncCustomerApi}
     */
    ERPSyncCustomerApi: ERPSyncCustomerApi,
    /**
     * The ERPSyncProductApi service constructor.
     * @property {module:api/ERPSyncProductApi}
     */
    ERPSyncProductApi: ERPSyncProductApi,
    /**
     * The EntityChangeApi service constructor.
     * @property {module:api/EntityChangeApi}
     */
    EntityChangeApi: EntityChangeApi,
    /**
     * The FinancialIndicatorApi service constructor.
     * @property {module:api/FinancialIndicatorApi}
     */
    FinancialIndicatorApi: FinancialIndicatorApi,
    /**
     * The ForecastModelApi service constructor.
     * @property {module:api/ForecastModelApi}
     */
    ForecastModelApi: ForecastModelApi,
    /**
     * The ForecastModelAggregationLevelApi service constructor.
     * @property {module:api/ForecastModelAggregationLevelApi}
     */
    ForecastModelAggregationLevelApi: ForecastModelAggregationLevelApi,
    /**
     * The ForecastModelDataEntryApi service constructor.
     * @property {module:api/ForecastModelDataEntryApi}
     */
    ForecastModelDataEntryApi: ForecastModelDataEntryApi,
    /**
     * The ForecastModelDataEntryCustomIndicatorApi service constructor.
     * @property {module:api/ForecastModelDataEntryCustomIndicatorApi}
     */
    ForecastModelDataEntryCustomIndicatorApi: ForecastModelDataEntryCustomIndicatorApi,
    /**
     * The ForecastModelDataEntryStatusApi service constructor.
     * @property {module:api/ForecastModelDataEntryStatusApi}
     */
    ForecastModelDataEntryStatusApi: ForecastModelDataEntryStatusApi,
    /**
     * The ForecastModelDataEntryTypeApi service constructor.
     * @property {module:api/ForecastModelDataEntryTypeApi}
     */
    ForecastModelDataEntryTypeApi: ForecastModelDataEntryTypeApi,
    /**
     * The ForecastModelRecordDataApi service constructor.
     * @property {module:api/ForecastModelRecordDataApi}
     */
    ForecastModelRecordDataApi: ForecastModelRecordDataApi,
    /**
     * The ForecastModelRecordDataActualSplitRangeApi service constructor.
     * @property {module:api/ForecastModelRecordDataActualSplitRangeApi}
     */
    ForecastModelRecordDataActualSplitRangeApi: ForecastModelRecordDataActualSplitRangeApi,
    /**
     * The ForecastModelRecordDataFileApi service constructor.
     * @property {module:api/ForecastModelRecordDataFileApi}
     */
    ForecastModelRecordDataFileApi: ForecastModelRecordDataFileApi,
    /**
     * The ForecastModelRecordDataImportPeriodTypeApi service constructor.
     * @property {module:api/ForecastModelRecordDataImportPeriodTypeApi}
     */
    ForecastModelRecordDataImportPeriodTypeApi: ForecastModelRecordDataImportPeriodTypeApi,
    /**
     * The ForesightScenarioApi service constructor.
     * @property {module:api/ForesightScenarioApi}
     */
    ForesightScenarioApi: ForesightScenarioApi,
    /**
     * The ForesightScenarioBaselineCalculationApi service constructor.
     * @property {module:api/ForesightScenarioBaselineCalculationApi}
     */
    ForesightScenarioBaselineCalculationApi: ForesightScenarioBaselineCalculationApi,
    /**
     * The ForesightScenarioElementApi service constructor.
     * @property {module:api/ForesightScenarioElementApi}
     */
    ForesightScenarioElementApi: ForesightScenarioElementApi,
    /**
     * The ForesightScenarioElementTypeApi service constructor.
     * @property {module:api/ForesightScenarioElementTypeApi}
     */
    ForesightScenarioElementTypeApi: ForesightScenarioElementTypeApi,
    /**
     * The ForesightScenarioFactorApi service constructor.
     * @property {module:api/ForesightScenarioFactorApi}
     */
    ForesightScenarioFactorApi: ForesightScenarioFactorApi,
    /**
     * The ForesightScenarioLevelApi service constructor.
     * @property {module:api/ForesightScenarioLevelApi}
     */
    ForesightScenarioLevelApi: ForesightScenarioLevelApi,
    /**
     * The ForesightScenarioNotificationRecipientApi service constructor.
     * @property {module:api/ForesightScenarioNotificationRecipientApi}
     */
    ForesightScenarioNotificationRecipientApi: ForesightScenarioNotificationRecipientApi,
    /**
     * The FrontendErrorReportApi service constructor.
     * @property {module:api/FrontendErrorReportApi}
     */
    FrontendErrorReportApi: FrontendErrorReportApi,
    /**
     * The GeneralSettingsApi service constructor.
     * @property {module:api/GeneralSettingsApi}
     */
    GeneralSettingsApi: GeneralSettingsApi,
    /**
     * The GeoAreaApi service constructor.
     * @property {module:api/GeoAreaApi}
     */
    GeoAreaApi: GeoAreaApi,
    /**
     * The GoalMetricApi service constructor.
     * @property {module:api/GoalMetricApi}
     */
    GoalMetricApi: GoalMetricApi,
    /**
     * The GoalMetricValueSourceApi service constructor.
     * @property {module:api/GoalMetricValueSourceApi}
     */
    GoalMetricValueSourceApi: GoalMetricValueSourceApi,
    /**
     * The GoalMetricValueTypeApi service constructor.
     * @property {module:api/GoalMetricValueTypeApi}
     */
    GoalMetricValueTypeApi: GoalMetricValueTypeApi,
    /**
     * The GoogleAnalyticsSettingsApi service constructor.
     * @property {module:api/GoogleAnalyticsSettingsApi}
     */
    GoogleAnalyticsSettingsApi: GoogleAnalyticsSettingsApi,
    /**
     * The GoogleOAuthUserApi service constructor.
     * @property {module:api/GoogleOAuthUserApi}
     */
    GoogleOAuthUserApi: GoogleOAuthUserApi,
    /**
     * The InsightApi service constructor.
     * @property {module:api/InsightApi}
     */
    InsightApi: InsightApi,
    /**
     * The InsightDefaultExcludedDomainApi service constructor.
     * @property {module:api/InsightDefaultExcludedDomainApi}
     */
    InsightDefaultExcludedDomainApi: InsightDefaultExcludedDomainApi,
    /**
     * The InsightImageApi service constructor.
     * @property {module:api/InsightImageApi}
     */
    InsightImageApi: InsightImageApi,
    /**
     * The InsightReactionLinkApi service constructor.
     * @property {module:api/InsightReactionLinkApi}
     */
    InsightReactionLinkApi: InsightReactionLinkApi,
    /**
     * The InsightReactionTypeApi service constructor.
     * @property {module:api/InsightReactionTypeApi}
     */
    InsightReactionTypeApi: InsightReactionTypeApi,
    /**
     * The InsightTypeApi service constructor.
     * @property {module:api/InsightTypeApi}
     */
    InsightTypeApi: InsightTypeApi,
    /**
     * The IntegrationDataMappingDimensionApi service constructor.
     * @property {module:api/IntegrationDataMappingDimensionApi}
     */
    IntegrationDataMappingDimensionApi: IntegrationDataMappingDimensionApi,
    /**
     * The IntegrationDataMappingMatchRuleApi service constructor.
     * @property {module:api/IntegrationDataMappingMatchRuleApi}
     */
    IntegrationDataMappingMatchRuleApi: IntegrationDataMappingMatchRuleApi,
    /**
     * The IntegrationDataMappingRuleApi service constructor.
     * @property {module:api/IntegrationDataMappingRuleApi}
     */
    IntegrationDataMappingRuleApi: IntegrationDataMappingRuleApi,
    /**
     * The IntegrationDataMappingSourceApi service constructor.
     * @property {module:api/IntegrationDataMappingSourceApi}
     */
    IntegrationDataMappingSourceApi: IntegrationDataMappingSourceApi,
    /**
     * The IntegrationFinancialUploadBatchApi service constructor.
     * @property {module:api/IntegrationFinancialUploadBatchApi}
     */
    IntegrationFinancialUploadBatchApi: IntegrationFinancialUploadBatchApi,
    /**
     * The IntegrationPipedriveSettingsApi service constructor.
     * @property {module:api/IntegrationPipedriveSettingsApi}
     */
    IntegrationPipedriveSettingsApi: IntegrationPipedriveSettingsApi,
    /**
     * The IntegrationPipedriveSettingsPipelineApi service constructor.
     * @property {module:api/IntegrationPipedriveSettingsPipelineApi}
     */
    IntegrationPipedriveSettingsPipelineApi: IntegrationPipedriveSettingsPipelineApi,
    /**
     * The IntegrationPipedriveSettingsPipelineStageApi service constructor.
     * @property {module:api/IntegrationPipedriveSettingsPipelineStageApi}
     */
    IntegrationPipedriveSettingsPipelineStageApi: IntegrationPipedriveSettingsPipelineStageApi,
    /**
     * The IntegrationSettingsNetvisorSyncDefaultHandleTypeApi service constructor.
     * @property {module:api/IntegrationSettingsNetvisorSyncDefaultHandleTypeApi}
     */
    IntegrationSettingsNetvisorSyncDefaultHandleTypeApi: IntegrationSettingsNetvisorSyncDefaultHandleTypeApi,
    /**
     * The IntegrationSourceApi service constructor.
     * @property {module:api/IntegrationSourceApi}
     */
    IntegrationSourceApi: IntegrationSourceApi,
    /**
     * The IntegrationSourceCompanyStatusApi service constructor.
     * @property {module:api/IntegrationSourceCompanyStatusApi}
     */
    IntegrationSourceCompanyStatusApi: IntegrationSourceCompanyStatusApi,
    /**
     * The InvoicingDataApi service constructor.
     * @property {module:api/InvoicingDataApi}
     */
    InvoicingDataApi: InvoicingDataApi,
    /**
     * The InvoicingDataPreviewReportApi service constructor.
     * @property {module:api/InvoicingDataPreviewReportApi}
     */
    InvoicingDataPreviewReportApi: InvoicingDataPreviewReportApi,
    /**
     * The LastFinancialPeriodTypeApi service constructor.
     * @property {module:api/LastFinancialPeriodTypeApi}
     */
    LastFinancialPeriodTypeApi: LastFinancialPeriodTypeApi,
    /**
     * The LemonsoftIntegrationSettingsApi service constructor.
     * @property {module:api/LemonsoftIntegrationSettingsApi}
     */
    LemonsoftIntegrationSettingsApi: LemonsoftIntegrationSettingsApi,
    /**
     * The LivingStrategyDashboardReportApi service constructor.
     * @property {module:api/LivingStrategyDashboardReportApi}
     */
    LivingStrategyDashboardReportApi: LivingStrategyDashboardReportApi,
    /**
     * The MapRegionApi service constructor.
     * @property {module:api/MapRegionApi}
     */
    MapRegionApi: MapRegionApi,
    /**
     * The MarketApi service constructor.
     * @property {module:api/MarketApi}
     */
    MarketApi: MarketApi,
    /**
     * The MarketFeedBingCognitiveApi service constructor.
     * @property {module:api/MarketFeedBingCognitiveApi}
     */
    MarketFeedBingCognitiveApi: MarketFeedBingCognitiveApi,
    /**
     * The MarketFreeNodeApi service constructor.
     * @property {module:api/MarketFreeNodeApi}
     */
    MarketFreeNodeApi: MarketFreeNodeApi,
    /**
     * The MarketPlayerTypeApi service constructor.
     * @property {module:api/MarketPlayerTypeApi}
     */
    MarketPlayerTypeApi: MarketPlayerTypeApi,
    /**
     * The MarketRSSWatchSettingApi service constructor.
     * @property {module:api/MarketRSSWatchSettingApi}
     */
    MarketRSSWatchSettingApi: MarketRSSWatchSettingApi,
    /**
     * The MarketRSSWatchSettingFeedDataApi service constructor.
     * @property {module:api/MarketRSSWatchSettingFeedDataApi}
     */
    MarketRSSWatchSettingFeedDataApi: MarketRSSWatchSettingFeedDataApi,
    /**
     * The MarketRSSWatchSettingReportApi service constructor.
     * @property {module:api/MarketRSSWatchSettingReportApi}
     */
    MarketRSSWatchSettingReportApi: MarketRSSWatchSettingReportApi,
    /**
     * The MarketScopeTypeApi service constructor.
     * @property {module:api/MarketScopeTypeApi}
     */
    MarketScopeTypeApi: MarketScopeTypeApi,
    /**
     * The MarketSearchTemplateReportApi service constructor.
     * @property {module:api/MarketSearchTemplateReportApi}
     */
    MarketSearchTemplateReportApi: MarketSearchTemplateReportApi,
    /**
     * The MasterSearchReportApi service constructor.
     * @property {module:api/MasterSearchReportApi}
     */
    MasterSearchReportApi: MasterSearchReportApi,
    /**
     * The MasterSearchUserInputApi service constructor.
     * @property {module:api/MasterSearchUserInputApi}
     */
    MasterSearchUserInputApi: MasterSearchUserInputApi,
    /**
     * The MeetingApi service constructor.
     * @property {module:api/MeetingApi}
     */
    MeetingApi: MeetingApi,
    /**
     * The MeetingAdministratorApi service constructor.
     * @property {module:api/MeetingAdministratorApi}
     */
    MeetingAdministratorApi: MeetingAdministratorApi,
    /**
     * The MeetingInvitationPeriodTypeApi service constructor.
     * @property {module:api/MeetingInvitationPeriodTypeApi}
     */
    MeetingInvitationPeriodTypeApi: MeetingInvitationPeriodTypeApi,
    /**
     * The MeetingMinutesApi service constructor.
     * @property {module:api/MeetingMinutesApi}
     */
    MeetingMinutesApi: MeetingMinutesApi,
    /**
     * The MeetingMinutesContentTypeApi service constructor.
     * @property {module:api/MeetingMinutesContentTypeApi}
     */
    MeetingMinutesContentTypeApi: MeetingMinutesContentTypeApi,
    /**
     * The MeetingParticipantApi service constructor.
     * @property {module:api/MeetingParticipantApi}
     */
    MeetingParticipantApi: MeetingParticipantApi,
    /**
     * The MeetingSectionApi service constructor.
     * @property {module:api/MeetingSectionApi}
     */
    MeetingSectionApi: MeetingSectionApi,
    /**
     * The MeetingSectionContentTypeApi service constructor.
     * @property {module:api/MeetingSectionContentTypeApi}
     */
    MeetingSectionContentTypeApi: MeetingSectionContentTypeApi,
    /**
     * The MeetingSectionTextTopicApi service constructor.
     * @property {module:api/MeetingSectionTextTopicApi}
     */
    MeetingSectionTextTopicApi: MeetingSectionTextTopicApi,
    /**
     * The MeetingSectionTopicApi service constructor.
     * @property {module:api/MeetingSectionTopicApi}
     */
    MeetingSectionTopicApi: MeetingSectionTopicApi,
    /**
     * The MeetingSectionTopicAttachmentApi service constructor.
     * @property {module:api/MeetingSectionTopicAttachmentApi}
     */
    MeetingSectionTopicAttachmentApi: MeetingSectionTopicAttachmentApi,
    /**
     * The MeetingSectionTopicCommentApi service constructor.
     * @property {module:api/MeetingSectionTopicCommentApi}
     */
    MeetingSectionTopicCommentApi: MeetingSectionTopicCommentApi,
    /**
     * The MeetingSectionTopicLinkApi service constructor.
     * @property {module:api/MeetingSectionTopicLinkApi}
     */
    MeetingSectionTopicLinkApi: MeetingSectionTopicLinkApi,
    /**
     * The MeetingStatusApi service constructor.
     * @property {module:api/MeetingStatusApi}
     */
    MeetingStatusApi: MeetingStatusApi,
    /**
     * The MeetingTemplateApi service constructor.
     * @property {module:api/MeetingTemplateApi}
     */
    MeetingTemplateApi: MeetingTemplateApi,
    /**
     * The MeetingTemplateAdministratorApi service constructor.
     * @property {module:api/MeetingTemplateAdministratorApi}
     */
    MeetingTemplateAdministratorApi: MeetingTemplateAdministratorApi,
    /**
     * The MeetingTemplateParticipantApi service constructor.
     * @property {module:api/MeetingTemplateParticipantApi}
     */
    MeetingTemplateParticipantApi: MeetingTemplateParticipantApi,
    /**
     * The MeetingTemplateSectionApi service constructor.
     * @property {module:api/MeetingTemplateSectionApi}
     */
    MeetingTemplateSectionApi: MeetingTemplateSectionApi,
    /**
     * The MeetingTemplateSectionTextTopicApi service constructor.
     * @property {module:api/MeetingTemplateSectionTextTopicApi}
     */
    MeetingTemplateSectionTextTopicApi: MeetingTemplateSectionTextTopicApi,
    /**
     * The MeetingTemplateSectionTopicApi service constructor.
     * @property {module:api/MeetingTemplateSectionTopicApi}
     */
    MeetingTemplateSectionTopicApi: MeetingTemplateSectionTopicApi,
    /**
     * The MeetingTemplateSectionTopicLinkApi service constructor.
     * @property {module:api/MeetingTemplateSectionTopicLinkApi}
     */
    MeetingTemplateSectionTopicLinkApi: MeetingTemplateSectionTopicLinkApi,
    /**
     * The MicrosoftTeamsBotLinkedConversationApi service constructor.
     * @property {module:api/MicrosoftTeamsBotLinkedConversationApi}
     */
    MicrosoftTeamsBotLinkedConversationApi: MicrosoftTeamsBotLinkedConversationApi,
    /**
     * The MobileClientTokenApi service constructor.
     * @property {module:api/MobileClientTokenApi}
     */
    MobileClientTokenApi: MobileClientTokenApi,
    /**
     * The NewsEntryApi service constructor.
     * @property {module:api/NewsEntryApi}
     */
    NewsEntryApi: NewsEntryApi,
    /**
     * The NewsEntryAutomatedSourceApi service constructor.
     * @property {module:api/NewsEntryAutomatedSourceApi}
     */
    NewsEntryAutomatedSourceApi: NewsEntryAutomatedSourceApi,
    /**
     * The NewsEntryCategoryApi service constructor.
     * @property {module:api/NewsEntryCategoryApi}
     */
    NewsEntryCategoryApi: NewsEntryCategoryApi,
    /**
     * The NewsEntryCommentApi service constructor.
     * @property {module:api/NewsEntryCommentApi}
     */
    NewsEntryCommentApi: NewsEntryCommentApi,
    /**
     * The NewsEntryContributorApi service constructor.
     * @property {module:api/NewsEntryContributorApi}
     */
    NewsEntryContributorApi: NewsEntryContributorApi,
    /**
     * The NewsEntryEntryStatusApi service constructor.
     * @property {module:api/NewsEntryEntryStatusApi}
     */
    NewsEntryEntryStatusApi: NewsEntryEntryStatusApi,
    /**
     * The NewsEntryInsightLinkApi service constructor.
     * @property {module:api/NewsEntryInsightLinkApi}
     */
    NewsEntryInsightLinkApi: NewsEntryInsightLinkApi,
    /**
     * The NewsEntrySourceApi service constructor.
     * @property {module:api/NewsEntrySourceApi}
     */
    NewsEntrySourceApi: NewsEntrySourceApi,
    /**
     * The NewsEntrySourceCategoryApi service constructor.
     * @property {module:api/NewsEntrySourceCategoryApi}
     */
    NewsEntrySourceCategoryApi: NewsEntrySourceCategoryApi,
    /**
     * The NewsEntrySourceReportApi service constructor.
     * @property {module:api/NewsEntrySourceReportApi}
     */
    NewsEntrySourceReportApi: NewsEntrySourceReportApi,
    /**
     * The NewsEntrySourceTypeApi service constructor.
     * @property {module:api/NewsEntrySourceTypeApi}
     */
    NewsEntrySourceTypeApi: NewsEntrySourceTypeApi,
    /**
     * The NewsEntryUserStatusApi service constructor.
     * @property {module:api/NewsEntryUserStatusApi}
     */
    NewsEntryUserStatusApi: NewsEntryUserStatusApi,
    /**
     * The NotificationReportApi service constructor.
     * @property {module:api/NotificationReportApi}
     */
    NotificationReportApi: NotificationReportApi,
    /**
     * The NotificationSendingTimeTypeApi service constructor.
     * @property {module:api/NotificationSendingTimeTypeApi}
     */
    NotificationSendingTimeTypeApi: NotificationSendingTimeTypeApi,
    /**
     * The NotificationTypeApi service constructor.
     * @property {module:api/NotificationTypeApi}
     */
    NotificationTypeApi: NotificationTypeApi,
    /**
     * The OpencorporatesOrganizationApi service constructor.
     * @property {module:api/OpencorporatesOrganizationApi}
     */
    OpencorporatesOrganizationApi: OpencorporatesOrganizationApi,
    /**
     * The OrganizationApi service constructor.
     * @property {module:api/OrganizationApi}
     */
    OrganizationApi: OrganizationApi,
    /**
     * The OrganizationClassificationTypeApi service constructor.
     * @property {module:api/OrganizationClassificationTypeApi}
     */
    OrganizationClassificationTypeApi: OrganizationClassificationTypeApi,
    /**
     * The OtherPlayerApi service constructor.
     * @property {module:api/OtherPlayerApi}
     */
    OtherPlayerApi: OtherPlayerApi,
    /**
     * The PartnerApi service constructor.
     * @property {module:api/PartnerApi}
     */
    PartnerApi: PartnerApi,
    /**
     * The PartnerClientCompanyApi service constructor.
     * @property {module:api/PartnerClientCompanyApi}
     */
    PartnerClientCompanyApi: PartnerClientCompanyApi,
    /**
     * The PartnerClientCompanyEventTypeApi service constructor.
     * @property {module:api/PartnerClientCompanyEventTypeApi}
     */
    PartnerClientCompanyEventTypeApi: PartnerClientCompanyEventTypeApi,
    /**
     * The PartnerClientCompanyTypeApi service constructor.
     * @property {module:api/PartnerClientCompanyTypeApi}
     */
    PartnerClientCompanyTypeApi: PartnerClientCompanyTypeApi,
    /**
     * The PartnerSupportLevelApi service constructor.
     * @property {module:api/PartnerSupportLevelApi}
     */
    PartnerSupportLevelApi: PartnerSupportLevelApi,
    /**
     * The PerformanceIndicatorApi service constructor.
     * @property {module:api/PerformanceIndicatorApi}
     */
    PerformanceIndicatorApi: PerformanceIndicatorApi,
    /**
     * The PerformanceIndicatorCalculationRangeApi service constructor.
     * @property {module:api/PerformanceIndicatorCalculationRangeApi}
     */
    PerformanceIndicatorCalculationRangeApi: PerformanceIndicatorCalculationRangeApi,
    /**
     * The PerformanceIndicatorCollectionTypeApi service constructor.
     * @property {module:api/PerformanceIndicatorCollectionTypeApi}
     */
    PerformanceIndicatorCollectionTypeApi: PerformanceIndicatorCollectionTypeApi,
    /**
     * The PerformanceIndicatorComparisonCalculationApi service constructor.
     * @property {module:api/PerformanceIndicatorComparisonCalculationApi}
     */
    PerformanceIndicatorComparisonCalculationApi: PerformanceIndicatorComparisonCalculationApi,
    /**
     * The PerformanceIndicatorComparisonTargetApi service constructor.
     * @property {module:api/PerformanceIndicatorComparisonTargetApi}
     */
    PerformanceIndicatorComparisonTargetApi: PerformanceIndicatorComparisonTargetApi,
    /**
     * The PerformanceIndicatorConversationApi service constructor.
     * @property {module:api/PerformanceIndicatorConversationApi}
     */
    PerformanceIndicatorConversationApi: PerformanceIndicatorConversationApi,
    /**
     * The PerformanceIndicatorDateRangeApi service constructor.
     * @property {module:api/PerformanceIndicatorDateRangeApi}
     */
    PerformanceIndicatorDateRangeApi: PerformanceIndicatorDateRangeApi,
    /**
     * The PerformanceIndicatorDayDataApi service constructor.
     * @property {module:api/PerformanceIndicatorDayDataApi}
     */
    PerformanceIndicatorDayDataApi: PerformanceIndicatorDayDataApi,
    /**
     * The PerformanceIndicatorDimensionApi service constructor.
     * @property {module:api/PerformanceIndicatorDimensionApi}
     */
    PerformanceIndicatorDimensionApi: PerformanceIndicatorDimensionApi,
    /**
     * The PerformanceIndicatorFormulaApi service constructor.
     * @property {module:api/PerformanceIndicatorFormulaApi}
     */
    PerformanceIndicatorFormulaApi: PerformanceIndicatorFormulaApi,
    /**
     * The PerformanceIndicatorFormulaElementTypeApi service constructor.
     * @property {module:api/PerformanceIndicatorFormulaElementTypeApi}
     */
    PerformanceIndicatorFormulaElementTypeApi: PerformanceIndicatorFormulaElementTypeApi,
    /**
     * The PerformanceIndicatorGroupApi service constructor.
     * @property {module:api/PerformanceIndicatorGroupApi}
     */
    PerformanceIndicatorGroupApi: PerformanceIndicatorGroupApi,
    /**
     * The PerformanceIndicatorMonthDataApi service constructor.
     * @property {module:api/PerformanceIndicatorMonthDataApi}
     */
    PerformanceIndicatorMonthDataApi: PerformanceIndicatorMonthDataApi,
    /**
     * The PerformanceIndicatorPeriodTypeApi service constructor.
     * @property {module:api/PerformanceIndicatorPeriodTypeApi}
     */
    PerformanceIndicatorPeriodTypeApi: PerformanceIndicatorPeriodTypeApi,
    /**
     * The PerformanceIndicatorPointCalculationApi service constructor.
     * @property {module:api/PerformanceIndicatorPointCalculationApi}
     */
    PerformanceIndicatorPointCalculationApi: PerformanceIndicatorPointCalculationApi,
    /**
     * The PerformanceIndicatorPollBatchApi service constructor.
     * @property {module:api/PerformanceIndicatorPollBatchApi}
     */
    PerformanceIndicatorPollBatchApi: PerformanceIndicatorPollBatchApi,
    /**
     * The PerformanceIndicatorPollBatchUserApi service constructor.
     * @property {module:api/PerformanceIndicatorPollBatchUserApi}
     */
    PerformanceIndicatorPollBatchUserApi: PerformanceIndicatorPollBatchUserApi,
    /**
     * The PerformanceIndicatorPollGeneralResponseApi service constructor.
     * @property {module:api/PerformanceIndicatorPollGeneralResponseApi}
     */
    PerformanceIndicatorPollGeneralResponseApi: PerformanceIndicatorPollGeneralResponseApi,
    /**
     * The PerformanceIndicatorPollSettingsApi service constructor.
     * @property {module:api/PerformanceIndicatorPollSettingsApi}
     */
    PerformanceIndicatorPollSettingsApi: PerformanceIndicatorPollSettingsApi,
    /**
     * The PerformanceIndicatorPollStatusApi service constructor.
     * @property {module:api/PerformanceIndicatorPollStatusApi}
     */
    PerformanceIndicatorPollStatusApi: PerformanceIndicatorPollStatusApi,
    /**
     * The PerformanceIndicatorPollValueAggregationTypeApi service constructor.
     * @property {module:api/PerformanceIndicatorPollValueAggregationTypeApi}
     */
    PerformanceIndicatorPollValueAggregationTypeApi: PerformanceIndicatorPollValueAggregationTypeApi,
    /**
     * The PerformanceIndicatorPollValueTypeApi service constructor.
     * @property {module:api/PerformanceIndicatorPollValueTypeApi}
     */
    PerformanceIndicatorPollValueTypeApi: PerformanceIndicatorPollValueTypeApi,
    /**
     * The PerformanceIndicatorQuarterDataApi service constructor.
     * @property {module:api/PerformanceIndicatorQuarterDataApi}
     */
    PerformanceIndicatorQuarterDataApi: PerformanceIndicatorQuarterDataApi,
    /**
     * The PerformanceIndicatorRelativePeriodApi service constructor.
     * @property {module:api/PerformanceIndicatorRelativePeriodApi}
     */
    PerformanceIndicatorRelativePeriodApi: PerformanceIndicatorRelativePeriodApi,
    /**
     * The PerformanceIndicatorSystemTypeApi service constructor.
     * @property {module:api/PerformanceIndicatorSystemTypeApi}
     */
    PerformanceIndicatorSystemTypeApi: PerformanceIndicatorSystemTypeApi,
    /**
     * The PerformanceIndicatorValueDependencyRuleApi service constructor.
     * @property {module:api/PerformanceIndicatorValueDependencyRuleApi}
     */
    PerformanceIndicatorValueDependencyRuleApi: PerformanceIndicatorValueDependencyRuleApi,
    /**
     * The PerformanceIndicatorValueSourceApi service constructor.
     * @property {module:api/PerformanceIndicatorValueSourceApi}
     */
    PerformanceIndicatorValueSourceApi: PerformanceIndicatorValueSourceApi,
    /**
     * The PerformanceIndicatorWeekDataApi service constructor.
     * @property {module:api/PerformanceIndicatorWeekDataApi}
     */
    PerformanceIndicatorWeekDataApi: PerformanceIndicatorWeekDataApi,
    /**
     * The PerformanceIndicatorYearDataApi service constructor.
     * @property {module:api/PerformanceIndicatorYearDataApi}
     */
    PerformanceIndicatorYearDataApi: PerformanceIndicatorYearDataApi,
    /**
     * The PerformanceManagementAlertApi service constructor.
     * @property {module:api/PerformanceManagementAlertApi}
     */
    PerformanceManagementAlertApi: PerformanceManagementAlertApi,
    /**
     * The PerformanceManagementAlertActivityStatusApi service constructor.
     * @property {module:api/PerformanceManagementAlertActivityStatusApi}
     */
    PerformanceManagementAlertActivityStatusApi: PerformanceManagementAlertActivityStatusApi,
    /**
     * The PerformanceManagementAlertDashboardBlockApi service constructor.
     * @property {module:api/PerformanceManagementAlertDashboardBlockApi}
     */
    PerformanceManagementAlertDashboardBlockApi: PerformanceManagementAlertDashboardBlockApi,
    /**
     * The PerformanceManagementAlertDashboardBlockCommentApi service constructor.
     * @property {module:api/PerformanceManagementAlertDashboardBlockCommentApi}
     */
    PerformanceManagementAlertDashboardBlockCommentApi: PerformanceManagementAlertDashboardBlockCommentApi,
    /**
     * The PerformanceManagementAlertDeliveryChannelApi service constructor.
     * @property {module:api/PerformanceManagementAlertDeliveryChannelApi}
     */
    PerformanceManagementAlertDeliveryChannelApi: PerformanceManagementAlertDeliveryChannelApi,
    /**
     * The PerformanceManagementAlertEmailTitleTypeApi service constructor.
     * @property {module:api/PerformanceManagementAlertEmailTitleTypeApi}
     */
    PerformanceManagementAlertEmailTitleTypeApi: PerformanceManagementAlertEmailTitleTypeApi,
    /**
     * The PerformanceManagementAlertIndicatorApi service constructor.
     * @property {module:api/PerformanceManagementAlertIndicatorApi}
     */
    PerformanceManagementAlertIndicatorApi: PerformanceManagementAlertIndicatorApi,
    /**
     * The PerformanceManagementAlertRecipientApi service constructor.
     * @property {module:api/PerformanceManagementAlertRecipientApi}
     */
    PerformanceManagementAlertRecipientApi: PerformanceManagementAlertRecipientApi,
    /**
     * The PerformanceManagementAlertReviewSectionApi service constructor.
     * @property {module:api/PerformanceManagementAlertReviewSectionApi}
     */
    PerformanceManagementAlertReviewSectionApi: PerformanceManagementAlertReviewSectionApi,
    /**
     * The PerformanceManagementAlertReviewSectionCommentApi service constructor.
     * @property {module:api/PerformanceManagementAlertReviewSectionCommentApi}
     */
    PerformanceManagementAlertReviewSectionCommentApi: PerformanceManagementAlertReviewSectionCommentApi,
    /**
     * The PerformanceManagementAlertScoreApi service constructor.
     * @property {module:api/PerformanceManagementAlertScoreApi}
     */
    PerformanceManagementAlertScoreApi: PerformanceManagementAlertScoreApi,
    /**
     * The PerformanceManagementAlertTriggerIndicatorApi service constructor.
     * @property {module:api/PerformanceManagementAlertTriggerIndicatorApi}
     */
    PerformanceManagementAlertTriggerIndicatorApi: PerformanceManagementAlertTriggerIndicatorApi,
    /**
     * The PerformanceManagementAlertTriggerTypeApi service constructor.
     * @property {module:api/PerformanceManagementAlertTriggerTypeApi}
     */
    PerformanceManagementAlertTriggerTypeApi: PerformanceManagementAlertTriggerTypeApi,
    /**
     * The PerformancePerspectiveApi service constructor.
     * @property {module:api/PerformancePerspectiveApi}
     */
    PerformancePerspectiveApi: PerformancePerspectiveApi,
    /**
     * The PerformancePerspectiveGroupApi service constructor.
     * @property {module:api/PerformancePerspectiveGroupApi}
     */
    PerformancePerspectiveGroupApi: PerformancePerspectiveGroupApi,
    /**
     * The PersonalTopicApi service constructor.
     * @property {module:api/PersonalTopicApi}
     */
    PersonalTopicApi: PersonalTopicApi,
    /**
     * The PollReportApi service constructor.
     * @property {module:api/PollReportApi}
     */
    PollReportApi: PollReportApi,
    /**
     * The PollSettingsScaleApi service constructor.
     * @property {module:api/PollSettingsScaleApi}
     */
    PollSettingsScaleApi: PollSettingsScaleApi,
    /**
     * The PowerBITokenApi service constructor.
     * @property {module:api/PowerBITokenApi}
     */
    PowerBITokenApi: PowerBITokenApi,
    /**
     * The ProductApi service constructor.
     * @property {module:api/ProductApi}
     */
    ProductApi: ProductApi,
    /**
     * The PublicExternalLinkApi service constructor.
     * @property {module:api/PublicExternalLinkApi}
     */
    PublicExternalLinkApi: PublicExternalLinkApi,
    /**
     * The QuickStartApi service constructor.
     * @property {module:api/QuickStartApi}
     */
    QuickStartApi: QuickStartApi,
    /**
     * The RawDataMappingApi service constructor.
     * @property {module:api/RawDataMappingApi}
     */
    RawDataMappingApi: RawDataMappingApi,
    /**
     * The RawDataMappingColumnApi service constructor.
     * @property {module:api/RawDataMappingColumnApi}
     */
    RawDataMappingColumnApi: RawDataMappingColumnApi,
    /**
     * The RawDataMappingColumnDataTypeApi service constructor.
     * @property {module:api/RawDataMappingColumnDataTypeApi}
     */
    RawDataMappingColumnDataTypeApi: RawDataMappingColumnDataTypeApi,
    /**
     * The RawDataMappingRuleApi service constructor.
     * @property {module:api/RawDataMappingRuleApi}
     */
    RawDataMappingRuleApi: RawDataMappingRuleApi,
    /**
     * The RawDataRowApi service constructor.
     * @property {module:api/RawDataRowApi}
     */
    RawDataRowApi: RawDataRowApi,
    /**
     * The RawDataSourceApi service constructor.
     * @property {module:api/RawDataSourceApi}
     */
    RawDataSourceApi: RawDataSourceApi,
    /**
     * The RawDataSourceStatusApi service constructor.
     * @property {module:api/RawDataSourceStatusApi}
     */
    RawDataSourceStatusApi: RawDataSourceStatusApi,
    /**
     * The RelativeDateTypeApi service constructor.
     * @property {module:api/RelativeDateTypeApi}
     */
    RelativeDateTypeApi: RelativeDateTypeApi,
    /**
     * The SIEUploadQueueApi service constructor.
     * @property {module:api/SIEUploadQueueApi}
     */
    SIEUploadQueueApi: SIEUploadQueueApi,
    /**
     * The SWOTAreaApi service constructor.
     * @property {module:api/SWOTAreaApi}
     */
    SWOTAreaApi: SWOTAreaApi,
    /**
     * The SWOTInboxApi service constructor.
     * @property {module:api/SWOTInboxApi}
     */
    SWOTInboxApi: SWOTInboxApi,
    /**
     * The SWOTSessionApi service constructor.
     * @property {module:api/SWOTSessionApi}
     */
    SWOTSessionApi: SWOTSessionApi,
    /**
     * The SWOTSessionParticipantApi service constructor.
     * @property {module:api/SWOTSessionParticipantApi}
     */
    SWOTSessionParticipantApi: SWOTSessionParticipantApi,
    /**
     * The SWOTTopicApi service constructor.
     * @property {module:api/SWOTTopicApi}
     */
    SWOTTopicApi: SWOTTopicApi,
    /**
     * The SWOTTopicCommentApi service constructor.
     * @property {module:api/SWOTTopicCommentApi}
     */
    SWOTTopicCommentApi: SWOTTopicCommentApi,
    /**
     * The SWOTTopicVoteApi service constructor.
     * @property {module:api/SWOTTopicVoteApi}
     */
    SWOTTopicVoteApi: SWOTTopicVoteApi,
    /**
     * The SWOTTopicVoteBatchApi service constructor.
     * @property {module:api/SWOTTopicVoteBatchApi}
     */
    SWOTTopicVoteBatchApi: SWOTTopicVoteBatchApi,
    /**
     * The SessionInformationApi service constructor.
     * @property {module:api/SessionInformationApi}
     */
    SessionInformationApi: SessionInformationApi,
    /**
     * The SeveraIntegrationSettingsApi service constructor.
     * @property {module:api/SeveraIntegrationSettingsApi}
     */
    SeveraIntegrationSettingsApi: SeveraIntegrationSettingsApi,
    /**
     * The SheetConfigurationApi service constructor.
     * @property {module:api/SheetConfigurationApi}
     */
    SheetConfigurationApi: SheetConfigurationApi,
    /**
     * The SheetConfigurationForecastDownloadFromSheetRuleApi service constructor.
     * @property {module:api/SheetConfigurationForecastDownloadFromSheetRuleApi}
     */
    SheetConfigurationForecastDownloadFromSheetRuleApi: SheetConfigurationForecastDownloadFromSheetRuleApi,
    /**
     * The SheetConfigurationForecastUploadToSheetRuleApi service constructor.
     * @property {module:api/SheetConfigurationForecastUploadToSheetRuleApi}
     */
    SheetConfigurationForecastUploadToSheetRuleApi: SheetConfigurationForecastUploadToSheetRuleApi,
    /**
     * The SheetExcelConfigurationApi service constructor.
     * @property {module:api/SheetExcelConfigurationApi}
     */
    SheetExcelConfigurationApi: SheetExcelConfigurationApi,
    /**
     * The SheetExcelGenerationIndicatorDepthRuleApi service constructor.
     * @property {module:api/SheetExcelGenerationIndicatorDepthRuleApi}
     */
    SheetExcelGenerationIndicatorDepthRuleApi: SheetExcelGenerationIndicatorDepthRuleApi,
    /**
     * The SheetExcelGenerationValueWriteRuleApi service constructor.
     * @property {module:api/SheetExcelGenerationValueWriteRuleApi}
     */
    SheetExcelGenerationValueWriteRuleApi: SheetExcelGenerationValueWriteRuleApi,
    /**
     * The SheetForecastApi service constructor.
     * @property {module:api/SheetForecastApi}
     */
    SheetForecastApi: SheetForecastApi,
    /**
     * The SheetForecastFileApi service constructor.
     * @property {module:api/SheetForecastFileApi}
     */
    SheetForecastFileApi: SheetForecastFileApi,
    /**
     * The SheetForecastFileStatusApi service constructor.
     * @property {module:api/SheetForecastFileStatusApi}
     */
    SheetForecastFileStatusApi: SheetForecastFileStatusApi,
    /**
     * The SheetForecastFileTypeApi service constructor.
     * @property {module:api/SheetForecastFileTypeApi}
     */
    SheetForecastFileTypeApi: SheetForecastFileTypeApi,
    /**
     * The SheetForecastFileUserAccessApi service constructor.
     * @property {module:api/SheetForecastFileUserAccessApi}
     */
    SheetForecastFileUserAccessApi: SheetForecastFileUserAccessApi,
    /**
     * The SheetForecastInputMethodApi service constructor.
     * @property {module:api/SheetForecastInputMethodApi}
     */
    SheetForecastInputMethodApi: SheetForecastInputMethodApi,
    /**
     * The SheetForecastNotificationApi service constructor.
     * @property {module:api/SheetForecastNotificationApi}
     */
    SheetForecastNotificationApi: SheetForecastNotificationApi,
    /**
     * The SheetForecastRelatedSheetApi service constructor.
     * @property {module:api/SheetForecastRelatedSheetApi}
     */
    SheetForecastRelatedSheetApi: SheetForecastRelatedSheetApi,
    /**
     * The SheetGoogleConfigurationApi service constructor.
     * @property {module:api/SheetGoogleConfigurationApi}
     */
    SheetGoogleConfigurationApi: SheetGoogleConfigurationApi,
    /**
     * The SheetGoogleTemplateCopiedRangeValueTypeApi service constructor.
     * @property {module:api/SheetGoogleTemplateCopiedRangeValueTypeApi}
     */
    SheetGoogleTemplateCopiedRangeValueTypeApi: SheetGoogleTemplateCopiedRangeValueTypeApi,
    /**
     * The StakeholderApi service constructor.
     * @property {module:api/StakeholderApi}
     */
    StakeholderApi: StakeholderApi,
    /**
     * The StakeholderBenchmarkApi service constructor.
     * @property {module:api/StakeholderBenchmarkApi}
     */
    StakeholderBenchmarkApi: StakeholderBenchmarkApi,
    /**
     * The StakeholderBenchmarkCustomItemApi service constructor.
     * @property {module:api/StakeholderBenchmarkCustomItemApi}
     */
    StakeholderBenchmarkCustomItemApi: StakeholderBenchmarkCustomItemApi,
    /**
     * The StakeholderBenchmarkDimensionApi service constructor.
     * @property {module:api/StakeholderBenchmarkDimensionApi}
     */
    StakeholderBenchmarkDimensionApi: StakeholderBenchmarkDimensionApi,
    /**
     * The StakeholderBenchmarkDimensionValueApi service constructor.
     * @property {module:api/StakeholderBenchmarkDimensionValueApi}
     */
    StakeholderBenchmarkDimensionValueApi: StakeholderBenchmarkDimensionValueApi,
    /**
     * The StakeholderBenchmarkTemplateApi service constructor.
     * @property {module:api/StakeholderBenchmarkTemplateApi}
     */
    StakeholderBenchmarkTemplateApi: StakeholderBenchmarkTemplateApi,
    /**
     * The StakeholderCommentApi service constructor.
     * @property {module:api/StakeholderCommentApi}
     */
    StakeholderCommentApi: StakeholderCommentApi,
    /**
     * The StakeholderMarketPositioningMapViewApi service constructor.
     * @property {module:api/StakeholderMarketPositioningMapViewApi}
     */
    StakeholderMarketPositioningMapViewApi: StakeholderMarketPositioningMapViewApi,
    /**
     * The StakeholderMarketPositioningMapViewCustomItemApi service constructor.
     * @property {module:api/StakeholderMarketPositioningMapViewCustomItemApi}
     */
    StakeholderMarketPositioningMapViewCustomItemApi: StakeholderMarketPositioningMapViewCustomItemApi,
    /**
     * The StakeholderMarketPositioningMapViewPositionApi service constructor.
     * @property {module:api/StakeholderMarketPositioningMapViewPositionApi}
     */
    StakeholderMarketPositioningMapViewPositionApi: StakeholderMarketPositioningMapViewPositionApi,
    /**
     * The StakeholderMarketPositioningMapViewTemplateApi service constructor.
     * @property {module:api/StakeholderMarketPositioningMapViewTemplateApi}
     */
    StakeholderMarketPositioningMapViewTemplateApi: StakeholderMarketPositioningMapViewTemplateApi,
    /**
     * The StakeholderNewsEntryAutomatedSourceApi service constructor.
     * @property {module:api/StakeholderNewsEntryAutomatedSourceApi}
     */
    StakeholderNewsEntryAutomatedSourceApi: StakeholderNewsEntryAutomatedSourceApi,
    /**
     * The StakeholderNewsWatchFilterLevelApi service constructor.
     * @property {module:api/StakeholderNewsWatchFilterLevelApi}
     */
    StakeholderNewsWatchFilterLevelApi: StakeholderNewsWatchFilterLevelApi,
    /**
     * The StakeholderTypeApi service constructor.
     * @property {module:api/StakeholderTypeApi}
     */
    StakeholderTypeApi: StakeholderTypeApi,
    /**
     * The StrategicGoalApi service constructor.
     * @property {module:api/StrategicGoalApi}
     */
    StrategicGoalApi: StrategicGoalApi,
    /**
     * The StrategicGoalCriticalSuccessFactorApi service constructor.
     * @property {module:api/StrategicGoalCriticalSuccessFactorApi}
     */
    StrategicGoalCriticalSuccessFactorApi: StrategicGoalCriticalSuccessFactorApi,
    /**
     * The StrategicGoalMilestoneApi service constructor.
     * @property {module:api/StrategicGoalMilestoneApi}
     */
    StrategicGoalMilestoneApi: StrategicGoalMilestoneApi,
    /**
     * The StrategicGoalMilestoneAchievabilityApi service constructor.
     * @property {module:api/StrategicGoalMilestoneAchievabilityApi}
     */
    StrategicGoalMilestoneAchievabilityApi: StrategicGoalMilestoneAchievabilityApi,
    /**
     * The StrategicGoalMilestoneCommentApi service constructor.
     * @property {module:api/StrategicGoalMilestoneCommentApi}
     */
    StrategicGoalMilestoneCommentApi: StrategicGoalMilestoneCommentApi,
    /**
     * The StrategicGoalMilestoneFinalStatusApi service constructor.
     * @property {module:api/StrategicGoalMilestoneFinalStatusApi}
     */
    StrategicGoalMilestoneFinalStatusApi: StrategicGoalMilestoneFinalStatusApi,
    /**
     * The StrategicGoalMilestoneSecondaryOwnerApi service constructor.
     * @property {module:api/StrategicGoalMilestoneSecondaryOwnerApi}
     */
    StrategicGoalMilestoneSecondaryOwnerApi: StrategicGoalMilestoneSecondaryOwnerApi,
    /**
     * The StrategicGoalMilestoneSecondaryStatusUpdateApi service constructor.
     * @property {module:api/StrategicGoalMilestoneSecondaryStatusUpdateApi}
     */
    StrategicGoalMilestoneSecondaryStatusUpdateApi: StrategicGoalMilestoneSecondaryStatusUpdateApi,
    /**
     * The StrategicGoalMilestoneStatusApi service constructor.
     * @property {module:api/StrategicGoalMilestoneStatusApi}
     */
    StrategicGoalMilestoneStatusApi: StrategicGoalMilestoneStatusApi,
    /**
     * The StrategicGoalMilestoneStatusUpdateApi service constructor.
     * @property {module:api/StrategicGoalMilestoneStatusUpdateApi}
     */
    StrategicGoalMilestoneStatusUpdateApi: StrategicGoalMilestoneStatusUpdateApi,
    /**
     * The StrategicGoalMilestoneTeamLinkApi service constructor.
     * @property {module:api/StrategicGoalMilestoneTeamLinkApi}
     */
    StrategicGoalMilestoneTeamLinkApi: StrategicGoalMilestoneTeamLinkApi,
    /**
     * The StrategicProgramApi service constructor.
     * @property {module:api/StrategicProgramApi}
     */
    StrategicProgramApi: StrategicProgramApi,
    /**
     * The StrategicProgramCommentApi service constructor.
     * @property {module:api/StrategicProgramCommentApi}
     */
    StrategicProgramCommentApi: StrategicProgramCommentApi,
    /**
     * The StrategicProgramConnectionApi service constructor.
     * @property {module:api/StrategicProgramConnectionApi}
     */
    StrategicProgramConnectionApi: StrategicProgramConnectionApi,
    /**
     * The StrategicProgramFinalStatusApi service constructor.
     * @property {module:api/StrategicProgramFinalStatusApi}
     */
    StrategicProgramFinalStatusApi: StrategicProgramFinalStatusApi,
    /**
     * The StrategicProgramRiskLevelApi service constructor.
     * @property {module:api/StrategicProgramRiskLevelApi}
     */
    StrategicProgramRiskLevelApi: StrategicProgramRiskLevelApi,
    /**
     * The StrategicProgramSecondaryOwnerApi service constructor.
     * @property {module:api/StrategicProgramSecondaryOwnerApi}
     */
    StrategicProgramSecondaryOwnerApi: StrategicProgramSecondaryOwnerApi,
    /**
     * The StrategicProgramStatusApi service constructor.
     * @property {module:api/StrategicProgramStatusApi}
     */
    StrategicProgramStatusApi: StrategicProgramStatusApi,
    /**
     * The StrategicProgramStatusUpdateApi service constructor.
     * @property {module:api/StrategicProgramStatusUpdateApi}
     */
    StrategicProgramStatusUpdateApi: StrategicProgramStatusUpdateApi,
    /**
     * The StrategicProgramStatusUpdateRecipientApi service constructor.
     * @property {module:api/StrategicProgramStatusUpdateRecipientApi}
     */
    StrategicProgramStatusUpdateRecipientApi: StrategicProgramStatusUpdateRecipientApi,
    /**
     * The StrategicProgramUpdateFrequencyApi service constructor.
     * @property {module:api/StrategicProgramUpdateFrequencyApi}
     */
    StrategicProgramUpdateFrequencyApi: StrategicProgramUpdateFrequencyApi,
    /**
     * The StrategyDescriptionApi service constructor.
     * @property {module:api/StrategyDescriptionApi}
     */
    StrategyDescriptionApi: StrategyDescriptionApi,
    /**
     * The StrategyDescriptionAdministratorApi service constructor.
     * @property {module:api/StrategyDescriptionAdministratorApi}
     */
    StrategyDescriptionAdministratorApi: StrategyDescriptionAdministratorApi,
    /**
     * The StrategyDescriptionExternalLinkApi service constructor.
     * @property {module:api/StrategyDescriptionExternalLinkApi}
     */
    StrategyDescriptionExternalLinkApi: StrategyDescriptionExternalLinkApi,
    /**
     * The StrategyDescriptionParticipatorApi service constructor.
     * @property {module:api/StrategyDescriptionParticipatorApi}
     */
    StrategyDescriptionParticipatorApi: StrategyDescriptionParticipatorApi,
    /**
     * The StrategyDescriptionPerformanceIndicatorApi service constructor.
     * @property {module:api/StrategyDescriptionPerformanceIndicatorApi}
     */
    StrategyDescriptionPerformanceIndicatorApi: StrategyDescriptionPerformanceIndicatorApi,
    /**
     * The StrategyDescriptionStatusApi service constructor.
     * @property {module:api/StrategyDescriptionStatusApi}
     */
    StrategyDescriptionStatusApi: StrategyDescriptionStatusApi,
    /**
     * The StrategyElementTypeApi service constructor.
     * @property {module:api/StrategyElementTypeApi}
     */
    StrategyElementTypeApi: StrategyElementTypeApi,
    /**
     * The StrategyExecutionCustomEntityApi service constructor.
     * @property {module:api/StrategyExecutionCustomEntityApi}
     */
    StrategyExecutionCustomEntityApi: StrategyExecutionCustomEntityApi,
    /**
     * The StrategyExecutionCustomEntityDataApi service constructor.
     * @property {module:api/StrategyExecutionCustomEntityDataApi}
     */
    StrategyExecutionCustomEntityDataApi: StrategyExecutionCustomEntityDataApi,
    /**
     * The StrategyExecutionCustomFieldApi service constructor.
     * @property {module:api/StrategyExecutionCustomFieldApi}
     */
    StrategyExecutionCustomFieldApi: StrategyExecutionCustomFieldApi,
    /**
     * The StrategyExecutionCustomFieldLinkApi service constructor.
     * @property {module:api/StrategyExecutionCustomFieldLinkApi}
     */
    StrategyExecutionCustomFieldLinkApi: StrategyExecutionCustomFieldLinkApi,
    /**
     * The StrategyExecutionCustomFieldOptionApi service constructor.
     * @property {module:api/StrategyExecutionCustomFieldOptionApi}
     */
    StrategyExecutionCustomFieldOptionApi: StrategyExecutionCustomFieldOptionApi,
    /**
     * The StrategyExecutionCustomFieldTypeApi service constructor.
     * @property {module:api/StrategyExecutionCustomFieldTypeApi}
     */
    StrategyExecutionCustomFieldTypeApi: StrategyExecutionCustomFieldTypeApi,
    /**
     * The StrategyExecutionSecondaryStatusUpdateTypeApi service constructor.
     * @property {module:api/StrategyExecutionSecondaryStatusUpdateTypeApi}
     */
    StrategyExecutionSecondaryStatusUpdateTypeApi: StrategyExecutionSecondaryStatusUpdateTypeApi,
    /**
     * The StrategyExecutionTypeApi service constructor.
     * @property {module:api/StrategyExecutionTypeApi}
     */
    StrategyExecutionTypeApi: StrategyExecutionTypeApi,
    /**
     * The StrategyFreeNodeApi service constructor.
     * @property {module:api/StrategyFreeNodeApi}
     */
    StrategyFreeNodeApi: StrategyFreeNodeApi,
    /**
     * The StrategyHealthReportApi service constructor.
     * @property {module:api/StrategyHealthReportApi}
     */
    StrategyHealthReportApi: StrategyHealthReportApi,
    /**
     * The StrategyNamingTypeApi service constructor.
     * @property {module:api/StrategyNamingTypeApi}
     */
    StrategyNamingTypeApi: StrategyNamingTypeApi,
    /**
     * The StrategyPageBlockApi service constructor.
     * @property {module:api/StrategyPageBlockApi}
     */
    StrategyPageBlockApi: StrategyPageBlockApi,
    /**
     * The StrategyPageBlockTypeApi service constructor.
     * @property {module:api/StrategyPageBlockTypeApi}
     */
    StrategyPageBlockTypeApi: StrategyPageBlockTypeApi,
    /**
     * The StrategyPageMemoBlockApi service constructor.
     * @property {module:api/StrategyPageMemoBlockApi}
     */
    StrategyPageMemoBlockApi: StrategyPageMemoBlockApi,
    /**
     * The StrategyProcessApi service constructor.
     * @property {module:api/StrategyProcessApi}
     */
    StrategyProcessApi: StrategyProcessApi,
    /**
     * The StrategyProcessPhaseApi service constructor.
     * @property {module:api/StrategyProcessPhaseApi}
     */
    StrategyProcessPhaseApi: StrategyProcessPhaseApi,
    /**
     * The StrategyProcessPhaseContentApi service constructor.
     * @property {module:api/StrategyProcessPhaseContentApi}
     */
    StrategyProcessPhaseContentApi: StrategyProcessPhaseContentApi,
    /**
     * The StrategyProcessSubthemeApi service constructor.
     * @property {module:api/StrategyProcessSubthemeApi}
     */
    StrategyProcessSubthemeApi: StrategyProcessSubthemeApi,
    /**
     * The StrategyProcessSubthemeLinkApi service constructor.
     * @property {module:api/StrategyProcessSubthemeLinkApi}
     */
    StrategyProcessSubthemeLinkApi: StrategyProcessSubthemeLinkApi,
    /**
     * The StrategyProcessSubthemeTypeApi service constructor.
     * @property {module:api/StrategyProcessSubthemeTypeApi}
     */
    StrategyProcessSubthemeTypeApi: StrategyProcessSubthemeTypeApi,
    /**
     * The StrategyProcessThemeApi service constructor.
     * @property {module:api/StrategyProcessThemeApi}
     */
    StrategyProcessThemeApi: StrategyProcessThemeApi,
    /**
     * The StrategyProgressCalculationMethodApi service constructor.
     * @property {module:api/StrategyProgressCalculationMethodApi}
     */
    StrategyProgressCalculationMethodApi: StrategyProgressCalculationMethodApi,
    /**
     * The StrategyProgressCalculationSourceApi service constructor.
     * @property {module:api/StrategyProgressCalculationSourceApi}
     */
    StrategyProgressCalculationSourceApi: StrategyProgressCalculationSourceApi,
    /**
     * The StrategyPublishingLevelApi service constructor.
     * @property {module:api/StrategyPublishingLevelApi}
     */
    StrategyPublishingLevelApi: StrategyPublishingLevelApi,
    /**
     * The StrategyPublishingTypeApi service constructor.
     * @property {module:api/StrategyPublishingTypeApi}
     */
    StrategyPublishingTypeApi: StrategyPublishingTypeApi,
    /**
     * The StrategySavedViewApi service constructor.
     * @property {module:api/StrategySavedViewApi}
     */
    StrategySavedViewApi: StrategySavedViewApi,
    /**
     * The StrategySelectionApi service constructor.
     * @property {module:api/StrategySelectionApi}
     */
    StrategySelectionApi: StrategySelectionApi,
    /**
     * The StrategyTaxonomyApi service constructor.
     * @property {module:api/StrategyTaxonomyApi}
     */
    StrategyTaxonomyApi: StrategyTaxonomyApi,
    /**
     * The SupplierApi service constructor.
     * @property {module:api/SupplierApi}
     */
    SupplierApi: SupplierApi,
    /**
     * The SystemLanguageApi service constructor.
     * @property {module:api/SystemLanguageApi}
     */
    SystemLanguageApi: SystemLanguageApi,
    /**
     * The SystemRegisterDataSourceApi service constructor.
     * @property {module:api/SystemRegisterDataSourceApi}
     */
    SystemRegisterDataSourceApi: SystemRegisterDataSourceApi,
    /**
     * The SystemUserRoleApi service constructor.
     * @property {module:api/SystemUserRoleApi}
     */
    SystemUserRoleApi: SystemUserRoleApi,
    /**
     * The SystemUserTypeApi service constructor.
     * @property {module:api/SystemUserTypeApi}
     */
    SystemUserTypeApi: SystemUserTypeApi,
    /**
     * The TrackingLevelApi service constructor.
     * @property {module:api/TrackingLevelApi}
     */
    TrackingLevelApi: TrackingLevelApi,
    /**
     * The TrackingLevelItemApi service constructor.
     * @property {module:api/TrackingLevelItemApi}
     */
    TrackingLevelItemApi: TrackingLevelItemApi,
    /**
     * The TrendCategoryApi service constructor.
     * @property {module:api/TrendCategoryApi}
     */
    TrendCategoryApi: TrendCategoryApi,
    /**
     * The TrendScopeApi service constructor.
     * @property {module:api/TrendScopeApi}
     */
    TrendScopeApi: TrendScopeApi,
    /**
     * The TrendSettingsApi service constructor.
     * @property {module:api/TrendSettingsApi}
     */
    TrendSettingsApi: TrendSettingsApi,
    /**
     * The TrendTopicApi service constructor.
     * @property {module:api/TrendTopicApi}
     */
    TrendTopicApi: TrendTopicApi,
    /**
     * The TrendTopicCommentApi service constructor.
     * @property {module:api/TrendTopicCommentApi}
     */
    TrendTopicCommentApi: TrendTopicCommentApi,
    /**
     * The TrendTopicTypeApi service constructor.
     * @property {module:api/TrendTopicTypeApi}
     */
    TrendTopicTypeApi: TrendTopicTypeApi,
    /**
     * The UserApi service constructor.
     * @property {module:api/UserApi}
     */
    UserApi: UserApi,
    /**
     * The UserActivityItemApi service constructor.
     * @property {module:api/UserActivityItemApi}
     */
    UserActivityItemApi: UserActivityItemApi,
    /**
     * The UserActivityReportApi service constructor.
     * @property {module:api/UserActivityReportApi}
     */
    UserActivityReportApi: UserActivityReportApi,
    /**
     * The UserCompanyAccessApi service constructor.
     * @property {module:api/UserCompanyAccessApi}
     */
    UserCompanyAccessApi: UserCompanyAccessApi,
    /**
     * The UserCompanyFunctionalityAccessApi service constructor.
     * @property {module:api/UserCompanyFunctionalityAccessApi}
     */
    UserCompanyFunctionalityAccessApi: UserCompanyFunctionalityAccessApi,
    /**
     * The UserDataVisibilityFunctionApi service constructor.
     * @property {module:api/UserDataVisibilityFunctionApi}
     */
    UserDataVisibilityFunctionApi: UserDataVisibilityFunctionApi,
    /**
     * The UserDataVisibilityLegalEntityApi service constructor.
     * @property {module:api/UserDataVisibilityLegalEntityApi}
     */
    UserDataVisibilityLegalEntityApi: UserDataVisibilityLegalEntityApi,
    /**
     * The UserDataVisibilityProductApi service constructor.
     * @property {module:api/UserDataVisibilityProductApi}
     */
    UserDataVisibilityProductApi: UserDataVisibilityProductApi,
    /**
     * The UserDataVisibilitySettingsApi service constructor.
     * @property {module:api/UserDataVisibilitySettingsApi}
     */
    UserDataVisibilitySettingsApi: UserDataVisibilitySettingsApi,
    /**
     * The UserEngagementActionApi service constructor.
     * @property {module:api/UserEngagementActionApi}
     */
    UserEngagementActionApi: UserEngagementActionApi,
    /**
     * The UserFeedbackReportApi service constructor.
     * @property {module:api/UserFeedbackReportApi}
     */
    UserFeedbackReportApi: UserFeedbackReportApi,
    /**
     * The UserFunctionalityAccessReportApi service constructor.
     * @property {module:api/UserFunctionalityAccessReportApi}
     */
    UserFunctionalityAccessReportApi: UserFunctionalityAccessReportApi,
    /**
     * The UserInterfaceTextApi service constructor.
     * @property {module:api/UserInterfaceTextApi}
     */
    UserInterfaceTextApi: UserInterfaceTextApi,
    /**
     * The UserInterfaceTranslationLanguageApi service constructor.
     * @property {module:api/UserInterfaceTranslationLanguageApi}
     */
    UserInterfaceTranslationLanguageApi: UserInterfaceTranslationLanguageApi,
    /**
     * The UserListDataReportApi service constructor.
     * @property {module:api/UserListDataReportApi}
     */
    UserListDataReportApi: UserListDataReportApi,
    /**
     * The UserLocalApi service constructor.
     * @property {module:api/UserLocalApi}
     */
    UserLocalApi: UserLocalApi,
    /**
     * The UserNotificationEventSourceApi service constructor.
     * @property {module:api/UserNotificationEventSourceApi}
     */
    UserNotificationEventSourceApi: UserNotificationEventSourceApi,
    /**
     * The UserNotificationUserSettingsApi service constructor.
     * @property {module:api/UserNotificationUserSettingsApi}
     */
    UserNotificationUserSettingsApi: UserNotificationUserSettingsApi,
    /**
     * The UserPartnerAccessApi service constructor.
     * @property {module:api/UserPartnerAccessApi}
     */
    UserPartnerAccessApi: UserPartnerAccessApi,
    /**
     * The UserRoleApi service constructor.
     * @property {module:api/UserRoleApi}
     */
    UserRoleApi: UserRoleApi,
    /**
     * The UserRoleBillingUserTypeApi service constructor.
     * @property {module:api/UserRoleBillingUserTypeApi}
     */
    UserRoleBillingUserTypeApi: UserRoleBillingUserTypeApi,
    /**
     * The UserRoleProductApi service constructor.
     * @property {module:api/UserRoleProductApi}
     */
    UserRoleProductApi: UserRoleProductApi,
    /**
     * The UserSyncExcelSettingsApi service constructor.
     * @property {module:api/UserSyncExcelSettingsApi}
     */
    UserSyncExcelSettingsApi: UserSyncExcelSettingsApi,
    /**
     * The UserTrackingLevelLinkApi service constructor.
     * @property {module:api/UserTrackingLevelLinkApi}
     */
    UserTrackingLevelLinkApi: UserTrackingLevelLinkApi,
    /**
     * The VATPeriodTypeApi service constructor.
     * @property {module:api/VATPeriodTypeApi}
     */
    VATPeriodTypeApi: VATPeriodTypeApi,
    /**
     * The WorkshopApi service constructor.
     * @property {module:api/WorkshopApi}
     */
    WorkshopApi: WorkshopApi,
    /**
     * The WorkshopBackgroundImageApi service constructor.
     * @property {module:api/WorkshopBackgroundImageApi}
     */
    WorkshopBackgroundImageApi: WorkshopBackgroundImageApi,
    /**
     * The WorkshopCanvasItemApi service constructor.
     * @property {module:api/WorkshopCanvasItemApi}
     */
    WorkshopCanvasItemApi: WorkshopCanvasItemApi,
    /**
     * The WorkshopCanvasItemTypeApi service constructor.
     * @property {module:api/WorkshopCanvasItemTypeApi}
     */
    WorkshopCanvasItemTypeApi: WorkshopCanvasItemTypeApi,
    /**
     * The WorkshopExternalContentTypeApi service constructor.
     * @property {module:api/WorkshopExternalContentTypeApi}
     */
    WorkshopExternalContentTypeApi: WorkshopExternalContentTypeApi,
    /**
     * The WorkshopItemApi service constructor.
     * @property {module:api/WorkshopItemApi}
     */
    WorkshopItemApi: WorkshopItemApi,
    /**
     * The WorkshopItemCategoryApi service constructor.
     * @property {module:api/WorkshopItemCategoryApi}
     */
    WorkshopItemCategoryApi: WorkshopItemCategoryApi,
    /**
     * The WorkshopItemCategoryConnectionApi service constructor.
     * @property {module:api/WorkshopItemCategoryConnectionApi}
     */
    WorkshopItemCategoryConnectionApi: WorkshopItemCategoryConnectionApi,
    /**
     * The WorkshopItemHistoryApi service constructor.
     * @property {module:api/WorkshopItemHistoryApi}
     */
    WorkshopItemHistoryApi: WorkshopItemHistoryApi,
    /**
     * The WorkshopItemRatingApi service constructor.
     * @property {module:api/WorkshopItemRatingApi}
     */
    WorkshopItemRatingApi: WorkshopItemRatingApi,
    /**
     * The WorkshopItemRatingHistoryApi service constructor.
     * @property {module:api/WorkshopItemRatingHistoryApi}
     */
    WorkshopItemRatingHistoryApi: WorkshopItemRatingHistoryApi,
    /**
     * The WorkshopParticipantApi service constructor.
     * @property {module:api/WorkshopParticipantApi}
     */
    WorkshopParticipantApi: WorkshopParticipantApi,
    /**
     * The WorkshopParticipantRoleApi service constructor.
     * @property {module:api/WorkshopParticipantRoleApi}
     */
    WorkshopParticipantRoleApi: WorkshopParticipantRoleApi,
    /**
     * The WorkshopPhaseApi service constructor.
     * @property {module:api/WorkshopPhaseApi}
     */
    WorkshopPhaseApi: WorkshopPhaseApi,
    /**
     * The WorkshopPhaseComparisonAxisApi service constructor.
     * @property {module:api/WorkshopPhaseComparisonAxisApi}
     */
    WorkshopPhaseComparisonAxisApi: WorkshopPhaseComparisonAxisApi,
    /**
     * The WorkshopPhaseComparisonDimensionApi service constructor.
     * @property {module:api/WorkshopPhaseComparisonDimensionApi}
     */
    WorkshopPhaseComparisonDimensionApi: WorkshopPhaseComparisonDimensionApi,
    /**
     * The WorkshopPhaseContentCreationRuleApi service constructor.
     * @property {module:api/WorkshopPhaseContentCreationRuleApi}
     */
    WorkshopPhaseContentCreationRuleApi: WorkshopPhaseContentCreationRuleApi,
    /**
     * The WorkshopPhaseContentRowApi service constructor.
     * @property {module:api/WorkshopPhaseContentRowApi}
     */
    WorkshopPhaseContentRowApi: WorkshopPhaseContentRowApi,
    /**
     * The WorkshopPhaseContentRowLayoutApi service constructor.
     * @property {module:api/WorkshopPhaseContentRowLayoutApi}
     */
    WorkshopPhaseContentRowLayoutApi: WorkshopPhaseContentRowLayoutApi,
    /**
     * The WorkshopPhaseGridBlockApi service constructor.
     * @property {module:api/WorkshopPhaseGridBlockApi}
     */
    WorkshopPhaseGridBlockApi: WorkshopPhaseGridBlockApi,
    /**
     * The WorkshopPhaseParticipantRoleApi service constructor.
     * @property {module:api/WorkshopPhaseParticipantRoleApi}
     */
    WorkshopPhaseParticipantRoleApi: WorkshopPhaseParticipantRoleApi,
    /**
     * The WorkshopPrioritizationVotingTypeApi service constructor.
     * @property {module:api/WorkshopPrioritizationVotingTypeApi}
     */
    WorkshopPrioritizationVotingTypeApi: WorkshopPrioritizationVotingTypeApi,
    /**
     * The WorkshopQuestionnaireFilterApi service constructor.
     * @property {module:api/WorkshopQuestionnaireFilterApi}
     */
    WorkshopQuestionnaireFilterApi: WorkshopQuestionnaireFilterApi,
    /**
     * The WorkshopQuestionnaireOptionApi service constructor.
     * @property {module:api/WorkshopQuestionnaireOptionApi}
     */
    WorkshopQuestionnaireOptionApi: WorkshopQuestionnaireOptionApi,
    /**
     * The WorkshopQuestionnaireQuestionApi service constructor.
     * @property {module:api/WorkshopQuestionnaireQuestionApi}
     */
    WorkshopQuestionnaireQuestionApi: WorkshopQuestionnaireQuestionApi,
    /**
     * The WorkshopQuestionnaireQuestionTypeApi service constructor.
     * @property {module:api/WorkshopQuestionnaireQuestionTypeApi}
     */
    WorkshopQuestionnaireQuestionTypeApi: WorkshopQuestionnaireQuestionTypeApi,
    /**
     * The WorkshopQuestionnaireResponseApi service constructor.
     * @property {module:api/WorkshopQuestionnaireResponseApi}
     */
    WorkshopQuestionnaireResponseApi: WorkshopQuestionnaireResponseApi,
    /**
     * The WorkshopRatingPhaseCategoryWeightApi service constructor.
     * @property {module:api/WorkshopRatingPhaseCategoryWeightApi}
     */
    WorkshopRatingPhaseCategoryWeightApi: WorkshopRatingPhaseCategoryWeightApi,
    /**
     * The WorkshopRatingPhaseSourceApi service constructor.
     * @property {module:api/WorkshopRatingPhaseSourceApi}
     */
    WorkshopRatingPhaseSourceApi: WorkshopRatingPhaseSourceApi,
    /**
     * The WorkshopRatingPhaseWeightedLevelApi service constructor.
     * @property {module:api/WorkshopRatingPhaseWeightedLevelApi}
     */
    WorkshopRatingPhaseWeightedLevelApi: WorkshopRatingPhaseWeightedLevelApi,
    /**
     * The WorkshopResultPhaseSourceApi service constructor.
     * @property {module:api/WorkshopResultPhaseSourceApi}
     */
    WorkshopResultPhaseSourceApi: WorkshopResultPhaseSourceApi,
    /**
     * The WorkshopResultPresentationTypeApi service constructor.
     * @property {module:api/WorkshopResultPresentationTypeApi}
     */
    WorkshopResultPresentationTypeApi: WorkshopResultPresentationTypeApi,
    /**
     * The WorkshopVersionHistoryChangeTypeApi service constructor.
     * @property {module:api/WorkshopVersionHistoryChangeTypeApi}
     */
    WorkshopVersionHistoryChangeTypeApi: WorkshopVersionHistoryChangeTypeApi,
    /**
     * The WorkshopVideoCallApi service constructor.
     * @property {module:api/WorkshopVideoCallApi}
     */
    WorkshopVideoCallApi: WorkshopVideoCallApi,
    /**
     * The WorkshopWidgetApi service constructor.
     * @property {module:api/WorkshopWidgetApi}
     */
    WorkshopWidgetApi: WorkshopWidgetApi,
    /**
     * The WorkshopWidgetIdeaGenerationThemeApi service constructor.
     * @property {module:api/WorkshopWidgetIdeaGenerationThemeApi}
     */
    WorkshopWidgetIdeaGenerationThemeApi: WorkshopWidgetIdeaGenerationThemeApi,
    /**
     * The WorkshopWidgetParticipantStatusApi service constructor.
     * @property {module:api/WorkshopWidgetParticipantStatusApi}
     */
    WorkshopWidgetParticipantStatusApi: WorkshopWidgetParticipantStatusApi,
    /**
     * The WorkshopWidgetStatusApi service constructor.
     * @property {module:api/WorkshopWidgetStatusApi}
     */
    WorkshopWidgetStatusApi: WorkshopWidgetStatusApi,
    /**
     * The WorkshopWidgetTypeApi service constructor.
     * @property {module:api/WorkshopWidgetTypeApi}
     */
    WorkshopWidgetTypeApi: WorkshopWidgetTypeApi,
    /**
     * The WorkspaceMindmapApi service constructor.
     * @property {module:api/WorkspaceMindmapApi}
     */
    WorkspaceMindmapApi: WorkspaceMindmapApi,
    /**
     * The WorkspaceMindmapNodeApi service constructor.
     * @property {module:api/WorkspaceMindmapNodeApi}
     */
    WorkspaceMindmapNodeApi: WorkspaceMindmapNodeApi,
    /**
     * The WorkspaceMindmapNodeTypeApi service constructor.
     * @property {module:api/WorkspaceMindmapNodeTypeApi}
     */
    WorkspaceMindmapNodeTypeApi: WorkspaceMindmapNodeTypeApi
  };

  return exports;
}));
